import {jsx as $hgUW1$jsx, jsxs as $hgUW1$jsxs, Fragment as $hgUW1$Fragment1} from "@emotion/react/jsx-runtime";
import {forwardRef as $hgUW1$forwardRef, createContext as $hgUW1$createContext, useContext as $hgUW1$useContext, useState as $hgUW1$useState, useRef as $hgUW1$useRef, useReducer as $hgUW1$useReducer, useCallback as $hgUW1$useCallback, useEffect as $hgUW1$useEffect, useMemo as $hgUW1$useMemo, Fragment as $hgUW1$Fragment, createElement as $hgUW1$createElement} from "react";
import {ThemeProvider as $hgUW1$ThemeProvider, Global as $hgUW1$Global, css as $hgUW1$css, useTheme as $hgUW1$useTheme} from "@emotion/react";
import {ThemeTypes as $hgUW1$ThemeTypes, extendTheme as $hgUW1$extendTheme, createTransition as $hgUW1$createTransition, useWindowSize as $hgUW1$useWindowSize, useDirection as $hgUW1$useDirection, createCustomLetterSpacing as $hgUW1$createCustomLetterSpacing, useCombinedRef as $hgUW1$useCombinedRef, Sizes as $hgUW1$Sizes, Icons as $hgUW1$Icons, Alignments as $hgUW1$Alignments, aria as $hgUW1$aria, MediaQueries as $hgUW1$MediaQueries, createCustomSpacing as $hgUW1$createCustomSpacing, Spacings as $hgUW1$Spacings, IconButton as $hgUW1$IconButton, Heading as $hgUW1$Heading, preventCancelableDefault as $hgUW1$preventCancelableDefault, Spacer as $hgUW1$Spacer, InvertedThemeProvider as $hgUW1$InvertedThemeProvider, SpinnerSizes as $hgUW1$SpinnerSizes, Orientations as $hgUW1$Orientations, Icon as $hgUW1$Icon, Text as $hgUW1$Text, Spinner as $hgUW1$Spinner, blend as $hgUW1$blend, Colors as $hgUW1$Colors, Opacities as $hgUW1$Opacities, createCSSTransition as $hgUW1$createCSSTransition, MotionEasings as $hgUW1$MotionEasings, MotionDurations as $hgUW1$MotionDurations, Link as $hgUW1$Link, Themes as $hgUW1$Themes, withOpacity as $hgUW1$withOpacity, CheckboxField as $hgUW1$CheckboxField, Caption as $hgUW1$Caption, SecondaryButton as $hgUW1$SecondaryButton, TextButton as $hgUW1$TextButton, TextField as $hgUW1$TextField, useMediaQuery as $hgUW1$useMediaQuery, DeviceTypes as $hgUW1$DeviceTypes, Transitions as $hgUW1$Transitions, Portal as $hgUW1$Portal, LayoutIndexes as $hgUW1$LayoutIndexes, DarkThemeProvider as $hgUW1$DarkThemeProvider, useTheme as $hgUW1$useTheme1, PrimaryButton as $hgUW1$PrimaryButton, shouldNotForwardProps as $hgUW1$shouldNotForwardProps1} from "@polestar/component-warehouse-react";
import {useThemes as $hgUW1$useThemes} from "@polestar/component-warehouse-react/contexts/themes";
import * as $hgUW1$process from "process";
import $hgUW1$emotionstyled from "@emotion/styled";
import {useMotionValue as $hgUW1$useMotionValue, animate as $hgUW1$animate, useTransform as $hgUW1$useTransform, m as $hgUW1$m, AnimatePresence as $hgUW1$AnimatePresence} from "framer-motion";
import {useInteractionMode as $hgUW1$useInteractionMode} from "@polestar/component-warehouse-react/contexts/interactionMode";
import {useReducedMotion as $hgUW1$useReducedMotion} from "@polestar/component-warehouse-react/hooks/useReducedMotion";
import {shouldNotForwardProps as $hgUW1$shouldNotForwardProps} from "@polestar/component-warehouse-react/helpers/shouldForwardProps";
import {useFocusTrap as $hgUW1$useFocusTrap, useFocusInitial as $hgUW1$useFocusInitial, useFocusRestore as $hgUW1$useFocusRestore} from "@polestar/component-warehouse-react/hooks/focus";
import $hgUW1$polestarcomponentwarehousereacthooksuseCombinedRef from "@polestar/component-warehouse-react/hooks/useCombinedRef";
import {responsiveStyles as $hgUW1$responsiveStyles} from "@polestar/component-warehouse-react/helpers/responsiveStyle";
import {useModal as $hgUW1$useModal} from "@polestar/component-warehouse-react/contexts/modal";
import {useHeightCallback as $hgUW1$useHeightCallback, useWidthCallback as $hgUW1$useWidthCallback} from "@polestar/component-warehouse-react/hooks/useDimensions";
import $hgUW1$polestarcomponentwarehousereactcomponentsbackdropBackdrop from "@polestar/component-warehouse-react/components/backdrop/Backdrop";
import $hgUW1$polestarcomponentwarehousereacttokenscolorsColors, {blend as $hgUW1$blend1, withOpacity as $hgUW1$withOpacity1} from "@polestar/component-warehouse-react/tokens/colors/Colors";
import $hgUW1$polestarcomponentwarehousereacttokensopacitiesOpacities from "@polestar/component-warehouse-react/tokens/opacities/Opacities";
import {format as $hgUW1$format, isWithinInterval as $hgUW1$isWithinInterval} from "date-fns";
import {zonedTimeToUtc as $hgUW1$zonedTimeToUtc} from "date-fns-tz";
import {isSSR as $hgUW1$isSSR} from "@polestar/component-warehouse-react/helpers/supports";





/* eslint-disable no-case-declarations */ let $82f9b1b8e367eb3b$export$706f72478c189308;
(function(SupportDialogStepNames) {
    SupportDialogStepNames["LOAD_DATA"] = "loadData";
    SupportDialogStepNames["OPEN_DIRECTLY"] = "openDirectly";
    SupportDialogStepNames["OPEN"] = "open";
    SupportDialogStepNames["FORM"] = "form";
})($82f9b1b8e367eb3b$export$706f72478c189308 || ($82f9b1b8e367eb3b$export$706f72478c189308 = {}));
let $82f9b1b8e367eb3b$export$dc3c40f9a324927c;
(function(SupportDialogReducerActions) {
    SupportDialogReducerActions["SDK_MESSAGING_SERVICE_PLUGIN_READY"] = "SDK_MESSAGING_SERVICE_PLUGIN_READY";
    SupportDialogReducerActions["SDK_MESSAGING_SERVICE_PLUGIN_CONNECTION_STARTED"] = "SDK_MESSAGING_SERVICE_PLUGIN_CONNECTION_STARTED";
    SupportDialogReducerActions["SDK_MESSAGING_SERVICE_PLUGIN_CONVERSATION_RESTORED"] = "SDK_MESSAGING_SERVICE_PLUGIN_CONVERSATION_RESTORED";
    SupportDialogReducerActions["SDK_MESSENGER_PLUGIN_READY"] = "SDK_MESSENGER_PLUGIN_READY";
    SupportDialogReducerActions["SDK_DATABASE_PLUGIN_READY"] = "SDK_DATABASE_PLUGIN_READY";
    SupportDialogReducerActions["SDK_READY"] = "SDK_READY";
    SupportDialogReducerActions["SDK_LOADED"] = "SDK_LOADED";
    SupportDialogReducerActions["DIRECT_EXECUTION"] = "DIRECT_EXECUTION";
    SupportDialogReducerActions["DATABASE_SET"] = "DATABASE_SET";
    SupportDialogReducerActions["DATABASE_UPDATED"] = "DATABASE_UPDATED";
    SupportDialogReducerActions["MESSAGES_AMOUNT"] = "MESSAGES_AMOUNT";
    SupportDialogReducerActions["MESSAGES_CLEAR"] = "MESSAGES_CLEAR";
    SupportDialogReducerActions["ENVIRONMENT_ID"] = "SET_ENVIRONMENT_ID";
    SupportDialogReducerActions["DEPLOYMENT_ID"] = "SET_DEPLOYMENT_ID";
    SupportDialogReducerActions["LOGGING_ENABLED"] = "LOGGING_ENABLED";
    SupportDialogReducerActions["MESSENGER_OPENED"] = "MESSENGER_OPENED";
    SupportDialogReducerActions["NEXT_STEP"] = "NEXT_STEP";
    SupportDialogReducerActions["LOADING_DATA"] = "LOADING_DATA";
    SupportDialogReducerActions["SHOW_FORM"] = "SHOW_FORM";
    SupportDialogReducerActions["PERSONAL_INFORMATION_STORED"] = "PERSONAL_INFORMATION_STORED";
})($82f9b1b8e367eb3b$export$dc3c40f9a324927c || ($82f9b1b8e367eb3b$export$dc3c40f9a324927c = {}));
const $82f9b1b8e367eb3b$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.SDK_MESSENGER_PLUGIN_READY:
            return {
                ...state,
                sdkMessengerPluginReady: action.value,
                sdkReady: state.sdkDatabasePluginReady && action.value
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.SDK_DATABASE_PLUGIN_READY:
            return {
                ...state,
                sdkDatabasePluginReady: action.value,
                sdkReady: action.value && state.sdkMessagingPluginReady
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.SDK_READY:
            return {
                ...state,
                sdkReady: action.value
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.SDK_LOADED:
            return {
                ...state,
                sdkLoaded: action.value
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.SDK_MESSAGING_SERVICE_PLUGIN_READY:
            return {
                ...state,
                sdkMessagingPluginReady: action.value
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.SDK_MESSAGING_SERVICE_PLUGIN_CONNECTION_STARTED:
            return {
                ...state,
                sdkMessagingPluginConnectionStarted: action.value
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.SDK_MESSAGING_SERVICE_PLUGIN_CONVERSATION_RESTORED:
            return {
                ...state,
                // some messages are sent after the user updated so ensure the new-messages indicator is shown
                messages: state.lastMessageId !== action.value ? 1 : state.messages,
                sdkMessagingPluginConversationRestored: true,
                lastMessageId: action.value ? action.value || "" : state.lastMessageId
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.DIRECT_EXECUTION:
            return {
                ...state,
                directExecution: action.value
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.DATABASE_SET:
            return {
                ...state,
                databaseSet: action.value,
                databaseUpdated: false
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.DATABASE_UPDATED:
            return {
                ...state,
                databaseUpdated: action.value,
                databaseSet: false,
                showForm: false
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.MESSAGES_AMOUNT:
            return {
                ...state,
                messages: (state.messages || 0) + action.value.messages,
                lastMessageId: action.value.lastId
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.MESSAGES_CLEAR:
            return {
                ...state,
                messages: 0,
                isPersonalInformationStored: false,
                showForm: false
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.ENVIRONMENT_ID:
            return {
                ...state,
                environment: action.value
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.DEPLOYMENT_ID:
            return {
                ...state,
                deploymentId: action.value
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.LOGGING_ENABLED:
            return {
                ...state,
                loggingEnabled: action.value
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.MESSENGER_OPENED:
            return {
                ...state,
                messages: 0,
                messengerOpened: action.value,
                // hide form when the messenger / chat window is opened
                showForm: action.value ? false : state.showForm,
                // reset when opened, otherwise keep the current state
                directExecution: false
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.NEXT_STEP:
            const steps = action.value;
            return {
                ...state,
                nextStep: steps,
                directExecution: steps && steps.length > 0 ? steps?.includes($82f9b1b8e367eb3b$export$706f72478c189308.OPEN_DIRECTLY) || false : state.directExecution
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.LOADING_DATA:
            return {
                ...state,
                isLoadingData: action.value
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.SHOW_FORM:
            return {
                ...state,
                showForm: action.value,
                // ensure that no form keeps visible behind the chat window
                nextStep: []
            };
        case $82f9b1b8e367eb3b$export$dc3c40f9a324927c.PERSONAL_INFORMATION_STORED:
            // reset showForm when information is stored
            const showForm = action.value ? false : state.showForm;
            return {
                ...state,
                isPersonalInformationStored: action.value,
                showForm: showForm
            };
    }
    throw Error("SupportDialog: unknown action for the Genesys SDK integration.");
};


const $7bb9128d6aa2a32d$export$706d24ac8338084e = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
...props)=>{
    if (typeof window !== "undefined") // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    {
        if (window.polestarChatLogging) console.log(...props);
    }
};



const $cfc57243d48ecb76$export$feca7512a2d80ba4 = (action, label = "missing label")=>{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "support_dialog",
        eventInfo: {
            action: action,
            label: label
        }
    });
};
const $cfc57243d48ecb76$export$610503f776ddf63f = (action, label)=>{
    $cfc57243d48ecb76$export$feca7512a2d80ba4(action, label);
};
const $cfc57243d48ecb76$export$aad702b77ef29b16 = (label)=>{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "chat_button",
        eventInfo: {
            action: "chat_button_click",
            label: label || "missing label"
        }
    });
};
const $cfc57243d48ecb76$export$1af36040bd10a2aa = ()=>{
    $cfc57243d48ecb76$export$feca7512a2d80ba4("open_support_dialog", window?.location?.pathname);
};
const $cfc57243d48ecb76$export$46ee1d90b8d9465f = (label)=>{
    $cfc57243d48ecb76$export$feca7512a2d80ba4("cookie_consent_button_click", label);
};


const $9cbbd2c6a2e58c1c$export$408f97352dd89169 = ({ dispatch: dispatch , directChatTriggered: directChatTriggered , environment: environment , deploymentId: deploymentId , loggingEnabled: loggingEnabled = false , entriesSaved: entriesSaved , focusIconButtonFunction: focusIconButtonFunction , clearConversation: clearConversation  })=>{
    dispatch({
        type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).LOADING_DATA,
        value: true
    });
    // load chat SDK
    (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("loadGenesysChat", {
        environment: environment,
        deploymentId: deploymentId
    });
    const init = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
    g, e, n, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    es)=>{
        g["_genesysJs"] = e;
        g[e] = g[e] || function() {
            (g[e].q = g[e].q || []).push(// eslint-disable-next-line prefer-rest-params
            arguments);
        };
        g[e].t = 1 * Date.now();
        g[e].c = es;
        const ys = document.createElement("script");
        ys.async = true;
        ys.src = n;
        ys.charset = "utf-8";
        document.head.appendChild(ys);
    };
    init(window, "Genesys", "https://apps.mypurecloud.de/genesys-bootstrap/genesys.min.js", {
        environment: environment,
        deploymentId: deploymentId,
        // only needed for debugging purposes
        debug: loggingEnabled
    });
    let sdk;
    /**
   * Wait until the Genesys SDK is loaded
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const checkLoadStatus = ()=>{
        (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("checkLoadStatus:", {
            genesysLoaded: // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window?.Genesys === undefined,
            genesysReferenceNull: sdk === null
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (window?.Genesys && !sdk) {
            if (loadStatusRef) clearInterval(loadStatusRef);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            sdk = window.Genesys;
            (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("checkLoadStatus: listen to Genesys events");
            // listen to events
            sdk?.("subscribe", "Messenger.opened", ()=>{
                (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("got Messenger.opened event");
                dispatch({
                    type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).MESSENGER_OPENED,
                    value: true
                });
            });
            // sdk?.("subscribe", "MessagingService.oldMessages", ({ data }: any) => {
            //   logFunction("messages:old-messages:fetched:", data);
            // });
            // sdk?.("subscribe", "MessagingService.historyComplete", () => {
            //   logFunction("messages:history:complete");
            // });
            sdk?.("subscribe", "MessagingService.ready", ()=>{
                (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("got MessagingService.ready event");
                dispatch({
                    type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).SDK_MESSAGING_SERVICE_PLUGIN_READY,
                    value: true
                });
            });
            sdk?.("subscribe", "MessagingService.started", ()=>{
                // Published when the new WebSocket connection is established.
                (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("got MessagingService.started event");
                dispatch({
                    type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).SDK_MESSAGING_SERVICE_PLUGIN_CONNECTION_STARTED,
                    value: true
                });
            });
            sdk?.("subscribe", "MessagingService.restored", ({ data: data  })=>{
                // Published when conversation session has been restored after page navigation or page refresh. It may not include all the messages within the session, but a limited set of recent messages. More older messages are available in the oldMessages event.
                (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("got MessagingService.restored event", data);
                const lastMessageId = data.messages[data.messages.length - 1].id || undefined;
                if (lastMessageId) dispatch({
                    type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).SDK_MESSAGING_SERVICE_PLUGIN_CONVERSATION_RESTORED,
                    value: lastMessageId
                });
            });
            sdk?.("subscribe", "MessagingService.conversationCleared", ()=>{
                (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("got MessagingService.conversationCleared event");
                (0, $cfc57243d48ecb76$export$feca7512a2d80ba4)("support_chat_click", "confirm_delete_chat");
                clearConversation();
            });
            sdk?.("subscribe", "MessagingService.error", (// eslint-disable-next-line @typescript-eslint/no-explicit-any
            { data: data  })=>{
                console.warn("SupportDialog: something failed with receiving messages due to", data);
            });
            sdk?.("subscribe", "MessagingService.messagesReceived", (value)=>{
                (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("got MessagingService.messagesReceived event", value);
                const messages = value.data.messages?.map((message)=>{
                    if (message.originatingEntity === "Human") return message.text;
                    return undefined;
                }).filter((value)=>value !== undefined);
                // only show human messages
                if (messages?.length > 0) try {
                    const newestMessage = value?.data?.messages?.[0] || {
                        id: "-1",
                        messages: []
                    };
                    dispatch({
                        type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).MESSAGES_AMOUNT,
                        value: {
                            messages: messages.length,
                            lastId: newestMessage.id
                        }
                    });
                } catch (e) {
                    console.error("[SupportDialog] Could not parse incoming message due to", e);
                }
            });
            sdk?.("subscribe", "MessagingService.typingReceived", ()=>{
                // document.title = "Agent is typing...";
                // TODO: what to do? because it is inside an iframe
                (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("Agent is typing");
            });
            sdk?.("subscribe", "MessagingService.typingTimeout", ()=>{
                // document.title = WEBSITE_DEFAULT_TITLE;
                // TODO: what to do? because it is inside an iframe
                (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("Agent is typing, but took too long #timeout");
            });
            sdk?.("subscribe", "Messenger.closed", ()=>{
                (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("got Messenger.closed event");
                (0, $cfc57243d48ecb76$export$feca7512a2d80ba4)("support_chat_click", "minimize_chat");
                dispatch({
                    type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).MESSENGER_OPENED,
                    value: false
                });
                dispatch({
                    type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).LOADING_DATA,
                    value: false
                });
                // set focus to icon button back again
                focusIconButtonFunction.current?.();
                // Hide the launcher button of Genesys
                sdk?.("command", "Launcher.hide");
            });
            sdk?.("subscribe", "Database.updated", ()=>{
                (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("got Database.updated event");
                dispatch({
                    type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).DATABASE_UPDATED,
                    value: true
                });
                (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("Content is saved in the database");
                entriesSaved?.();
            });
            sdk?.("subscribe", "Database.ready", ()=>{
                (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("got Database.ready event");
                dispatch({
                    type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).SDK_DATABASE_PLUGIN_READY,
                    value: true
                });
            });
            sdk?.("subscribe", "Messenger.ready", ()=>{
                (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("got Messenger.ready event", {
                    directChatTriggered: directChatTriggered
                });
                dispatch({
                    type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).SDK_MESSENGER_PLUGIN_READY,
                    value: true
                });
            });
        }
    };
    // wait until available in the DOM
    const loadStatusRef = setInterval(checkLoadStatus, 30);
};



const $fa80a63b2c4a0c94$export$a5cfd6b9de5c382f = ()=>{
    (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("startChat to open up the Messenger window");
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (window?.Genesys === undefined) console.error("SupportDialog: cannot find Genesys SDK");
    else // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.Genesys?.("command", "Messenger.open", {}, ()=>{
    // opened
    }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        console.warn("SupportDialog: failed to open the Genesys chat due to", e);
    });
};





var $4d7d019151bf18dc$import_meta = Object.assign(Object.create(null), {
    url: "file:///src/helpers/fetchFromDato.ts"
});

async function $4d7d019151bf18dc$export$e393c23e3e79fe52(query, environment, variables) {
    const response = await fetch(environment === "production" ? "https://cms-api.polestar.com" : "https://cms-api.polestar.com/preview/", {
        method: "POST",
        headers: {
            Authorization: `Bearer ${typeof $hgUW1$process !== "undefined" ? "5c0443e4f7f86f96e4ff0c9a3898eb" : $4d7d019151bf18dc$import_meta.env.VITE_DATO_TOKEN}`,
            "content-type": "application/json",
            "X-Exclude-Invalid": "true",
            ...environment === "development" && {
                "X-Include-Drafts": "true"
            }
        },
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    });
    if (!response.ok) throw new Error("Failed to fetch API");
    const { data: data , errors: errors  } = await response.json();
    if (errors) {
        console.error(errors);
        throw new Error("Failed to fetch API");
    }
    return data;
}


// @ts-nocheck
const $0f023ed6d091e715$export$59ec2a1b90d3a300 = `
    query sharedChatConfiguration($locale: SiteLocale!) {
  sharedChatConfiguration {
    chatConfigurationGeneral(locale: $locale, fallbackLocales: [$locale, en]) {
      baseCoreUrl
      baseLiveAgentContentUrl
      baseLiveAgentUrl
      deploymentId
      environment
      orgId
    }
    chatConfigurationMarket(locale: $locale) {
      buttonId
      communityEndpointUrl
      defaultMinimizedText
      disabledMinimizedText
      environment
      eswConfigDevName
      eswLiveAgentDevName
      language
      loadingText
      locale
      genesysConfiguration {
        environment
        deploymentId
      }
    }
  }
}
    `;
function $0f023ed6d091e715$export$68dbe58f97d98fc5(requester) {
    return {
        sharedChatConfiguration (variables, options) {
            return requester($0f023ed6d091e715$export$59ec2a1b90d3a300, variables, options);
        }
    };
}


const $07f6ba590aeed1e6$export$85b9fcd90b287b91 = (data, stage)=>{
    const chatConfigGeneral = data.sharedChatConfiguration?.chatConfigurationGeneral?.find((config)=>config.environment === stage);
    const productionConfig = data.sharedChatConfiguration?.chatConfigurationMarket?.find((config)=>config.environment === "production");
    const developmentConfig = data.sharedChatConfiguration?.chatConfigurationMarket?.find((config)=>config.environment === "development");
    const chatConfigMarket = stage === "production" ? productionConfig : developmentConfig || productionConfig;
    if (chatConfigMarket) return {
        ...chatConfigMarket,
        ...chatConfigGeneral
    };
    return undefined;
};
const $07f6ba590aeed1e6$var$getChatConfiguration = async (locale, environment)=>{
    const response = await (0, $4d7d019151bf18dc$export$e393c23e3e79fe52)((0, $0f023ed6d091e715$export$59ec2a1b90d3a300), environment, {
        locale: locale
    });
    return $07f6ba590aeed1e6$export$85b9fcd90b287b91(response, environment);
};
var $07f6ba590aeed1e6$export$2e2bcd8739ae039 = $07f6ba590aeed1e6$var$getChatConfiguration;



var $ce78962a2070b423$export$2e2bcd8739ae039 = (0, $07f6ba590aeed1e6$export$2e2bcd8739ae039);






































const $5f0dbb7c18f85f01$var$EmptyIcon = /*#__PURE__*/ (0, $hgUW1$forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars,@typescript-eslint/ban-ts-comment
(props, ref)=>/*#__PURE__*/ (0, $hgUW1$jsx)("svg", {}));
$5f0dbb7c18f85f01$var$EmptyIcon.displayName = "EmptyIcon";
const $5f0dbb7c18f85f01$var$SupportIconButton = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ loading: loading , ariaLabelOpen: ariaLabelOpen , open: open , visible: visible = true , offset: offset , ...props }, ref)=>{
    const empty = {
        glyph: $5f0dbb7c18f85f01$var$EmptyIcon
    };
    const [iconLoading, setIconLoading] = (0, $hgUW1$useState)(false);
    const { messages: genesysMessages , isChatActive: isChatActive  } = (0, $1972cb1a4960efb2$export$9804cccfc8dc0bb9)();
    (0, $hgUW1$useEffect)(()=>{
        setTimeout(()=>{
            setIconLoading(loading || false);
        }, 500);
    }, [
        loading
    ]);
    // ensure when Genesys chat is open that the IconButton is not focusable
    const tabIndex = isChatActive ? -1 : visible ? undefined : -1;
    return /*#__PURE__*/ (0, $hgUW1$jsx)($5f0dbb7c18f85f01$var$SupportButtonContainer, {
        offset: offset,
        ...props,
        ref: ref,
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)($5f0dbb7c18f85f01$var$IconWrapper, {
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)($5f0dbb7c18f85f01$var$StyledIconButton, {
                    id: "support-dialog-button",
                    icon: iconLoading ? empty : (0, $hgUW1$Icons).support,
                    size: (0, $hgUW1$Sizes).large,
                    title: ariaLabelOpen,
                    ...(0, $hgUW1$aria)({
                        haspopup: true,
                        expanded: open,
                        label: ariaLabelOpen
                    }),
                    visible: visible,
                    tabIndex: tabIndex,
                    disabled: !visible,
                    genesysMessages: genesysMessages,
                    "data-loading": iconLoading,
                    "data-base-loading": loading
                }),
                iconLoading && /*#__PURE__*/ (0, $hgUW1$jsx)($5f0dbb7c18f85f01$var$SpinnerWrapper, {
                    children: /*#__PURE__*/ (0, $hgUW1$jsx)($5f0dbb7c18f85f01$var$StyledSpinner, {
                        size: (0, $hgUW1$SpinnerSizes).small
                    })
                }),
                !iconLoading && genesysMessages > 0 && /*#__PURE__*/ (0, $hgUW1$jsx)($5f0dbb7c18f85f01$var$Messages, {
                    children: genesysMessages
                })
            ]
        })
    });
});
$5f0dbb7c18f85f01$var$SupportIconButton.displayName = "SupportIconButton";
var $5f0dbb7c18f85f01$export$2e2bcd8739ae039 = $5f0dbb7c18f85f01$var$SupportIconButton;
const $5f0dbb7c18f85f01$var$IconWrapper = (0, $hgUW1$emotionstyled).div`
  position: relative;
`;
const $5f0dbb7c18f85f01$var$SpinnerWrapper = (0, $hgUW1$emotionstyled).div`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  inset-block-end: 0;
`;
const $5f0dbb7c18f85f01$var$StyledSpinner = (0, $hgUW1$emotionstyled)((0, $hgUW1$Spinner))`
  svg circle {
    stroke: ${(0, $hgUW1$Colors).white};
  }
`;
const $5f0dbb7c18f85f01$var$SupportButtonContainer = (0, $hgUW1$emotionstyled).div(({ offset: offset  })=>(0, $hgUW1$css)((0, $hgUW1$css)`
      display: flex;
      justify-content: flex-end;
      margin-inline-end: ${(0, $hgUW1$Spacings).small};
      margin-block-end: ${(0, $hgUW1$Spacings).small};

      ${(0, $hgUW1$MediaQueries).tablet} {
        margin-inline-end: ${(0, $hgUW1$createCustomSpacing)(1.25)};
        margin-block-end: ${(0, $hgUW1$createCustomSpacing)(1.25)};
      }

      ${(0, $hgUW1$MediaQueries).desktop} {
        margin-inline-end: ${(0, $hgUW1$Spacings).large};
        margin-block-end: ${(0, $hgUW1$Spacings).large};
      }
    `, offset && (typeof offset === "string" ? (0, $hgUW1$css)`
            margin-block-end: ${offset};

            ${(0, $hgUW1$MediaQueries).tablet} {
              margin-block-end: ${offset};
            }

            ${(0, $hgUW1$MediaQueries).desktop} {
              margin-block-end: ${offset};
            }
          ` : (0, $hgUW1$responsiveStyles)({
        marginBlockEnd: offset
    }))));
const $5f0dbb7c18f85f01$var$StyledIconButton = (0, $hgUW1$emotionstyled)((0, $hgUW1$IconButton), (0, $hgUW1$shouldNotForwardProps)(false, "isAltIcon", "genesysMessages"))(({ theme: theme , visible: visible , genesysMessages: genesysMessages = 0  })=>(0, $hgUW1$css)((0, $hgUW1$css)`
      position: relative;
      width: 48px;
      height: 48px;
      background-color: ${theme.supportDialog.button.states.enabled.backgroundColor};
      color: ${theme.supportDialog.button.states.enabled.iconColor};
      border-radius: 50%;

      &:hover {
        background-color: ${theme.supportDialog.button.states.hover.backgroundColor};
        color: ${theme.supportDialog.button.states.hover.iconColor};
      }

      &:active {
        background-color: ${theme.supportDialog.button.states.active.backgroundColor};
        color: ${theme.supportDialog.button.states.active.iconColor};
      }
    `, genesysMessages > 0 && (0, $hgUW1$css)`
        &:after {
          display: block;
          position: absolute;
          content: "";
          inset-block-start: calc(50% - ${(0, $hgUW1$createCustomSpacing)(9 / 16)});
          background-color: ${theme.supportDialog.button.states.enabled.backgroundColor};
          width: ${(0, $hgUW1$Spacings).small};
          height: ${(0, $hgUW1$Spacings).medium};
          transition: ${(0, $hgUW1$createCSSTransition)("background-color", (0, $hgUW1$MotionEasings).default, (0, $hgUW1$MotionDurations).fast)};
          z-index: 2;
        }

        &:hover {
          &:after {
            background-color: ${theme.supportDialog.button.states.hover.backgroundColor};
          }
        }
      `, !visible && (0, $hgUW1$css)`
        opacity: 0;
        pointer-events: none;
        visibility: hidden;
      `));
const $5f0dbb7c18f85f01$var$Messages = (0, $hgUW1$emotionstyled).span(({ theme: theme  })=>(0, $hgUW1$css)`
    position: absolute;
    pointer-events: none;
    inset-block-start: ${(0, $hgUW1$createCustomSpacing)(0.875)};
    inset-inline-start: 50%;
    translate: -50%;
    color: ${(0, $hgUW1$Colors).white};
    font-size: ${(0, $hgUW1$createCustomSpacing)(0.75)};
    z-index: 3;

    ${$5f0dbb7c18f85f01$export$5b35437f9ac62431}
    &:before {
      background: ${theme.supportDialog.dialog.button.status.online.color};
      inset-inline-start: ${(0, $hgUW1$createCustomSpacing)(0.5)};
      inset-block-start: -${(0, $hgUW1$createCustomSpacing)(6 / 16)};
    }
  `);
const $5f0dbb7c18f85f01$export$5b35437f9ac62431 = (0, $hgUW1$css)`
  &:before {
    content: "";
    inset-block-start: -${(0, $hgUW1$createCustomSpacing)(2 / 16)};
    inset-inline-end: -${(0, $hgUW1$createCustomSpacing)(2 / 16)};
    position: absolute;
    border-radius: ${(0, $hgUW1$createCustomSpacing)(6 / 16)};
    border: ${(0, $hgUW1$createCustomSpacing)(2 / 16)} solid ${(0, $hgUW1$Colors).ironGrey};
    width: ${(0, $hgUW1$Spacings).small};
    height: ${(0, $hgUW1$Spacings).small};
    z-index: 2;
    transition: ${(0, $hgUW1$createCSSTransition)("background-color", (0, $hgUW1$MotionEasings).default, (0, $hgUW1$MotionDurations).fast)};
  }
`;




const $9befe8313eed890c$var$functionalCookieIdentifier = ",3";
const $9befe8313eed890c$export$4899ceb0277de925 = ()=>{
    if (typeof window === "undefined") return false;
    // Should not happen as OneTrust should be first to load, but assume no consent when OneTrust hasn't loaded
    // Documentation: https://polestarjira.atlassian.net/wiki/spaces/Privacy/pages/2882437604/Devteams+Using+Cookies+DOM+storage+tracking+in+your+project+OneTrust+APIs
    if (!window?.OnetrustActiveGroups) return false;
    /**
   * Get more information about the groups with OneTrust?.GetDomainData?.()
   */ return window.OnetrustActiveGroups.includes($9befe8313eed890c$var$functionalCookieIdentifier);
};
const $9befe8313eed890c$var$useHasConsent = ()=>{
    const [hasConsent, setHasConsent] = (0, $hgUW1$useState)($9befe8313eed890c$export$4899ceb0277de925);
    (0, $hgUW1$useEffect)(()=>{
        const update = ()=>{
            setHasConsent($9befe8313eed890c$export$4899ceb0277de925);
        };
        // Try to load chat again on a consent change
        window.addEventListener("consent.onetrust", update);
        return ()=>{
            window.removeEventListener("consent.onetrust", update);
        };
    }, [
        hasConsent
    ]);
    return hasConsent;
};
var $9befe8313eed890c$export$2e2bcd8739ae039 = $9befe8313eed890c$var$useHasConsent;


let $f2754c44a13f16ee$export$c87fd205be4f689b;
(function(ChatTypes) {
    ChatTypes["genesys"] = "genesys";
    ChatTypes["salesforce"] = "salesforce";
})($f2754c44a13f16ee$export$c87fd205be4f689b || ($f2754c44a13f16ee$export$c87fd205be4f689b = {}));


const $a882efb81830fa38$export$b479dcc3bfb47330 = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ data: data , onClick: onClick , ...props }, ref)=>{
    const label = data?.label;
    const href = data?.href;
    // ensure that custom overrides are past onto the inverted theme below
    const theme = (0, $hgUW1$useTheme)();
    const handlelinkClick = (label)=>{
        (0, $cfc57243d48ecb76$export$610503f776ddf63f)("link_menu_item_click", label);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$InvertedThemeProvider), {
        overrides: {
            button: {
                primary: theme.contextMenu.button
            }
        },
        children: /*#__PURE__*/ (0, $hgUW1$jsx)($a882efb81830fa38$var$StyledLink, {
            href: href,
            onClick: (event)=>{
                handlelinkClick(label);
                onClick?.(event);
            },
            ...props,
            ref: ref,
            children: label
        })
    });
});
$a882efb81830fa38$export$b479dcc3bfb47330.displayName = "SupportDialogMenuLink";
/**
 * The more complex button that shows a Salesforce link or a Genesys chat button or a sub-menu button
 */ const $a882efb81830fa38$var$SupportDialogMenuItem = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ onClick: onClick , onSelect: onSelect , index: index = 0 , hasSubMenu: /**
       * To show the chevronRight icon when the button has a submenu.
       */ hasSubMenu , isPageBadge: isPageBadge = false , color: color , isLast: isLast , ariaLabels: ariaLabels , data: data , ...props }, ref)=>{
    const { messages: genesysMessages , setGenesysChatTrigger: setGenesysChatTrigger  } = (0, $1972cb1a4960efb2$export$9804cccfc8dc0bb9)();
    const consent = (0, $9befe8313eed890c$export$2e2bcd8739ae039)();
    const isGenesys = (data?.items?.[0])?.["data-type"] === (0, $f2754c44a13f16ee$export$c87fd205be4f689b).genesys;
    const isSalesforce = data?.["data-type"] === (0, $f2754c44a13f16ee$export$c87fd205be4f689b).salesforce;
    const status = data?.status || (isSalesforce ? (0, $5191fc15630cefd3$export$9354cf8072350acf).offline : data?.status);
    const label = data?.label;
    const statusMessage = (status)=>{
        switch(status){
            case (0, $5191fc15630cefd3$export$9354cf8072350acf).online:
                return ariaLabels.chatStatusOnline ?? "Online";
            case (0, $5191fc15630cefd3$export$9354cf8072350acf).busy:
                return ariaLabels.chatStatusOnline ?? "Online";
            case (0, $5191fc15630cefd3$export$9354cf8072350acf).loading:
                return ariaLabels.chatStatusLoading ?? "Loading";
            default:
                return ariaLabels.chatStatusOffline ?? "Offline";
        }
    };
    const handleClick = (0, $hgUW1$useCallback)((event)=>{
        const isChatButton = event.currentTarget.dataset?.type === (0, $f2754c44a13f16ee$export$c87fd205be4f689b).salesforce;
        if (!isChatButton) onClick?.(event);
        // Don't propagate on clicks when navigating to submenu
        if (hasSubMenu) event?.stopPropagation?.();
        onSelect?.(index);
    }, [
        index,
        onClick,
        onSelect,
        hasSubMenu
    ]);
    const StatusIndicator = ({ status: status , usesSalesforce: usesSalesforce  })=>{
        return !!status && usesSalesforce ? /*#__PURE__*/ (0, $hgUW1$jsxs)($a882efb81830fa38$var$StyledIndicatorWrapper, {
            children: [
                status !== (0, $5191fc15630cefd3$export$9354cf8072350acf).loading && /*#__PURE__*/ (0, $hgUW1$jsx)($a882efb81830fa38$var$StyledStatusIndicator, {
                    status: status
                }),
                status === (0, $5191fc15630cefd3$export$9354cf8072350acf).loading && /*#__PURE__*/ (0, $hgUW1$jsx)($a882efb81830fa38$var$StyledSpinner, {
                    size: (0, $hgUW1$SpinnerSizes).small
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)($a882efb81830fa38$var$StyledStatusIndicatorText, {
                    status: status,
                    children: statusMessage(status)
                })
            ]
        }) : null;
    };
    if (isGenesys) {
        // necessary for playwright tests
        props["data-type"] = "genesys";
        // add reference to be able to directly open up the form or chat
        setGenesysChatTrigger(()=>{
            onSelect?.(index);
        });
    }
    const button = /*#__PURE__*/ (0, $hgUW1$jsxs)($a882efb81830fa38$var$StyledButton, {
        isLast: isLast,
        ref: ref,
        color: color,
        isPageBadge: isPageBadge,
        onClick: (e)=>{
            handleClick(e);
        },
        "data-status": status,
        disabled: isSalesforce && !consent ? false : status === (0, $5191fc15630cefd3$export$9354cf8072350acf).offline,
        ...!!status && {
            status: status
        },
        ...props,
        children: [
            label,
            isGenesys && /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment1), {
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Spacer), {
                        orientation: (0, $hgUW1$Orientations).horizontal,
                        spacing: (0, $hgUW1$createCustomSpacing)(6 / 16)
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)($a882efb81830fa38$var$GenesysIcon, {
                        icon: (0, $hgUW1$Icons).support,
                        pairedWithText: true,
                        hasMessages: genesysMessages > 0
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)(StatusIndicator, {
                status: status,
                usesSalesforce: isSalesforce
            }),
            hasSubMenu && !isGenesys && /*#__PURE__*/ (0, $hgUW1$jsx)($a882efb81830fa38$var$HasChildIcon, {
                icon: (0, $hgUW1$Icons).chevronRight
            })
        ]
    });
    // ensure that custom overrides are past onto the inverted theme below
    const theme = (0, $hgUW1$useTheme)();
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$InvertedThemeProvider), {
        overrides: {
            button: {
                primary: theme.contextMenu.button
            }
        },
        children: button
    });
});
$a882efb81830fa38$var$SupportDialogMenuItem.displayName = "SupportDialogMenuItem";
var $a882efb81830fa38$export$2e2bcd8739ae039 = $a882efb81830fa38$var$SupportDialogMenuItem;
const $a882efb81830fa38$var$HasChildIcon = (0, $hgUW1$emotionstyled)((0, $hgUW1$Icon))`
  margin-inline-start: auto;
  min-width: ${(0, $hgUW1$Spacings).large};
`;
const $a882efb81830fa38$var$StyledStatusIndicatorText = (0, $hgUW1$emotionstyled)((0, $hgUW1$Text), (0, $hgUW1$shouldNotForwardProps)(true, "status"))(({ theme: theme , status: status  })=>(0, $hgUW1$css)`
    font-size: 14px;
    color: ${theme.supportDialog.dialog.button.status[status].textColor};
  `);
const $a882efb81830fa38$var$StyledSpinner = (0, $hgUW1$emotionstyled)((0, $hgUW1$Spinner))`
  margin-inline: ${(0, $hgUW1$Spacings).xSmall} ${(0, $hgUW1$Spacings).xxSmall};
  width: unset;
`;
const $a882efb81830fa38$var$basicButtonStyling = (theme, isPageBadge)=>(0, $hgUW1$css)((0, $hgUW1$css)`
      display: flex;
      align-items: center;
      width: 100%;
      padding-inline: 0;
      padding-block: ${(0, $hgUW1$createCustomSpacing)(15 / 16)} ${(0, $hgUW1$createCustomSpacing)(0.875)};

      background-color: transparent;
      color: ${theme.supportDialog.dialog.button.states.enabled.color};
      cursor: pointer;
      border: none;

      &:hover {
        color: ${theme.supportDialog.dialog.button.states.hover.color};
      }

      &:active {
        color: ${theme.supportDialog.dialog.button.states.active.color};
      }

      &:disabled {
        color: ${theme.supportDialog.dialog.button.states.disabled.color};
      }
    `, !isPageBadge && (0, $hgUW1$css)`
        border-block-end: 1px solid ${theme.supportDialog.dialog.dividerColor};
      `);
const $a882efb81830fa38$var$StyledLink = (0, $hgUW1$emotionstyled)("a", (0, $hgUW1$shouldNotForwardProps)(true))(({ theme: theme  })=>(0, $hgUW1$css)($a882efb81830fa38$var$basicButtonStyling(theme, false), (0, $hgUW1$css)`
      text-decoration: none;
    `));
const $a882efb81830fa38$var$StyledIndicatorWrapper = (0, $hgUW1$emotionstyled).div`
  display: flex;
  align-items: center;
  pointer-events: none;
`;
const $a882efb81830fa38$var$StyledStatusIndicator = (0, $hgUW1$emotionstyled)("span", (0, $hgUW1$shouldNotForwardProps)(true, "status"))(({ theme: theme , status: status  })=>(0, $hgUW1$css)($a882efb81830fa38$export$6b53d3d1caa77bef, status !== (0, $5191fc15630cefd3$export$9354cf8072350acf).loading && (0, $hgUW1$css)`
        &::after {
          background-color: ${theme.supportDialog.dialog.button.status[status].color};
        }
      `));
const $a882efb81830fa38$var$StyledButton = (0, $hgUW1$emotionstyled)("button", (0, $hgUW1$shouldNotForwardProps)(true, "status", "label", "isLast", "isPageBadge"))(({ theme: theme , isLast: isLast , status: status , isPageBadge: isPageBadge  })=>(0, $hgUW1$css)($a882efb81830fa38$var$basicButtonStyling(theme, isPageBadge), (0, $hgUW1$css)`
      max-height: ${(0, $hgUW1$Spacings).xxLarge};

      /* used to ensure that the hover adjust the messages icon as expected */
      &:hover span:before {
        background: ${(0, $hgUW1$blend)((0, $hgUW1$Colors).ironGrey, theme.supportDialog.dialog.button.status.online.color, (0, $hgUW1$Opacities).medium)};
      }
    `, isLast && (0, $hgUW1$css)`
        margin-block-end: ${(0, $hgUW1$Spacings).medium};
      `, !!status && status === (0, $5191fc15630cefd3$export$9354cf8072350acf).offline && (0, $hgUW1$css)`
        color: ${theme.supportDialog.dialog.button.status[status].textColor};
        pointer-events: none;
      `));
const $a882efb81830fa38$export$6b53d3d1caa77bef = (0, $hgUW1$css)`
  display: flex;
  &::after {
    content: "";
    display: inline-flex;
    margin-inline: ${(0, $hgUW1$Spacings).xSmall} 0.3rem;
    width: ${(0, $hgUW1$createCustomSpacing)(0.5)};
    height: ${(0, $hgUW1$createCustomSpacing)(0.5)};
    border-radius: 50%;
  }
`;
const $a882efb81830fa38$var$GenesysIcon = (0, $hgUW1$emotionstyled)((0, $hgUW1$Icon), (0, $hgUW1$shouldNotForwardProps)(false, "hasMesssages"))(({ theme: theme , hasMessages: hasMessages  })=>(0, $hgUW1$css)((0, $hgUW1$css)`
      position: relative;
    `, hasMessages && (0, $hgUW1$css)`
        ${0, $5f0dbb7c18f85f01$export$5b35437f9ac62431}

        &:before {
          background: ${theme.supportDialog.dialog.button.status.online.color};
          inset-inline-end: -${(0, $hgUW1$createCustomSpacing)(0.25)};
          inset-block-start: -${(0, $hgUW1$createCustomSpacing)(1 / 16)};
        }
      `));













const $8e4ecc6e776f3bc8$var$convertStructuredTextToComponents = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
structuredText)=>{
    const output = [];
    const list = structuredText?.[0]?.children || structuredText;
    list?.map((// eslint-disable-next-line @typescript-eslint/no-explicit-any
    { value: value , children: children , type: type , url: url , meta: meta , ...childProps }, index)=>{
        const metaProps = meta?.reduce((// eslint-disable-next-line @typescript-eslint/no-explicit-any
        prev, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        next)=>({
                ...prev,
                ...next
            }));
        if (url?.indexOf("%show-functional-cookies%") > -1) type = "button";
        const handleClick = ()=>{
            // show OneTrust consent window for the functional cookies to inspect
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window?.OneTrust?.ToggleInfoDisplay();
        };
        switch(type){
            case "span":
                output.push(/*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Text), {
                    children: value
                }, index));
                break;
            case "button":
                output.push(/*#__PURE__*/ (0, $hgUW1$jsx)($8e4ecc6e776f3bc8$var$StyledTextButton, {
                    onClick: handleClick,
                    children: $8e4ecc6e776f3bc8$var$convertStructuredTextToComponents(children)
                }, index));
                break;
            case "link":
                output.push(/*#__PURE__*/ (0, $hgUW1$createElement)((0, $hgUW1$Link), {
                    href: url,
                    ...metaProps,
                    ...childProps,
                    key: index
                }, $8e4ecc6e776f3bc8$var$convertStructuredTextToComponents(children)));
                break;
        }
    });
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Fragment1), {
        children: output
    });
};
const $8e4ecc6e776f3bc8$export$821980d4979cf645 = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ label: label , callToAction: callToAction , disclaimerText: disclaimerText , consentText: consentText , ariaLabels: ariaLabels , id: id , requiredLabel: requiredLabel , requiredLegend: requiredLegend , ...props }, ref)=>{
    const { isSDKReady: isSDKReady , savePersonalInformation: savePersonalInformation , getPersonalInformation: getPersonalInformation , storePersonalInformation: storePersonalInformation , loadSDK: loadSDK  } = (0, $1972cb1a4960efb2$export$9804cccfc8dc0bb9)();
    const hasConsent = (0, $9befe8313eed890c$export$2e2bcd8739ae039)();
    const personalInformation = getPersonalInformation();
    const [firstName, setFirstName] = (0, $hgUW1$useState)(personalInformation.firstName);
    const [lastName, setLastName] = (0, $hgUW1$useState)(personalInformation.lastName);
    const [email, setEmail] = (0, $hgUW1$useState)(personalInformation.email);
    const [checked, setChecked] = (0, $hgUW1$useState)(false);
    const [disabled, setDisabled] = (0, $hgUW1$useState)(false);
    const [formSubmitted, setFormSubmitted] = (0, $hgUW1$useState)(false);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        // update OneTrust consent when toggled on
        if (!hasConsent) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window?.OneTrust?.UpdateConsent?.("Category", "3:1");
        (0, $cfc57243d48ecb76$export$feca7512a2d80ba4)("support_chat_click", "start_chatting");
        setDisabled(true);
        if (hasConsent) setFormSubmitted(true);
        else {
            // SDK is not yet loaded
            setFormSubmitted(true);
            await loadSDK();
        }
    };
    (0, $hgUW1$useEffect)(()=>{
        storePersonalInformation({
            firstName: firstName,
            lastName: lastName,
            email: email
        });
    }, [
        firstName,
        lastName,
        email,
        checked,
        hasConsent
    ]);
    (0, $hgUW1$useEffect)(()=>{
        if (formSubmitted && isSDKReady) {
            savePersonalInformation({
                firstName: firstName,
                lastName: lastName,
                email: email
            });
            setFormSubmitted(false);
        }
    }, [
        formSubmitted,
        isSDKReady,
        firstName,
        lastName,
        email
    ]);
    const customTheme = (0, $hgUW1$extendTheme)((0, $hgUW1$Themes).light, {
        formField: {
            states: {
                enabled: {
                    labelColor: (0, $hgUW1$Themes).dark.formField.states.enabled.labelColor,
                    hintTextColor: (0, $hgUW1$Themes).dark.formField.states.enabled.hintTextColor,
                    borderColor: (0, $hgUW1$Themes).dark.formField.states.enabled.borderColor,
                    iconColor: (0, $hgUW1$Themes).dark.formField.states.enabled.iconColor,
                    inputTextColor: (0, $hgUW1$Themes).dark.formField.states.enabled.inputTextColor,
                    placeholderColor: (0, $hgUW1$Themes).dark.formField.states.enabled.placeholderColor
                },
                hover: {
                    labelColor: (0, $hgUW1$Themes).dark.formField.states.hover.labelColor,
                    hintTextColor: (0, $hgUW1$Themes).dark.formField.states.hover.hintTextColor,
                    borderColor: (0, $hgUW1$Themes).dark.formField.states.hover.borderColor,
                    iconColor: (0, $hgUW1$Themes).dark.formField.states.hover.iconColor,
                    inputTextColor: (0, $hgUW1$Themes).dark.formField.states.hover.inputTextColor
                },
                focused: {
                    labelColor: (0, $hgUW1$Themes).dark.formField.states.focused.labelColor,
                    hintTextColor: (0, $hgUW1$Themes).dark.formField.states.focused.hintTextColor,
                    borderColor: (0, $hgUW1$Themes).dark.formField.states.focused.borderColor,
                    inputTextColor: (0, $hgUW1$Themes).dark.formField.states.focused.inputTextColor
                },
                error: {
                    labelColor: (0, $hgUW1$Themes).dark.formField.states.error.labelColor,
                    borderColor: (0, $hgUW1$Themes).dark.formField.states.error.borderColor,
                    inputTextColor: (0, $hgUW1$Themes).dark.formField.states.error.inputTextColor
                },
                disabled: {
                    labelColor: (0, $hgUW1$Themes).dark.formField.states.disabled.labelColor,
                    hintTextColor: (0, $hgUW1$Themes).dark.formField.states.disabled.hintTextColor,
                    borderColor: (0, $hgUW1$Themes).dark.formField.states.disabled.borderColor,
                    iconColor: (0, $hgUW1$Themes).dark.formField.states.disabled.iconColor,
                    inputTextColor: (0, $hgUW1$Themes).dark.formField.states.disabled.inputTextColor
                }
            },
            backgroundColor: (0, $hgUW1$withOpacity)((0, $hgUW1$Colors).black, (0, $hgUW1$Opacities).xLow)
        },
        text: {
            color: (0, $hgUW1$Colors).white
        }
    });
    const customDisclaimerTheme = (0, $hgUW1$extendTheme)((0, $hgUW1$Themes).light, {
        caption: {
            default: {
                color: (0, $hgUW1$Themes).dark.caption.default.color
            },
            error: {
                color: (0, $hgUW1$Themes).dark.caption.error.color
            },
            disabled: {
                color: (0, $hgUW1$Themes).dark.caption.disabled.color
            }
        },
        text: {
            color: (0, $hgUW1$Themes).dark.caption.default.color
        },
        link: {
            variants: {
                default: {
                    states: {
                        enabled: {
                            textColor: (0, $hgUW1$Themes).dark.link.variants.default.states.enabled.textColor
                        },
                        hover: {
                            textColor: (0, $hgUW1$Themes).dark.link.variants.default.states.hover.textColor
                        },
                        active: {
                            textColor: (0, $hgUW1$Themes).dark.link.variants.default.states.active.textColor
                        }
                    }
                }
            }
        }
    });
    const handleFirstNameChange = (value)=>{
        setFirstName(value);
    };
    const handleLastNameChange = (value)=>{
        setLastName(value);
    };
    const handleEmailChange = (value)=>{
        setEmail(value);
    };
    return /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a1d69abd9d00ae77$export$5bea22cc1614ac3b), {
                first: true,
                children: label
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)($8e4ecc6e776f3bc8$var$Form, {
                id: id || `genesys-form`,
                onSubmit: handleSubmit,
                children: /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$ThemeProvider), {
                    theme: customTheme,
                    children: [
                        /*#__PURE__*/ (0, $hgUW1$jsx)($8e4ecc6e776f3bc8$var$StyledTextField, {
                            value: firstName,
                            name: "name",
                            onChange: handleFirstNameChange,
                            label: ariaLabels.firstName,
                            required: true,
                            ...(0, $hgUW1$aria)({
                                label: `${ariaLabels.firstName + " " + requiredLabel}`
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)($8e4ecc6e776f3bc8$var$StyledTextField, {
                            value: lastName,
                            name: "lastName",
                            onChange: handleLastNameChange,
                            label: ariaLabels.lastName,
                            required: true,
                            ...(0, $hgUW1$aria)({
                                label: `${ariaLabels.lastName + " " + requiredLabel}`
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)($8e4ecc6e776f3bc8$var$StyledTextField, {
                            value: email,
                            name: "email",
                            onChange: handleEmailChange,
                            label: ariaLabels.email,
                            pattern: ".*\\.[\\w]{2,}$",
                            required: true,
                            type: "email",
                            ...(0, $hgUW1$aria)({
                                label: `${ariaLabels.email + " " + requiredLabel}`
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$InvertedThemeProvider), {
                            overrides: {
                                checkbox: {
                                    backgroundColor: (0, $hgUW1$withOpacity)((0, $hgUW1$Colors).black, (0, $hgUW1$Opacities).xLow)
                                }
                            },
                            children: !hasConsent && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$CheckboxField), {
                                checked: checked,
                                onChange: (checked)=>setChecked(checked),
                                name: "checkbox-field",
                                value: "only-submitted-when-checked-checkboxfield",
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                label: /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment1), {
                                    children: [
                                        $8e4ecc6e776f3bc8$var$convertStructuredTextToComponents(consentText.value.document.children),
                                        " "
                                    ]
                                }),
                                required: true,
                                hint: "",
                                tooltip: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)($8e4ecc6e776f3bc8$var$SubmitWrapper, {
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)($8e4ecc6e776f3bc8$var$SubmitButton, {
                                    type: "submit",
                                    icon: formSubmitted && !isSDKReady ? undefined : (0, $hgUW1$Icons).arrowRight,
                                    iconPosition: (0, $hgUW1$Alignments).right,
                                    disabled: disabled,
                                    children: callToAction
                                }),
                                formSubmitted && !isSDKReady && /*#__PURE__*/ (0, $hgUW1$jsx)($8e4ecc6e776f3bc8$var$SpinnerWrapper, {
                                    children: /*#__PURE__*/ (0, $hgUW1$jsx)($8e4ecc6e776f3bc8$var$StyledSpinner, {
                                        size: (0, $hgUW1$SpinnerSizes).small
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$ThemeProvider), {
                            theme: customDisclaimerTheme,
                            children: [
                                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Caption), {
                                    size: (0, $hgUW1$Sizes).small,
                                    style: {
                                        display: "block"
                                    },
                                    children: $8e4ecc6e776f3bc8$var$convertStructuredTextToComponents(disclaimerText.value.document.children)
                                }),
                                /*#__PURE__*/ (0, $hgUW1$jsx)($8e4ecc6e776f3bc8$var$StyledCaption, {
                                    size: (0, $hgUW1$Sizes).small,
                                    style: {
                                        display: "block"
                                    },
                                    children: requiredLegend
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
});
$8e4ecc6e776f3bc8$export$821980d4979cf645.displayName = "GenesysForm";
/**
 * TODO: The styling of labels here is for demo purposes only
 * in order to use this we need to update our text fields in component warehouse and add translations in our dictionary
 */ const $8e4ecc6e776f3bc8$var$Form = (0, $hgUW1$emotionstyled).form`
  padding-block: ${(0, $hgUW1$Spacings).large};
  display: flex;
  flex-direction: column;
  gap: ${(0, $hgUW1$Spacings).large};
  color: ${(0, $hgUW1$Colors).white};
`;
const $8e4ecc6e776f3bc8$var$SubmitButton = (0, $hgUW1$emotionstyled)((0, $hgUW1$SecondaryButton))`
  background: ${(0, $hgUW1$Colors).white};
  box-shadow: none;
`;
const $8e4ecc6e776f3bc8$var$StyledTextButton = (0, $hgUW1$emotionstyled)((0, $hgUW1$TextButton))`
  text-decoration: underline;
  overflow: hidden;
`;
const $8e4ecc6e776f3bc8$var$StyledCaption = (0, $hgUW1$emotionstyled)((0, $hgUW1$Caption))`
  color: currentColor;
`;
const $8e4ecc6e776f3bc8$var$StyledTextField = (0, $hgUW1$emotionstyled)((0, $hgUW1$TextField))`
  -webkit-text-fill-color: ${(0, $hgUW1$Colors).white};
`;
const $8e4ecc6e776f3bc8$var$SubmitWrapper = (0, $hgUW1$emotionstyled).div`
  display: flex;
  flex-direction: column;
  position: relative;
`;
const $8e4ecc6e776f3bc8$var$SpinnerWrapper = (0, $hgUW1$emotionstyled).div`
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: ${(0, $hgUW1$Spacings).medium};
  inset-block-end: 0;
`;
const $8e4ecc6e776f3bc8$var$StyledSpinner = (0, $hgUW1$emotionstyled)((0, $hgUW1$Spinner))`
  svg circle {
    stroke: ${(0, $hgUW1$Colors).black};
  }
`;





const $a1d69abd9d00ae77$var$linkClickedTracking = (label = "missing label")=>{
    window.dataLayer?.push({
        event: "support_dialog",
        eventInfo: {
            action: "support_chat_click",
            label: label
        }
    });
};
const $a1d69abd9d00ae77$var$SupportDialogMenu = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ index: index , menuItem: menuItem , currentMenu: currentMenu , ariaLabels: ariaLabels , onClose: onClose , onSelect: onSelect , onHeightChange: onHeightChange , ...props }, ref)=>{
    const internalRef = (0, $hgUW1$useRef)();
    const heightRef = (0, $hgUW1$useCallback)((node)=>{
        if (node) onHeightChange?.(index, node.scrollHeight);
    }, [
        index,
        onHeightChange
    ]);
    const combinedRef = (0, $hgUW1$polestarcomponentwarehousereacthooksuseCombinedRef)(internalRef, ref, heightRef);
    const { isKeyboardControlled: isKeyboardControlled  } = (0, $hgUW1$useInteractionMode)();
    const { showForm: showForm  } = (0, $1972cb1a4960efb2$export$9804cccfc8dc0bb9)();
    (0, $hgUW1$useFocusRestore)(true, {
        scrollIntoView: false,
        preventScroll: true
    });
    (0, $hgUW1$useFocusInitial)(internalRef, true, {
        preventScroll: true
    });
    const elements = (0, $hgUW1$useMemo)(()=>{
        const hasGenesysProps = menuItem?.map((item)=>item?.items?.map((subItem)=>subItem?.["data-type"] === (0, $f2754c44a13f16ee$export$c87fd205be4f689b).genesys).includes(true) || false).includes(true) || false;
        if (showForm && hasGenesysProps) {
            const genesysValues = menuItem.flatMap((item)=>item.items ?? []).find((item)=>item?.["data-type"] === (0, $f2754c44a13f16ee$export$c87fd205be4f689b).genesys);
            if (genesysValues) return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8e4ecc6e776f3bc8$export$821980d4979cf645), {
                ref: ref,
                ...genesysValues,
                ariaLabels: ariaLabels
            }, "genesys");
        }
        return menuItem.map((menuItemProps, itemIndex)=>{
            return /*#__PURE__*/ (0, $hgUW1$jsx)($a1d69abd9d00ae77$var$SupportDialogMenuWrapper, {
                index: itemIndex,
                menuItemProps: menuItemProps,
                menuLength: menuItem.length,
                onSelect: onSelect,
                currentMenu: currentMenu,
                ariaLabels: ariaLabels,
                onClose: onClose
            }, itemIndex.toString());
        });
    }, [
        showForm,
        menuItem,
        currentMenu,
        onSelect,
        ariaLabels,
        onClose
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsx)($a1d69abd9d00ae77$var$SupportDialogMenuContainer, {
        ref: combinedRef,
        as: (0, $hgUW1$m).div,
        ...!isKeyboardControlled ? {
            initial: {
                visibility: "hidden"
            },
            animate: {
                visibility: !currentMenu && isKeyboardControlled ? "hidden" : "visible",
                pointerEvents: currentMenu ? "auto" : "none"
            },
            exit: {
                visibility: !currentMenu && isKeyboardControlled ? "hidden" : "visible",
                opacity: 0.9
            },
            transition: $5191fc15630cefd3$export$66bb15e2994e6a26
        } : {},
        style: isKeyboardControlled && !currentMenu ? {
            display: "none"
        } : {},
        ...props,
        children: elements
    });
});
$a1d69abd9d00ae77$var$SupportDialogMenu.displayName = "SupportDialogMenu";
var $a1d69abd9d00ae77$export$2e2bcd8739ae039 = $a1d69abd9d00ae77$var$SupportDialogMenu;
const $a1d69abd9d00ae77$export$5bea22cc1614ac3b = (0, $hgUW1$emotionstyled)((0, $hgUW1$Heading))(({ theme: theme , first: first  })=>(0, $hgUW1$css)((0, $hgUW1$css)`
      font-size: 30px;
      line-height: 32px;
      color: ${theme.supportDialog.dialog.color};
      margin-bottom: ${(0, $hgUW1$Spacings).xSmall};
    `, !first && (0, $hgUW1$css)`
        margin-top: ${(0, $hgUW1$createCustomSpacing)(3)};
      `));
const $a1d69abd9d00ae77$var$SupportDialogMenuContainer = (0, $hgUW1$emotionstyled).div`
  display: flex;
  width: 100%;
  z-index: 2;
  flex-shrink: 0;
  flex-grow: 0;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 ${(0, $hgUW1$Spacings).large};
`;
const $a1d69abd9d00ae77$var$SupportDialogMenuWrapper = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ index: index , menuLength: menuLength , menuItemProps: menuItemProps , onClose: onClose , onSelect: onSelect , ariaLabels: ariaLabels , currentMenu: currentMenu  }, ref)=>{
    const { openGenesysChat: openGenesysChat , showForm: showForm  } = (0, $1972cb1a4960efb2$export$9804cccfc8dc0bb9)();
    const clickHandler = (0, $hgUW1$useCallback)(async (e)=>{
        $a1d69abd9d00ae77$var$linkClickedTracking(menuItemProps?.label);
        if (e.currentTarget?.dataset?.type === "genesys") {
            // check if already saved then do not show the form
            (0, $hgUW1$preventCancelableDefault)(e);
            onClose?.(e);
            // chat button clicked, open chat
            openGenesysChat();
        } else menuItemProps?.onClick?.(e);
        if (!menuItemProps?.items) // do not close when a sub-menu is clicked
        onClose?.(e);
    }, [
        menuItemProps,
        openGenesysChat,
        onClose
    ]);
    const clickButtonProps = {
        ...menuItemProps,
        data: menuItemProps,
        ariaLabels: ariaLabels,
        index: index,
        onSelect: // do not trigger onSelect when personal information is stored
        onSelect,
        isLast: index === menuLength - 1,
        hasSubMenu: !!menuItemProps?.items,
        onClick: clickHandler,
        ...(0, $hgUW1$aria)({
            role: "menuitem",
            haspopup: !!menuItemProps?.items || undefined,
            expanded: menuItemProps?.items ? !currentMenu : undefined
        })
    };
    const genesysProps = menuItemProps;
    let genesysValues = genesysProps?.["data-type"] === (0, $f2754c44a13f16ee$export$c87fd205be4f689b).genesys ? genesysProps : undefined;
    const hasGenesysProps = menuItemProps?.items?.map((item)=>item?.["data-type"] === (0, $f2754c44a13f16ee$export$c87fd205be4f689b).genesys).includes(true) || false;
    if (hasGenesysProps && showForm) genesysValues = menuItemProps?.items?.find((item)=>item?.["data-type"] === (0, $f2754c44a13f16ee$export$c87fd205be4f689b).genesys);
    const content = (0, $hgUW1$useMemo)(()=>menuItemProps?.sectionTitle ? /*#__PURE__*/ (0, $hgUW1$jsx)($a1d69abd9d00ae77$export$5bea22cc1614ac3b, {
            ref: ref,
            as: "h5",
            automatedAlignment: true,
            first: index === 0,
            children: menuItemProps.sectionTitle
        }) : menuItemProps?.["data-type"] !== undefined && genesysValues !== undefined ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8e4ecc6e776f3bc8$export$821980d4979cf645), {
            ref: ref,
            ...genesysValues,
            ariaLabels: ariaLabels
        }, "genesys") : menuItemProps?.href ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a882efb81830fa38$export$b479dcc3bfb47330), {
            ...clickButtonProps
        }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a882efb81830fa38$export$2e2bcd8739ae039), {
            ...clickButtonProps
        }), [
        menuItemProps,
        index,
        clickButtonProps,
        ariaLabels,
        genesysValues
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$Fragment), {
        children: [
            content,
            index === menuLength - 1 && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Spacer), {
                spacing: (0, $hgUW1$Spacings).xxLarge,
                // ensure that it is calculated as part of the height of the menu
                style: {
                    width: (0, $hgUW1$createCustomSpacing)(1 / 16)
                }
            })
        ]
    }, `context-menu-item-${index}`);
});
$a1d69abd9d00ae77$var$SupportDialogMenuWrapper.displayName = "SupportDialogMenuWrapper";




let $5191fc15630cefd3$export$9354cf8072350acf;
(function(SupportDialogButtonStatus) {
    SupportDialogButtonStatus["online"] = "online";
    SupportDialogButtonStatus["offline"] = "offline";
    SupportDialogButtonStatus["busy"] = "busy";
    SupportDialogButtonStatus["loading"] = "loading";
})($5191fc15630cefd3$export$9354cf8072350acf || ($5191fc15630cefd3$export$9354cf8072350acf = {}));
const $5191fc15630cefd3$export$66bb15e2994e6a26 = (0, $hgUW1$createTransition)({
    reduced: true
});
const $5191fc15630cefd3$var$disabledTransition = {
    type: false,
    delay: 0
};
const $5191fc15630cefd3$var$SupportDialogPopover = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ consentContent: consentContent , showConsentDialog: showConsentDialog = false , onConsentBackClick: onConsentBackClick , onFormBackClick: onFormBackClick , isMobile: isMobile = false , ariaLabels: ariaLabels , items: items , loading: loading , onClose: onClose , ...props }, ref)=>{
    // multiple menus can exist due to different sub-levels using the same functionality
    const [menus, setMenus] = (0, $hgUW1$useState)([
        items
    ]);
    const [level, setLevel] = (0, $hgUW1$useState)(0);
    const { isKeyboardControlled: isKeyboardControlled  } = (0, $hgUW1$useInteractionMode)();
    const previousIsKeyboardControlled = (0, $hgUW1$useRef)(null);
    const isReducedMotion = (0, $hgUW1$useReducedMotion)();
    const { innerHeight: innerHeight  } = (0, $hgUW1$useWindowSize)();
    const { isTriggeredByChatButton: isTriggeredByChatButton , popoverClosed: popoverClosed , showForm: showForm  } = (0, $1972cb1a4960efb2$export$9804cccfc8dc0bb9)();
    const isDisabledMotion = previousIsKeyboardControlled.current === true && !isKeyboardControlled || isKeyboardControlled || isReducedMotion;
    const { isRTL: isRTL  } = (0, $hgUW1$useDirection)();
    (0, $hgUW1$useEffect)(()=>{
        setMenus([
            items
        ]);
    }, [
        items
    ]);
    const handleSelect = (0, $hgUW1$useCallback)((index)=>{
        setLevel((val)=>val + 1);
        setMenus((items)=>{
            const element = items[items.length - 1]?.[index];
            const selectedMenu = element?.items;
            return selectedMenu ? [
                ...items,
                selectedMenu
            ] : items;
        });
    }, []);
    const handleBack = (0, $hgUW1$useCallback)((e)=>{
        e?.stopPropagation();
        setLevel((val)=>val - 1);
        if (showForm) onFormBackClick?.(e);
        else if (showConsentDialog) onConsentBackClick?.(e);
        else setMenus((items)=>{
            return items.length === 1 ? [
                items[0]
            ] : items.slice(0, items.length - 1);
        });
    }, [
        showConsentDialog,
        showForm,
        onConsentBackClick,
        onFormBackClick
    ]);
    // ensure when the OneTrust dialog appear that the back button hides while the content is reset
    const consentDialog = (0, $hgUW1$useRef)(showConsentDialog);
    (0, $hgUW1$useEffect)(()=>{
        if (consentDialog.current !== showConsentDialog) {
            if (!showConsentDialog) setLevel(0);
            consentDialog.current = showConsentDialog;
        }
    }, [
        showConsentDialog
    ]);
    const [menuHeights, setMenuHeights] = (0, $hgUW1$useState)([]);
    const currentHeight = menuHeights[menuHeights.length - 1];
    const heightsChanged = menuHeights.length > menus.length;
    const resetScrollTopTimeout = (0, $hgUW1$useRef)(null);
    (0, $hgUW1$useEffect)(()=>{
        if (heightsChanged) setMenuHeights((prevHeights)=>prevHeights.slice(0, menus.length));
        if (menus.length === 2) {
            if (resetScrollTopTimeout.current) clearTimeout(resetScrollTopTimeout.current);
            // adjust scrollTop when a sub-menu is opened
            resetScrollTopTimeout.current = setTimeout(()=>{
                if (internalRef.current) internalRef.current.scrollTop = 0;
            }, 50);
        }
    }, [
        menus.length,
        heightsChanged
    ]);
    const handleHeightChange = (0, $hgUW1$useCallback)((index, columnHeight)=>{
        setMenuHeights((prevHeights)=>{
            const newHeights = [
                ...prevHeights
            ];
            newHeights[index] = columnHeight;
            return newHeights;
        });
    }, []);
    const handleClose = (0, $hgUW1$useCallback)((e)=>{
        setLevel(0);
        popoverClosed();
        onClose?.(e);
    }, []);
    const menuElements = (0, $hgUW1$useMemo)(()=>menus.map((menuItem, index)=>{
            const currentMenu = index === menus.length - 1;
            return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $a1d69abd9d00ae77$export$2e2bcd8739ae039), {
                index: index,
                currentMenu: currentMenu,
                menuItem: menuItem,
                onSelect: handleSelect,
                onHeightChange: handleHeightChange,
                onClose: handleClose,
                ariaLabels: ariaLabels
            }, index);
        }), [
        menus,
        handleSelect,
        handleHeightChange,
        handleClose,
        ariaLabels
    ]);
    const innerXValue = -((menus.length - 1) * 100);
    const maxDialogHeight = !isMobile ? 528 : `calc(${innerHeight}px - ${(0, $hgUW1$createCustomLetterSpacing)(4.5)})`;
    const internalRef = (0, $hgUW1$useRef)(null);
    const combinedRef = (0, $hgUW1$useCombinedRef)(ref, internalRef);
    (0, $hgUW1$useFocusTrap)(internalRef, true);
    // ensure when showing consent dialog the consent is provided
    (0, $hgUW1$useFocusInitial)(internalRef, showConsentDialog, {
        index: 1,
        preventScroll: true
    });
    const xPos = (0, $hgUW1$useMotionValue)(0);
    if (previousIsKeyboardControlled.current === true && isKeyboardControlled === false) // ensure that switching from keyboard to mouse will not trigger wrong transition
    xPos.set(innerXValue);
    // TODO: improve direct transitions to prevent this bugfix
    if (isKeyboardControlled) xPos.set(0);
    else (0, $hgUW1$animate)(xPos, innerXValue, $5191fc15630cefd3$export$66bb15e2994e6a26);
    const rtlMultiplier = isRTL ? -1 : 1;
    const xPosTransform = (0, $hgUW1$useTransform)(xPos, (val)=>val !== 0 ? `${rtlMultiplier * val}%` : rtlMultiplier * val);
    // keep at bottom to not change depending checks being changed
    previousIsKeyboardControlled.current = isKeyboardControlled;
    const showBackIcon = loading ? false : showForm || level > 0;
    return /*#__PURE__*/ (0, $hgUW1$jsxs)($5191fc15630cefd3$var$Container, {
        ref: combinedRef,
        isKeyboardControlled: isKeyboardControlled,
        ...props,
        style: {
            maxHeight: maxDialogHeight
        },
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsxs)($5191fc15630cefd3$var$ButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0, $hgUW1$jsx)($5191fc15630cefd3$var$BackIcon, {
                        "data-type": "back-icon",
                        onClick: handleBack,
                        size: (0, $hgUW1$Sizes).large,
                        icon: (0, $hgUW1$Icons).arrowLeft,
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            opacity: showBackIcon ? 1 : 0
                        },
                        exit: {
                            opacity: 0
                        },
                        alignmentOffset: (0, $hgUW1$Alignments).left,
                        interactive: !isTriggeredByChatButton() && showBackIcon,
                        tabIndex: showBackIcon ? 0 : -1,
                        title: ariaLabels.backButton,
                        ...(0, $hgUW1$aria)({
                            label: ariaLabels.backButton
                        })
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)($5191fc15630cefd3$var$CloseIcon, {
                        "data-type": "close-icon",
                        onClick: handleClose,
                        size: (0, $hgUW1$Sizes).large,
                        icon: (0, $hgUW1$Icons).close,
                        alignmentOffset: (0, $hgUW1$Alignments).right,
                        title: ariaLabels.closeButton,
                        ...(0, $hgUW1$aria)({
                            label: ariaLabels.closeButton
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)($5191fc15630cefd3$var$Inner, {
                transition: isDisabledMotion ? $5191fc15630cefd3$var$disabledTransition : $5191fc15630cefd3$export$66bb15e2994e6a26,
                initial: false,
                "data-id": "support-dialog-inner",
                style: {
                    x: xPosTransform,
                    height: currentHeight ? currentHeight : "auto"
                },
                children: /*#__PURE__*/ (0, $hgUW1$jsx)($5191fc15630cefd3$var$Content, {
                    showConsentDialog: showConsentDialog,
                    menuElements: menuElements,
                    consentContent: consentContent
                })
            })
        ]
    }, "popover");
});
$5191fc15630cefd3$var$SupportDialogPopover.displayName = "SupportDialogPopover";
var $5191fc15630cefd3$export$2e2bcd8739ae039 = $5191fc15630cefd3$var$SupportDialogPopover;
const $5191fc15630cefd3$var$Inner = (0, $hgUW1$emotionstyled)((0, $hgUW1$m).div)`
  display: flex;
`;
const $5191fc15630cefd3$var$Container = (0, $hgUW1$emotionstyled)((0, $hgUW1$m).div, (0, $hgUW1$shouldNotForwardProps)(false, "isKeyboardControlled"))(({ isKeyboardControlled: isKeyboardControlled , theme: theme  })=>(0, $hgUW1$css)`
    color: ${theme.supportDialog.dialog.color};
    min-width: 15rem;
    overflow: ${isKeyboardControlled ? "visible" : "hidden"};
    overflow-y: auto;
    background-color: ${theme.supportDialog.dialog.backgroundColor};

    position: fixed;
    width: 100%;
    inset-inline-end: 0;
    inset-block-end: 0;

    ${(0, $hgUW1$MediaQueries).tablet} {
      width: ${(0, $hgUW1$createCustomSpacing)(20)};
      inset-block-end: ${(0, $hgUW1$createCustomSpacing)(1.25)};
      inset-inline-end: ${(0, $hgUW1$createCustomSpacing)(1.25)};
      max-width: ${(0, $hgUW1$createCustomSpacing)(375 / 16)};
    }

    ${(0, $hgUW1$MediaQueries).desktop} {
      inset-block-end: ${(0, $hgUW1$Spacings).large};
      inset-inline-end: ${(0, $hgUW1$Spacings).large};
    }
  `);
const $5191fc15630cefd3$var$CloseIcon = (0, $hgUW1$emotionstyled)((0, $hgUW1$IconButton))(({ theme: theme  })=>(0, $hgUW1$css)`
    color: ${theme.supportDialog.dialog.icons.states.enabled.color};

    &:hover {
      color: ${theme.supportDialog.dialog.icons.states.hover.color};
    }

    &:active {
      color: ${theme.supportDialog.dialog.icons.states.active.color};
    }
  `);
const $5191fc15630cefd3$var$BackIcon = (0, $hgUW1$emotionstyled)((0, $hgUW1$m)((0, $hgUW1$IconButton)), (0, $hgUW1$shouldNotForwardProps)(false, "interactive"))(({ theme: theme , interactive: interactive = false  })=>(0, $hgUW1$css)((0, $hgUW1$css)`
      padding: ${(0, $hgUW1$Spacings).large};
      color: ${theme.supportDialog.dialog.icons.states.enabled.color};

      &:hover {
        color: ${theme.supportDialog.dialog.icons.states.hover.color};
      }

      &:active {
        color: ${theme.supportDialog.dialog.icons.states.active.color};
      }
    `, !interactive && (0, $hgUW1$css)`
        pointer-events: none;
        visibility: hidden;
      `));
const $5191fc15630cefd3$var$CookieContentPanel = (0, $hgUW1$emotionstyled).div`
  position: relative;
  padding: 0 ${(0, $hgUW1$Spacings).large};
`;
const $5191fc15630cefd3$var$ButtonWrapper = (0, $hgUW1$emotionstyled).div(({ theme: theme  })=>(0, $hgUW1$css)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    inset-block-start: 0;
    inset-inline-start: 0;
    width: 100%;
    background-color: ${theme.supportDialog.dialog.backgroundColor};
    padding: ${(0, $hgUW1$Spacings).small} ${(0, $hgUW1$Spacings).large};
    z-index: 3;
  `);
const $5191fc15630cefd3$var$Content = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ consentContent: consentContent , showConsentDialog: showConsentDialog = false , menuElements: menuElements  }, ref)=>showConsentDialog ? /*#__PURE__*/ (0, $hgUW1$jsx)($5191fc15630cefd3$var$CookieContentPanel, {
        ref: ref,
        children: consentContent
    }) : // We only need animation when using mouse, otherwise just render the items
    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$AnimatePresence), {
        initial: false,
        children: menuElements
    }));
$5191fc15630cefd3$var$Content.displayName = "Content";


// @ts-nocheck
// @ts-nocheck
const $4766dd3defe3db18$export$2fcc8c9275f9477b = `
    fragment supportDialogMenuItem on SupportDialogMenuModelMenuItemField {
  __typename
  ... on SupportDialogMenuItemChatButtonRecord {
    label
  }
  ... on SupportDialogMenuItemGenesysChatRecord {
    label
    disclaimerText {
      value
    }
    consentText {
      value
    }
    callToAction
    requiredLabel
    requiredLegend
  }
  ... on SupportDialogMenuItemTitleRecord {
    title
  }
  ... on SupportDialogMenuItemLinkRecord {
    label
    href
    isExternal
  }
  ... on SupportDialogMenuItemNavigationRecord {
    label
  }
  ... on SupportDialogMenuItemCallLinkRecord {
    phoneNumber
    label
  }
}
    `;
function $4766dd3defe3db18$export$68dbe58f97d98fc5(requester) {
    return {};
}


const $2a043660e4bfe08a$export$abb4c6760c8c1322 = `
    query supportDialogMenus($locale: SiteLocale!) {
  supportDialogDictionary(locale: $locale) {
    openButton
    loadingChatButton
    backButton
    closeButton
    backButton
    consentButton
    consentDialogText
    chatStatusOnline
    chatStatusOffline
  }
  sharedDictionary: allSharedDictionaries(
    locale: $locale
    filter: {key: {in: ["Email", "First name", "Last name"]}}
  ) {
    key
    value
  }
  allSupportDialogMenus(locale: $locale, filter: {parent: {exists: "false"}}) {
    menuItem {
      ...supportDialogMenuItem
    }
    children {
      menuItem {
        ...supportDialogMenuItem
      }
      children {
        menuItem {
          ...supportDialogMenuItem
        }
      }
    }
  }
}
    ${(0, $4766dd3defe3db18$export$2fcc8c9275f9477b)}`;
function $2a043660e4bfe08a$export$68dbe58f97d98fc5(requester) {
    return {
        supportDialogMenus (variables, options) {
            return requester($2a043660e4bfe08a$export$abb4c6760c8c1322, variables, options);
        }
    };
}


/* in Dato we set validation for the href link field: ^(\/|https:\/\/)
dato block: https://polestar.admin.datocms.com/admin/blocks_library/2025922 */ const $61e280e71447308a$var$handleHref = (href, fallBackDomain)=>{
    if (!href) return undefined;
    const isAbsolutePath = href.startsWith("https://") || href.startsWith("http://");
    return !isAbsolutePath && fallBackDomain ? `${fallBackDomain}${href}` : href;
};
var $61e280e71447308a$export$2e2bcd8739ae039 = $61e280e71447308a$var$handleHref;



const $d4f2220fd64bd165$export$4e7d22c39fd53790 = (menuItem, children, fallbackDomain)=>({
        label: menuItem.label,
        ...children?.length && {
            items: $d4f2220fd64bd165$export$4d0aa1f1e3f127b1(children, fallbackDomain)
        }
    });
const $d4f2220fd64bd165$export$b156ceef7f23b74b = (menuItem)=>({
        label: menuItem.label,
        "data-type": (0, $f2754c44a13f16ee$export$c87fd205be4f689b).salesforce,
        status: (0, $5191fc15630cefd3$export$9354cf8072350acf).offline
    });
const $d4f2220fd64bd165$export$78c7f441e7729dc9 = (props)=>{
    const { label: label , callToAction: callToAction , consentText: consentText , disclaimerText: disclaimerText , requiredLabel: requiredLabel , requiredLegend: requiredLegend  } = props;
    return {
        "data-type": (0, $f2754c44a13f16ee$export$c87fd205be4f689b).genesys,
        label: label,
        callToAction: callToAction,
        consentText: consentText,
        disclaimerText: disclaimerText,
        requiredLabel: requiredLabel,
        requiredLegend: requiredLegend
    };
};
const $d4f2220fd64bd165$export$f6fdc4252b54af8e = (menuItem)=>({
        sectionTitle: menuItem.title
    });
const $d4f2220fd64bd165$export$6870fa208eef4df = (menuItem, fallbackDomain)=>({
        label: menuItem.label,
        href: (0, $61e280e71447308a$export$2e2bcd8739ae039)(menuItem.href, fallbackDomain),
        ...menuItem.isExternal && {
            target: "_blank",
            rel: "noopener noreferrer"
        }
    });
const $d4f2220fd64bd165$export$ea92b2b182854322 = (menuItem)=>{
    return {
        label: menuItem.label,
        href: `tel:${menuItem.phoneNumber}`
    };
};
const $d4f2220fd64bd165$var$checkMenuItemsForChatType = (items)=>items?.filter((menu)=>{
        if (menu["data-type"]) // main level
        return true;
        if ((menu?.items?.length || 0) > 0) {
            // sub level
            if ((menu.items?.[0])?.["data-type"]) return true;
        }
        return false;
    }).reduce((// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    previous, next)=>{
        return previous ? previous : // @ts-ignore
        next?.items?.[0]["data-type"] === (0, $f2754c44a13f16ee$export$c87fd205be4f689b).genesys ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        next?.items?.[0]["data-type"] : (0, $f2754c44a13f16ee$export$c87fd205be4f689b).salesforce;
    }, undefined);
/**
 * Match the menu items returned from Dato to the props for the SupportDialog
 */ const $d4f2220fd64bd165$export$4d0aa1f1e3f127b1 = (menuItems, fallbackDomain)=>{
    const items = [];
    menuItems?.forEach((menu)=>{
        const currentMenuItems = menu?.menuItem[0];
        if (!currentMenuItems?.__typename) return;
        switch(currentMenuItems.__typename){
            case "SupportDialogMenuItemGenesysChatRecord":
                items.push($d4f2220fd64bd165$export$78c7f441e7729dc9(currentMenuItems));
                break;
            case "SupportDialogMenuItemNavigationRecord":
                items.push($d4f2220fd64bd165$export$4e7d22c39fd53790(currentMenuItems, menu?.children, fallbackDomain));
                break;
            case "SupportDialogMenuItemChatButtonRecord":
                items.push($d4f2220fd64bd165$export$b156ceef7f23b74b(currentMenuItems));
                break;
            case "SupportDialogMenuItemTitleRecord":
                items.push($d4f2220fd64bd165$export$f6fdc4252b54af8e(currentMenuItems));
                break;
            case "SupportDialogMenuItemLinkRecord":
                items.push($d4f2220fd64bd165$export$6870fa208eef4df(currentMenuItems, fallbackDomain));
                break;
            case "SupportDialogMenuItemCallLinkRecord":
                items.push($d4f2220fd64bd165$export$ea92b2b182854322(currentMenuItems));
                break;
        }
    });
    return items;
};
//* Fetch menu items from Dato
const $d4f2220fd64bd165$var$fetchMenuItems = async (locale, environment)=>await (0, $4d7d019151bf18dc$export$e393c23e3e79fe52)((0, $2a043660e4bfe08a$export$abb4c6760c8c1322), environment, {
        locale: locale
    });
const $d4f2220fd64bd165$var$makeCamelCase = (str)=>str.split(" ").map((e, i)=>i ? e.charAt(0).toUpperCase() + e.slice(1).toLowerCase() : e.toLowerCase()).join("");
const $d4f2220fd64bd165$export$b21bb307e27a352e = {
    openButton: "Open Support Button",
    closeButton: "Close Dialog",
    backButton: "Go back",
    consentButton: "Give consent",
    consentDialogText: "You need to turn off your adblocker and activate functional cookies for us to trigger the chat.",
    chatStatusOnline: "Online",
    chatStatusOffline: "Offline",
    chatStatusLoading: "Loading",
    firstName: "First name",
    lastName: "Last name",
    email: "Email"
};
const $d4f2220fd64bd165$export$91d66573ef213493 = async (locale, environment, fallbackDomain)=>{
    const menuItems = await $d4f2220fd64bd165$var$fetchMenuItems(locale, environment);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const translations = menuItems.sharedDictionary.map((item)=>({
            [$d4f2220fd64bd165$var$makeCamelCase(item.key)]: item.value
        })).reduce((prev, next)=>({
            ...prev,
            ...next
        }));
    const dictionary = {
        ...menuItems.supportDialogDictionary,
        ...translations
    };
    const items = $d4f2220fd64bd165$export$4d0aa1f1e3f127b1(menuItems.allSupportDialogMenus, fallbackDomain);
    const chatType = $d4f2220fd64bd165$var$checkMenuItemsForChatType(items);
    return {
        content: items || [],
        chatType: chatType,
        labels: {
            openButton: dictionary?.openButton || $d4f2220fd64bd165$export$b21bb307e27a352e.openButton,
            closeButton: dictionary?.closeButton || $d4f2220fd64bd165$export$b21bb307e27a352e.closeButton,
            backButton: dictionary?.backButton || $d4f2220fd64bd165$export$b21bb307e27a352e.closeButton,
            consentButton: dictionary?.consentButton || $d4f2220fd64bd165$export$b21bb307e27a352e.consentButton,
            chatStatusLoading: dictionary?.loadingChatButton || $d4f2220fd64bd165$export$b21bb307e27a352e.chatStatusLoading,
            consentDialogText: dictionary?.consentDialogText || $d4f2220fd64bd165$export$b21bb307e27a352e.consentDialogText,
            chatStatusOnline: dictionary?.chatStatusOnline || $d4f2220fd64bd165$export$b21bb307e27a352e.chatStatusOnline,
            chatStatusOffline: dictionary?.chatStatusOffline || $d4f2220fd64bd165$export$b21bb307e27a352e.chatStatusOffline,
            firstName: dictionary?.firstName || $d4f2220fd64bd165$export$b21bb307e27a352e.firstName,
            lastName: dictionary?.lastName || $d4f2220fd64bd165$export$b21bb307e27a352e.lastName,
            email: dictionary?.email || $d4f2220fd64bd165$export$b21bb307e27a352e.email
        }
    };
};


var $f24a6c0f784f8ad3$export$2e2bcd8739ae039 = (0, $d4f2220fd64bd165$export$91d66573ef213493);

















const $e3139fef3a909170$var$SupportDialogWrapper = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ onOpen: onOpen , onTop: onTop = false , onClose: onClose , ariaLabels: ariaLabels , open: open = false , loading: loading = false , showConsentDialog: showConsentDialog , showIconButton: showIconButton = true , isSupportButtonVisible: isSupportButtonVisible = true , offset: offset , ...props }, ref)=>{
    const opacity = (0, $hgUW1$useMotionValue)(0);
    const [show, setShow] = (0, $hgUW1$useState)(open);
    const { name: name  } = (0, $hgUW1$useMediaQuery)();
    const isMobile = name === (0, $hgUW1$DeviceTypes).mobile;
    const [dialogHeightRef, dialogHeight] = (0, $hgUW1$useHeightCallback)();
    const [dialogWidthRef, dialogWidth] = (0, $hgUW1$useWidthCallback)();
    const dialogWidthWithSideSpacing = dialogWidth + dialogWidth * 0.25;
    const x = (0, $hgUW1$useMotionValue)(-1);
    const y = (0, $hgUW1$useMotionValue)(isMobile ? 100 : 0);
    const internalRef = (0, $hgUW1$useRef)();
    const { isKeyboardControlled: isKeyboardControlled  } = (0, $hgUW1$useInteractionMode)();
    const combinedRef = (0, $hgUW1$polestarcomponentwarehousereacthooksuseCombinedRef)(internalRef, ref, dialogWidthRef, dialogHeightRef);
    // prevent resets when useEffect is triggered but the dialogWidthWithSideSpacing is the same
    const previousDialogWidthWithSideSpacing = (0, $hgUW1$useRef)(dialogWidthWithSideSpacing);
    const iconButtonRef = (0, $hgUW1$useRef)(null);
    const { setFocusIconButton: setFocusIconButton  } = (0, $1972cb1a4960efb2$export$9804cccfc8dc0bb9)();
    const { isRTL: isRTL  } = (0, $hgUW1$useDirection)();
    const rtlMultiplier = isRTL ? -1 : 1;
    // TODO: implement - no animation?
    // const { isKeyboardControlled } = useInteractionMode();
    // const isReducedMotion = useReducedMotion();
    // const isDisabledMotion = isReducedMotion || isKeyboardControlled;
    // ensure that when closed the focus is restored to the icon button
    (0, $hgUW1$useFocusRestore)(open, {
        scrollIntoView: false
    });
    const handleIconButtonClick = (0, $hgUW1$useCallback)(()=>{
        onOpen?.();
    }, [
        onOpen
    ]);
    const handleCloseClick = (0, $hgUW1$useCallback)(()=>{
        onClose?.();
    }, []);
    // Register the open state to the ModalContext
    (0, $hgUW1$useModal)({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ref: internalRef,
        // only block scrolling on mobile
        open: isMobile && open,
        closeHandler: handleCloseClick
    });
    (0, $hgUW1$useEffect)(()=>{
        if (open) setShow(true);
    }, [
        open
    ]);
    (0, $hgUW1$useEffect)(()=>{
        if (name !== undefined && dialogHeight > 0) {
            if (isMobile) {
                if (open && dialogWidthWithSideSpacing > 0 && previousDialogWidthWithSideSpacing.current !== dialogWidthWithSideSpacing) {
                    previousDialogWidthWithSideSpacing.current = dialogWidthWithSideSpacing;
                    // breakpoint changed, reset position
                    x.set(0);
                    y.set(dialogHeight);
                }
                if (isKeyboardControlled) // direct rendering to prevent focus issues
                y.set(open ? 0 : dialogHeight);
                else (0, $hgUW1$animate)(y, open ? 0 : dialogHeight, {
                    ...(0, $hgUW1$Transitions).largeSurface,
                    duration: 0.6
                });
            } else {
                if (open && dialogWidthWithSideSpacing > 0 && previousDialogWidthWithSideSpacing.current !== dialogWidthWithSideSpacing) {
                    previousDialogWidthWithSideSpacing.current = dialogWidthWithSideSpacing;
                    // breakpoint changed, reset position
                    x.set(isMobile ? 100 : rtlMultiplier * dialogWidthWithSideSpacing);
                    y.set(0);
                }
                if (isKeyboardControlled) // direct rendering to prevent focus issues
                x.set(open ? 0 : isMobile ? 100 : rtlMultiplier * dialogWidthWithSideSpacing);
                else // on desktop the end position is different than on mobile
                (0, $hgUW1$animate)(x, open ? 0 : isMobile ? 100 : rtlMultiplier * dialogWidthWithSideSpacing, {
                    ...(0, $hgUW1$Transitions).largeSurface,
                    duration: 0.6
                });
            }
        }
    }, [
        dialogWidthWithSideSpacing,
        open,
        dialogWidth,
        dialogHeight
    ]);
    const xTransform = (0, $hgUW1$useTransform)(x, (val)=>{
        if (!open && !isMobile) {
            if (val === (isMobile ? 100 : rtlMultiplier * dialogWidthWithSideSpacing)) {
                // prevent issues when toggling between landscape / portrait
                opacity.set(0);
                if (show) setShow(false);
            } else if (opacity.get() === 0) opacity.set(1);
        }
        // on mobile we want the popover come from the bottom but keep the full width of the viewport and therefore we need to switch between units
        return `${val}${isMobile ? "%" : "px"}`;
    });
    const yTransform = (0, $hgUW1$useTransform)(y, (val)=>{
        if (!open && isMobile && val === dialogHeight) {
            // prevent issues when toggling between landscape / portrait
            opacity.set(0);
            if (show) setShow(false);
        } else if (opacity.get() === 0 && dialogHeight > 0) opacity.set(1);
        return `${val}px`;
    });
    const opacityTransform = (0, $hgUW1$useTransform)([
        x,
        opacity
    ], ([xVal, opacityVal])=>// prevent issue that dialog width is earlier know than the x-position is set
        (isRTL ? xVal < 1 : xVal > -1) && dialogWidthWithSideSpacing > 0 ? opacityVal : 0);
    const handleFocusIconButton = ()=>{
        if (isKeyboardControlled) (iconButtonRef.current?.firstChild?.firstChild)?.focus();
    };
    (0, $hgUW1$useEffect)(()=>{
        setFocusIconButton?.(handleFocusIconButton);
    }, [
        // necessary due to isKeyboardControlled is otherwise not influencing the handle function correctly
        isKeyboardControlled
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Portal), {
        zIndex: (0, $hgUW1$LayoutIndexes).popoverOutsidePortal - 1,
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$AnimatePresence), {
            children: /*#__PURE__*/ (0, $hgUW1$jsxs)($e3139fef3a909170$var$SupportWrapper, {
                show: show,
                "data-type": "wrapper",
                isSupportButtonVisible: isSupportButtonVisible,
                onTop: onTop,
                children: [
                    isMobile && open && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$polestarcomponentwarehousereactcomponentsbackdropBackdrop), {
                        onClose: handleCloseClick,
                        allowScroll: true,
                        visible: true,
                        withBackground: true,
                        zIndexBaseValue: (0, $hgUW1$LayoutIndexes).formModal
                    }, "support-dialog-backdrop"),
                    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5f0dbb7c18f85f01$export$2e2bcd8739ae039), {
                        ref: iconButtonRef,
                        loading: loading,
                        onClick: !!loading || !showIconButton ? undefined : handleIconButtonClick,
                        ariaLabelOpen: ariaLabels.openButton,
                        open: open,
                        visible: showIconButton,
                        offset: offset
                    }),
                    /*#__PURE__*/ (0, $hgUW1$jsx)($e3139fef3a909170$var$MotionWrapper, {
                        role: "menu",
                        style: {
                            translateX: xTransform,
                            translateY: yTransform,
                            opacity: opacityTransform
                        },
                        onTop: onTop,
                        children: show && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $5191fc15630cefd3$export$2e2bcd8739ae039), {
                            ref: combinedRef,
                            isMobile: isMobile,
                            ariaLabels: ariaLabels,
                            showConsentDialog: showConsentDialog,
                            loading: loading,
                            ...props,
                            onClose: handleCloseClick
                        })
                    }, `support-dialog-menu`)
                ]
            })
        })
    });
});
$e3139fef3a909170$var$SupportDialogWrapper.displayName = "SupportDialogWrapper";
var $e3139fef3a909170$export$2e2bcd8739ae039 = $e3139fef3a909170$var$SupportDialogWrapper;
const $e3139fef3a909170$var$SupportWrapper = (0, $hgUW1$emotionstyled).div(({ show: show , isSupportButtonVisible: isSupportButtonVisible , onTop: onTop = false  })=>(0, $hgUW1$css)((0, $hgUW1$css)`
        position: fixed;
        inset-block-end: 0;
        inset-inline-end: 0;
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
        pointer-events: none;
      `, onTop && (0, $hgUW1$css)`
          z-index: ${(0, $hgUW1$LayoutIndexes).modal + 1};
        `, !onTop && (0, $hgUW1$css)`
          z-index: ${(0, $hgUW1$LayoutIndexes).modal - 2};
        `, // wait until end of animation
    show && (0, $hgUW1$css)`
          width: 100%;

          ${(0, $hgUW1$MediaQueries).tablet} {
            width: unset;
          }
        `, isSupportButtonVisible && (0, $hgUW1$css)`
          opacity: 1;
          pointer-events: auto;
        `));
const $e3139fef3a909170$var$MotionWrapper = (0, $hgUW1$emotionstyled)((0, $hgUW1$m).div)(({ onTop: onTop = false  })=>(0, $hgUW1$css)((0, $hgUW1$css)`
      position: relative;
    `, onTop && (0, $hgUW1$css)`
        z-index: ${(0, $hgUW1$LayoutIndexes).modal + 1 + 1};
      `, !onTop && (0, $hgUW1$css)`
        z-index: ${(0, $hgUW1$LayoutIndexes).modal - 2 + 1};
      `));







const $935194a21c37b04b$var$supportDialogTheme = {
    supportDialog: {
        button: {
            states: {
                enabled: {
                    backgroundColor: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).ironGrey,
                    iconColor: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white,
                    color: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white
                },
                hover: {
                    backgroundColor: (0, $hgUW1$blend1)((0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).ironGrey, (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).black, (0, $hgUW1$polestarcomponentwarehousereacttokensopacitiesOpacities).low),
                    iconColor: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white,
                    color: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white
                },
                active: {
                    backgroundColor: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).ironGrey,
                    iconColor: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white,
                    color: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white
                },
                disabled: {
                    backgroundColor: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).ironGrey,
                    iconColor: (0, $hgUW1$withOpacity1)((0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white, (0, $hgUW1$polestarcomponentwarehousereacttokensopacitiesOpacities).low),
                    color: (0, $hgUW1$withOpacity1)((0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white, (0, $hgUW1$polestarcomponentwarehousereacttokensopacitiesOpacities).low)
                }
            }
        },
        dialog: {
            backgroundColor: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).ironGrey,
            color: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white,
            dividerColor: (0, $hgUW1$withOpacity1)((0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white, (0, $hgUW1$polestarcomponentwarehousereacttokensopacitiesOpacities).low),
            icons: {
                states: {
                    enabled: {
                        color: (0, $hgUW1$withOpacity1)((0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white, (0, $hgUW1$polestarcomponentwarehousereacttokensopacitiesOpacities).medium)
                    },
                    hover: {
                        color: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white
                    },
                    active: {
                        color: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white
                    },
                    disabled: {
                        color: (0, $hgUW1$withOpacity1)((0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white, (0, $hgUW1$polestarcomponentwarehousereacttokensopacitiesOpacities).low)
                    }
                }
            },
            button: {
                states: {
                    enabled: {
                        color: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white
                    },
                    hover: {
                        color: (0, $hgUW1$withOpacity1)((0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white, (0, $hgUW1$polestarcomponentwarehousereacttokensopacitiesOpacities).medium)
                    },
                    active: {
                        color: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white
                    },
                    disabled: {
                        color: (0, $hgUW1$withOpacity1)((0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white, (0, $hgUW1$polestarcomponentwarehousereacttokensopacitiesOpacities).medium)
                    }
                },
                status: {
                    online: {
                        color: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).success,
                        textColor: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white
                    },
                    busy: {
                        color: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).success,
                        textColor: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white
                    },
                    offline: {
                        color: (0, $hgUW1$withOpacity1)((0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white, (0, $hgUW1$polestarcomponentwarehousereacttokensopacitiesOpacities).low),
                        textColor: (0, $hgUW1$withOpacity1)((0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white, (0, $hgUW1$polestarcomponentwarehousereacttokensopacitiesOpacities).low)
                    },
                    loading: {
                        color: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white,
                        textColor: (0, $hgUW1$polestarcomponentwarehousereacttokenscolorsColors).white
                    }
                }
            }
        }
    }
};
var $935194a21c37b04b$export$2e2bcd8739ae039 = $935194a21c37b04b$var$supportDialogTheme;







const $b8a0a86fb7e17780$var$useOneTrustPopup = ()=>{
    const [popupOpen, setPopupOpen] = (0, $hgUW1$useState)(false);
    (0, $hgUW1$useEffect)(()=>{
        const banner = document.getElementById("onetrust-pc-sdk");
        let observer;
        if (banner) {
            observer = new MutationObserver(()=>{
                // If the banner’s display property changes or it’s removed, consider it "closed"
                if (banner.style.display === "none" || !document.body.contains(banner)) setPopupOpen(false);
                else setPopupOpen(true);
            });
            observer.observe(banner, {
                attributes: true,
                attributeFilter: [
                    "style"
                ]
            });
        }
        return ()=>{
            observer?.disconnect();
        };
    }, []);
    return popupOpen;
};
var $b8a0a86fb7e17780$export$2e2bcd8739ae039 = $b8a0a86fb7e17780$var$useOneTrustPopup;



const $8f649985e8a19246$var$SupportDialogConsent = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ consentDialogText: consentDialogText , consentLabel: consentLabel , onConsentClick: onConsentClick , ...props }, ref)=>{
    const oneTrustPopupOpen = (0, $b8a0a86fb7e17780$export$2e2bcd8739ae039)();
    const innerRef = (0, $hgUW1$useRef)(null);
    const combinedRef = (0, $hgUW1$useCombinedRef)(ref, innerRef);
    (0, $hgUW1$useFocusInitial)(innerRef, !oneTrustPopupOpen);
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$DarkThemeProvider), {
        children: /*#__PURE__*/ (0, $hgUW1$jsxs)("div", {
            ref: combinedRef,
            ...props,
            children: [
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Heading), {
                    children: consentDialogText
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Spacer), {
                    spacing: (0, $hgUW1$Spacings).large
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$SecondaryButton), {
                    onClick: ()=>{
                        onConsentClick();
                        (0, $cfc57243d48ecb76$export$46ee1d90b8d9465f)(consentLabel);
                    },
                    children: consentLabel
                }),
                /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Spacer), {
                    spacing: (0, $hgUW1$Spacings).xxxxxLarge
                })
            ]
        })
    });
});
$8f649985e8a19246$var$SupportDialogConsent.displayName = "SupportDialogConsent";
var $8f649985e8a19246$export$2e2bcd8739ae039 = $8f649985e8a19246$var$SupportDialogConsent;




// @ts-nocheck
const $ba3c96606fde63f1$export$a5205d19074d70f3 = `
    fragment OpeningTime on SharedSupportOpeningTimeRecord {
  __typename
  id
  opensAt
  closesAt
}
    `;
const $ba3c96606fde63f1$export$850437233957748b = `
    fragment OpeningTimeOpen24 on SharedSupportOpeningTimeOpen24hRecord {
  __typename
  id
}
    `;
const $ba3c96606fde63f1$export$9e71e0f9eb111d9c = `
    query sharedSupportOpeningTimetable($locale: SiteLocale!) {
  sharedSupportOpeningTimetable(locale: $locale) {
    __typename
    additionalInformation
    phoneNumber
    timezone
    chatOpeningHoursDiffer
    phoneOpeningTimeMonday {
      ...OpeningTimeOpen24
      ...OpeningTime
    }
    phoneOpeningTimeTuesday {
      ...OpeningTimeOpen24
      ...OpeningTime
    }
    phoneOpeningTimeWednesday {
      ...OpeningTimeOpen24
      ...OpeningTime
    }
    phoneOpeningTimeThursday {
      ...OpeningTimeOpen24
      ...OpeningTime
    }
    phoneOpeningTimeFriday {
      ...OpeningTimeOpen24
      ...OpeningTime
    }
    phoneOpeningTimeSaturday {
      ...OpeningTimeOpen24
      ...OpeningTime
    }
    phoneOpeningTimeSunday {
      ...OpeningTimeOpen24
      ...OpeningTime
    }
    chatOpeningTimeMonday {
      ...OpeningTimeOpen24
      ...OpeningTime
    }
    chatOpeningTimeTuesday {
      ...OpeningTimeOpen24
      ...OpeningTime
    }
    chatOpeningTimeWednesday {
      ...OpeningTimeOpen24
      ...OpeningTime
    }
    chatOpeningTimeThursday {
      ...OpeningTimeOpen24
      ...OpeningTime
    }
    chatOpeningTimeFriday {
      ...OpeningTimeOpen24
      ...OpeningTime
    }
    chatOpeningTimeSaturday {
      ...OpeningTimeOpen24
      ...OpeningTime
    }
    chatOpeningTimeSunday {
      ...OpeningTimeOpen24
      ...OpeningTime
    }
    specialOpeningTimes {
      __typename
      ... on SharedSupportSpecialOpeningTimeRecord {
        id
        closesAt
        dateFrom
        dateThrough
        opensAt
        closesAt
      }
    }
  }
}
    ${$ba3c96606fde63f1$export$850437233957748b}
${$ba3c96606fde63f1$export$a5205d19074d70f3}`;
function $ba3c96606fde63f1$export$68dbe58f97d98fc5(requester) {
    return {
        sharedSupportOpeningTimetable (variables, options) {
            return requester($ba3c96606fde63f1$export$9e71e0f9eb111d9c, variables, options);
        }
    };
}


const $eb49702561260604$export$f82dd445eb8edde6 = (openingTime)=>{
    if (!openingTime.opensAt || !openingTime.closesAt) return {
        isClosedAllDay: true
    };
    return {
        opensAt: openingTime.opensAt,
        closesAt: openingTime.closesAt
    };
};
const $eb49702561260604$export$12c6aec4b567d0ab = (dayArray)=>{
    // We assume that there is only one opening time per day
    const day = dayArray[0];
    if (day?.__typename === "SharedSupportOpeningTimeOpen24hRecord") return {
        isOpenAllDay: true,
        isClosedAllDay: false
    };
    if (day?.__typename === "SharedSupportOpeningTimeRecord") return $eb49702561260604$export$f82dd445eb8edde6(day);
    return {
        isClosedAllDay: true
    };
};
const $eb49702561260604$export$ffb3d0046ef3a2 = (date)=>{
    if (!`${date}`.match(/^\d{4}-\d{1,2}-\d{1,2}$/)) throw new Error(`Unsupported date format, expecting YYYY-MM-DD, got "${date}"`);
    return date;
};
const $eb49702561260604$export$cc951e5e56e9816 = (openingTime)=>{
    const { dateFrom: dateFrom , dateThrough: dateThrough  } = openingTime;
    return {
        ...dateFrom && {
            fromDate: $eb49702561260604$export$ffb3d0046ef3a2(dateFrom)
        },
        ...dateThrough && {
            toDate: $eb49702561260604$export$ffb3d0046ef3a2(dateThrough)
        },
        ...$eb49702561260604$export$f82dd445eb8edde6(openingTime)
    };
};
const $eb49702561260604$export$c5c995d110a71336 = ({ timezone: timezone , chatOpeningHoursDiffer: chatOpeningHoursDiffer , phoneOpeningTimeMonday: phoneOpeningTimeMonday , phoneOpeningTimeTuesday: phoneOpeningTimeTuesday , phoneOpeningTimeWednesday: phoneOpeningTimeWednesday , phoneOpeningTimeThursday: phoneOpeningTimeThursday , phoneOpeningTimeFriday: phoneOpeningTimeFriday , phoneOpeningTimeSaturday: phoneOpeningTimeSaturday , phoneOpeningTimeSunday: phoneOpeningTimeSunday , chatOpeningTimeMonday: chatOpeningTimeMonday , chatOpeningTimeTuesday: chatOpeningTimeTuesday , chatOpeningTimeWednesday: chatOpeningTimeWednesday , chatOpeningTimeThursday: chatOpeningTimeThursday , chatOpeningTimeFriday: chatOpeningTimeFriday , chatOpeningTimeSaturday: chatOpeningTimeSaturday , chatOpeningTimeSunday: chatOpeningTimeSunday , specialOpeningTimes: specialOpeningTimes  })=>{
    return {
        timezone: timezone,
        normalOpeningTimes: [
            /*
       * Weekdays are ordered from Sunday to Saturday
       * to match JavaScript's Date.getDay() index order:
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getDay
       */ $eb49702561260604$export$12c6aec4b567d0ab(chatOpeningHoursDiffer ? chatOpeningTimeSunday : phoneOpeningTimeSunday),
            $eb49702561260604$export$12c6aec4b567d0ab(chatOpeningHoursDiffer ? chatOpeningTimeMonday : phoneOpeningTimeMonday),
            $eb49702561260604$export$12c6aec4b567d0ab(chatOpeningHoursDiffer ? chatOpeningTimeTuesday : phoneOpeningTimeTuesday),
            $eb49702561260604$export$12c6aec4b567d0ab(chatOpeningHoursDiffer ? chatOpeningTimeWednesday : phoneOpeningTimeWednesday),
            $eb49702561260604$export$12c6aec4b567d0ab(chatOpeningHoursDiffer ? chatOpeningTimeThursday : phoneOpeningTimeThursday),
            $eb49702561260604$export$12c6aec4b567d0ab(chatOpeningHoursDiffer ? chatOpeningTimeFriday : phoneOpeningTimeFriday),
            $eb49702561260604$export$12c6aec4b567d0ab(chatOpeningHoursDiffer ? chatOpeningTimeSaturday : phoneOpeningTimeSaturday)
        ],
        specialOpeningTimes: specialOpeningTimes?.reduce((acc, openingTime)=>{
            if (openingTime.__typename === "SharedSupportSpecialOpeningTimeRecord") acc.push($eb49702561260604$export$cc951e5e56e9816(openingTime));
            return acc;
        }, [])
    };
};
const $eb49702561260604$var$getOpeningTimes = async (locale, environment)=>{
    const response = await (0, $4d7d019151bf18dc$export$e393c23e3e79fe52)((0, $ba3c96606fde63f1$export$9e71e0f9eb111d9c), environment, {
        locale: locale
    });
    if (!response.sharedSupportOpeningTimetable) throw new Error(`Failed to fetch opening times for chat: unexpected response: ${JSON.stringify(response)}`);
    return $eb49702561260604$export$c5c995d110a71336(response.sharedSupportOpeningTimetable);
};
var $eb49702561260604$export$2e2bcd8739ae039 = $eb49702561260604$var$getOpeningTimes;



var $cb1b605f753cb90f$export$2e2bcd8739ae039 = (0, $eb49702561260604$export$2e2bcd8739ae039);




const $8a31e91003e0f2d7$export$53148bfa4e677363 = (time)=>{
    const getDateTime = (time)=>{
        const date = new Date();
        const [hours, minutes] = time.split(".").map((t)=>parseInt(t, 10));
        date.setHours(0, minutes, 0, 0);
        date.setHours(hours);
        date.setMinutes(minutes);
        return date;
    };
    const getMilitaryDateTime = (time, isAm)=>{
        const date = new Date();
        const [hours, minutes] = time.split(".").map((t)=>parseInt(t, 10));
        date.setHours(0, minutes, 0, 0);
        if (isAm) {
            date.setHours(hours);
            return date;
        }
        date.setHours(hours === 12 ? 0 : hours + 12);
        return date;
    };
    // Format: 11.58
    if (/^(([0][0-9]|1[0-9]|2[0-3])(\.)[0-5][0-9]?)$/.test(time)) return getDateTime(time);
    else if (/^(([0][1-9]|1[0-2])(\.)[0-5][0-9]?(AM|PM))/.test(time)) return getMilitaryDateTime(time, time.toLocaleLowerCase().includes("am"));
    else if (/^(([0][1-9]|1[0-2])(\.)[0-5][0-9]?( AM| PM))/.test(time)) return getMilitaryDateTime(time, time.toLocaleLowerCase().includes("am"));
    return undefined;
};
const $8a31e91003e0f2d7$export$31869b2f35614cb5 = (specialOpeningTime)=>{
    const currentDay = (0, $hgUW1$format)(new Date(), "yyyy-MM-dd");
    return specialOpeningTime.find((openingTime)=>{
        if (!openingTime?.fromDate || !openingTime?.toDate) return false;
        return openingTime.fromDate <= currentDay && openingTime.toDate >= currentDay;
    });
};
/**
 * Checks opening hours and returns true if you are within the opening times.
 * If not, it returns false.
 */ const $8a31e91003e0f2d7$var$getIsChatOpen = (parsedSupportOpeningTimetable)=>{
    if (!parsedSupportOpeningTimetable) return false;
    const weekday = new Date().getDay();
    const openingHours = parsedSupportOpeningTimetable.normalOpeningTimes[weekday];
    const activeSpecialOpeningHours = $8a31e91003e0f2d7$export$31869b2f35614cb5(parsedSupportOpeningTimetable.specialOpeningTimes);
    const today = activeSpecialOpeningHours || openingHours;
    if (today?.isOpenAllDay) return true;
    if (today?.isClosedAllDay) return false;
    if (!today || today.isClosedAllDay || !parsedSupportOpeningTimetable.timezone || !today.opensAt || !today.closesAt) return false;
    const startDate = $8a31e91003e0f2d7$export$53148bfa4e677363(today.opensAt);
    const endDate = $8a31e91003e0f2d7$export$53148bfa4e677363(today.closesAt);
    if (startDate && endDate) {
        const utcStartDate = (0, $hgUW1$zonedTimeToUtc)(startDate, parsedSupportOpeningTimetable.timezone);
        const utcEndDate = (0, $hgUW1$zonedTimeToUtc)(endDate, parsedSupportOpeningTimetable.timezone);
        return (0, $hgUW1$isWithinInterval)(new Date(), {
            start: utcStartDate,
            end: utcEndDate
        });
    }
    return false;
};
var $8a31e91003e0f2d7$export$2e2bcd8739ae039 = $8a31e91003e0f2d7$var$getIsChatOpen;



var $99c6dd255cd875dc$export$2e2bcd8739ae039 = (0, $8a31e91003e0f2d7$export$2e2bcd8739ae039);




// we use global styles to customize the Salesforce chat window
const $4f516b8bb7114aea$export$aa0e86c7c0d2f400 = (0, $hgUW1$css)`
  :root {
    /** Colors **/
    --signalWhite: rgb(236, 236, 231);
    --agatheGrey: rgb(177, 179, 179);
    --greyNurse: rgb(200, 201, 199);
    --ironGrey: rgb(83, 86, 90);
    --ironGrey60: rgb(109, 111, 115);
    --stormGrey: rgb(117, 120, 123);
    --graphiteBlack: rgb(16, 24, 32);
    --graphiteBlack60: rgba(16, 24, 32, 0.6);
    --graphiteBlack15: rgba(16, 24, 32, 0.15);
    --greyWhite: #d9d9d6;
    --graphiteBlackWhite15: #343b41;
    --offlineRed: #e03c31;
    --onlineGreen: #00e676;
    --iconStrokeConfig: rgb(16, 24, 32);
    --iconStrokeMyorder: rgb(255, 255, 255);

    /** Sizes **/
    --base-fontSize: 16px;
    --base-lineHeight: 18px;
    --lwc-sidebarWidth: 360px;

    /** Icons **/
    --upload-dark-icon: url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' style='enable-background:new 0 0 24 24;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23101820;%7D%0A%3C/style%3E%3Cpath class='st0' d='M11.2,7.4v9.1h1.5V7.4l4.2,4.2l1.1-1.1l-6-6l-6,6l1.1,1.1L11.2,7.4z M18,18H6v1.5h12V18z'/%3E%3C/svg%3E");
    --upload-light-icon: url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' style='enable-background:new 0 0 24 24;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cpath class='st0' d='M11.2,7.4v9.1h1.5V7.4l4.2,4.2l1.1-1.1l-6-6l-6,6l1.1,1.1L11.2,7.4z M18,18H6v1.5h12V18z'/%3E%3C/svg%3E");
    --minimize-icon: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M24 20H8V22H24V20Z' fill='white'/%3E%3C/svg%3E ");
    --close-icon-light: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M22.3601 20.95L17.4101 16L22.3601 11.05L20.9501 9.64001L16.0001 14.59L11.0501 9.64001L9.64014 11.05L14.5901 16L9.64014 20.95L11.0501 22.36L16.0001 17.41L20.9501 22.36L22.3601 20.95Z' fill='white'/%3E%3C/svg%3E%0A");
    --arrow-orange-icon: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 18L13.0575 16.9425L8.865 12.75H18V11.25H8.865L13.0575 7.0575L12 6L6 12L12 18Z' fill='%23FF7500'/%3E%3C/svg%3E ");
    --download-icon: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18 10.5L16.9425 9.4425L12.75 13.635V4.5H11.25V13.635L7.0575 9.4425L6 10.5L12 16.5L18 10.5Z' fill='%23FF7500'/%3E%3Cpath d='M18 18H6V19.5H18V18Z' fill='%23FF7500'/%3E%3C/svg%3E%0A");
    --file-remove-icon: url("data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.76998 8.71248L6.05748 4.99998L9.76998 1.28748L8.71248 0.22998L4.99998 3.94248L1.28748 0.22998L0.22998 1.28748L3.94248 4.99998L0.22998 8.71248L1.28748 9.76998L4.99998 6.05748L8.71248 9.76998L9.76998 8.71248Z' fill='%23101820'/%3E%3C/svg%3E");
    --file-icon: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 23.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 32' style='enable-background:new 0 0 24 32;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23D9D9D6;%7D .st1%7Bfill:%23B1B3B3;%7D%0A%3C/style%3E%3Cpath class='st0' d='M0,32h24V8l-8-8H0V32z'/%3E%3Cpath class='st1' d='M16,0l8,8h-8V0z'/%3E%3C/svg%3E%0A");
  }

  /** Code style overrides **/

  /* Fixes chat UI modal buttons (minimize, close) from being hidden on iOS */
  html embeddedservice-chat-header lightning-icon {
    display: block;
    width: 20px;
    height: 20px;
  }

  html .embeddedServiceSidebarButton:focus {
    box-shadow: none;
  }

  html .embeddedServiceLiveAgentStateWaiting .waitingStateButtonContainer,
  html .embeddedServiceLiveAgentStateWaiting .waitingStateContent {
    padding: 0 16px;
  }

  html .embeddedServiceSidebarState button.slds-m-left_x-small,
  html .embeddedServiceLiveAgentStateChat .endChatContainer .endChatButton,
  html .embeddedServiceSidebarState button,
  html .embeddedServiceSidebarButton {
    cursor: pointer;
    transition: background-color 0.25s ease;
    background: var(--ironGrey) none;
    border-radius: 0px;
    border: none;
    padding: 15px 73px 15px 24px;
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
    color: white;
    font-weight: normal;
    display: block;
    width: auto;
    height: auto;
  }

  html .embeddedServiceSidebarState button.slds-m-left_x-small:hover,
  html .embeddedServiceLiveAgentStateChat .endChatContainer .endChatButton:hover,
  html .embeddedServiceSidebarState button:hover,
  html .embeddedServiceSidebarButton:hover {
    background-color: var(--ironGrey60);
  }

  html .embeddedServiceSidebarButton .label {
    color: white;
  }

  html .embeddedServiceSidebarButton:not(:disabled):focus,
  html .embeddedServiceSidebarButton:not(:disabled):hover {
    text-decoration: none;
  }

  html .embeddedServiceSidebarButton.dialog-button-0 .label {
    color: white;
  }

  html .embeddedServiceSidebarButton.uiButton--inverse .label,
  html .endChatButton.saveTranscriptButton.uiButton--inverse,
  html .embeddedServiceSidebarButton.dialog-button-1 .label {
    color: var(--graphiteBlack);
    transition: color 0.2s ease;
    display: flex;
    align-items: center;
  }

  html .embeddedServiceSidebarButton.uiButton--inverse:hover .label,
  html .endChatButton.saveTranscriptButton.uiButton--inverse:hover,
  html .embeddedServiceSidebarButton.dialog-button-1:hover .label {
    color: var(--graphiteBlack60);
  }

  html .embeddedServiceSidebarButton.dialog-button-1 .label:focus {
    outline: none;
  }

  html .embeddedServiceSidebarButton.uiButton--inverse .label::before,
  html .embeddedServiceSidebarButton.dialog-button-1 .label::before {
    content: "";
    display: inline-block;
    background-image: var(--arrow-orange-icon);
    height: 24px;
    width: 24px;
    margin-inline-end: 2px;
  }

  html .embeddedServiceSidebarButton.waitingCancelChat .label::before {
    display: none;
  }

  html .embeddedServiceLiveAgentStateChat .messageArea:focus {
    border: none;
  }

  html .embeddedServiceSidebarDialogState .dialogButtonContainer {
    padding: 0 16px 24px;
  }

  /* form input */
  html .slds-card__body {
    margin-top: 8px;
  }

  html .embeddedServiceSidebarState button.slds-m-left_x-small {
    margin: 24px 0 0 12px;
  }

  html [lightning-input_input-host] {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }

  html label[lightning-input_input] {
    text-align: start;
    padding-inline-start: 16px;
    color: var(--graphiteBlack60);
    margin-top: 24px;
  }

  html .slds-card__body slot div:first-of-child label[lightning-input_input] {
    margin-top: 0;
  }

  html input[lightning-input_input] {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid var(--graphiteBlack60);
    border-radius: 0px;
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
    height: 32px;
    align-self: center;
    width: calc(100% - 32px);
    margin: 0 16px;
    box-sizing: border-box;
    padding: 0;
  }

  html .slds-form-element__help {
    text-align: start;
    padding-inline-start: 16px;
    padding-top: 4px;
    color: var(--graphiteBlack60);
  }

  html input[lightning-input_input]:focus {
    outline: none;
  }

  /* Chat announcement */
  html .sidebarHeader[embeddedService-chatHeader_chatHeader] {
    background-color: var(--graphiteBlackWhite15);
  }

  html .announcement[embeddedService-chatHeaderAnnouncement_chatHeaderAnnouncement] {
    background: white;
    color: var(--stormGrey);
    margin-inline-start: 1px;
    width: calc(100% - 2px);
  }

  html .embeddedServiceSidebarMinimizedDefaultUI.newMessage,
  html .embeddedServiceSidebarMinimizedDefaultUI.minimizedContainer:focus,
  html .embeddedServiceSidebarMinimizedDefaultUI.newMessage:focus {
    background-color: var(--graphiteBlackWhite15);
    text-decoration: none;
  }

  /* close and minimise buttons */
  html button.closeButton[embeddedService-chatHeader_chatHeader] {
    cursor: pointer;
    padding: 0;
  }

  html button[embeddedService-chatHeader_chatHeader] {
    cursor: pointer;
    height: 32px;
    min-height: 32px;
    width: 32px;
    min-width: 32px;
    padding: 0;
    margin: 0;
  }

  html button:hover[embeddedService-chatHeader_chatHeader]:before,
  html button[embeddedService-chatHeader_chatHeader]::before {
    content: "";
    opacity: 1;
    display: block;
    height: 32px;
    width: 32px;
    background: var(--close-icon-light) transparent;
  }

  html button[embeddedService-chatHeader_chatHeader] svg {
    display: none;
  }

  html button:hover[embeddedService-chatHeader_chatHeader].minimizeButton::before,
  html button[embeddedService-chatHeader_chatHeader].minimizeButton::before {
    background: var(--minimize-icon) transparent;
  }

  html button[embeddedService-chatHeader_chatHeader].minimizeButton:focus {
    outline: none;
  }

  /* Agent icon background */
  html .embeddedServiceLiveAgentStateChatAvatar.isLightningOutContext .agentIconColor0 {
    background-color: var(--agatheGrey);
  }

  /* Agent icon container */
  html .embeddedServiceLiveAgentStateChatItem .isLightningOutContext .avatar {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 18px;
  }

  /* Agent chat text */
  html .embeddedServiceLiveAgentStateChatPlaintextMessageDefaultUI.plaintextContent {
    margin-inline-start: 50px;
  }

  /* Agent name/time */
  html .embeddedServiceLiveAgentStateChatItem.agent .agentName,
  html .embeddedServiceLiveAgentStateChatItem.agent .timeContent.onlyTimeDisplayed {
    margin-inline-start: 60px;
  }

  /* Customer time */
  html .embeddedServiceLiveAgentStateChatItem.chasitor .timeContent {
    margin-inline-end: 10px;
  }

  /* Agent chat bubble */
  html .embeddedServiceLiveAgentStateChatPlaintextMessageDefaultUI.agent.plaintextContent {
    background-color: transparent;
    border: 1px solid var(--greyWhite);
    color: var(--graphiteBlack);
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
    border-radius: 0;
  }

  /* Customer chat bubble */
  html .embeddedServiceLiveAgentStateChatBubble.chasitor .chatContent,
  html .embeddedServiceLiveAgentStateChatPlaintextMessageDefaultUI.chasitor.plaintextContent {
    background-color: var(--signalWhite);
    color: var(--graphiteBlack);
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
    border-radius: 0;
    padding: 12px;
  }

  /* Agent writing chat bubble */
  html .embeddedServiceLiveAgentStateChatBubble.agent .chatContent {
    margin: 0 0 2px 48px;
    border-radius: 0;
    background-color: var(--signalWhite);
    box-sizing: border-box;
  }

  html .embeddedServiceLiveAgentStateChatTypingIndicator .typingIndicatorBall {
    height: 6px;
    width: 6px;
  }

  /* Chat message container */
  html .embeddedServiceLiveAgentStateChatItem.chatMessage {
    padding: 0 16px;
    margin-bottom: 6px;
    overflow: visible;
  }

  html .embeddedServiceLiveAgentStateChatItem.chatMessage:last-of-type {
    margin-bottom: 16px;
  }

  /* chat dividers */
  html .embeddedServiceLiveAgentStateChatEventMessage .eventMessage:before,
  html .embeddedServiceLiveAgentStateChatEventMessage .eventMessage:after {
    display: none;
  }

  html .embeddedServiceLiveAgentStateChatEventMessage .eventMessage {
    font-size: 12px;
    line-height: 14px;
    color: var(--stormGrey);
  }

  html .embeddedServiceLiveAgentStateChat .endChatContainer {
    padding: 0;
  }

  /* Textarea chat input */
  html .embeddedServiceLiveAgentStateChatInputFooter .chasitorControls .uiInput {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid var(--graphiteBlack60);
    border-radius: 0px;
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
    height: 32px;
    align-self: center;
    margin-inline-end: 10px;
  }

  html .embeddedServiceLiveAgentStateChatInputFooter.dynamicResizeTextOneRow .chasitorText {
    min-height: 32px;
    padding: 0 8px;
  }

  html .embeddedServiceLiveAgentStateChatInputFooter.dynamicResizeTextTwoRows .chasitorText {
    height: 50px;
    min-height: 50px;
  }

  html .embeddedServiceLiveAgentStateChatInputFooter.dynamicResizeTextThreeRows .chasitorText,
  html
    .embeddedServiceLiveAgentStateChatInputFooter.dynamicResizeTextMoreThanThreeRows
    .chasitorText {
    height: 88px;
    min-height: 88px;
  }

  html
    .embeddedServiceLiveAgentStateChatInputFooter.dynamicResizeTextMoreThanThreeRows
    .chasitorText {
    overflow-y: scroll;
  }

  html .embeddedServiceLiveAgentStateChatInputFooter .chasitorText {
    padding: 6px 8px 6px 0px;
    margin: 0 0 0 8px;
  }

  html .embeddedServiceLiveAgentStateChatInputFooter .chasitorControls .uiInput::placeholder {
    color: var(--graphiteBlack60);
  }

  html .embeddedServiceLiveAgentStateChatInputFooter .chasitorControls {
    margin: 8px 16px 8px 8px;
  }

  /* Bottom bar container */
  html .embeddedServiceLiveAgentStateChat .chasitorInputWrapper {
    background-color: var(--signalWhite);
  }

  /* burger icon */
  html
    .embeddedServiceLiveAgentStateChatInputFooter
    .footerMenuWrapper
    .footer-menu
    .slds-button_icon-container-more {
    display: none;
  }

  /* prechat form */
  html .embeddedServiceLiveAgentSidebarFeature lightning-button .slds-button {
    background: var(--ironGrey) none;
    transition: background-color 0.2s ease;
    border-radius: 0px;
    border: none;
    padding: 15px 73px 15px 24px;
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
    color: white;
    font-weight: normal;
    width: 100%;
    text-align: start;
  }

  html .embeddedServiceLiveAgentSidebarFeature lightning-button .slds-button:hover {
    background-color: var(--ironGrey60);
  }

  html .embeddedServiceLiveAgentSidebarFeature lightning-button {
    display: flex;
    margin: 16px 16px 0;
  }

  html .embeddedServiceLiveAgentSidebarFeature .slds-text-heading_small.slds-truncate {
    display: none;
  }

  /* chat small text for start time and name */
  html .embeddedServiceLiveAgentStateChat .chatSessionStartTime,
  html .embeddedServiceLiveAgentStateChat .nameAndTimeContent {
    font-size: 12px;
    line-height: 14px;
    color: var(--stormGrey);
    padding-top: 4px;
  }

  /* next in queue messaging */
  html .embeddedServiceLiveAgentStateWaiting .waitingGreeting {
    padding-bottom: 0;
    padding-top: 20px;
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
  }

  html .embeddedServiceLiveAgentQueuePosition .queuePositionMessage {
    margin: 0 0 32px 0;
  }

  html .embeddedServiceSidebarDialogState #dialogTextBody {
    font-size: 16px;
  }

  /* Service help button */
  html .embeddedServiceSidebar.modalContainer {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
  html .embeddedServiceHelpButton {
    z-index: 99;
  }
  html .embeddedServiceSidebar.layout-docked .dockableContainer,
  html body .embeddedServiceHelpButton .helpButton .uiButton,
  html .embeddedServiceSidebarMinimizedDefaultUI {
    background-color: var(--graphiteBlackWhite15);
    border-radius: 0;
    box-shadow: none;
  }

  html .embeddedServiceSidebarMinimizedDefaultUI.helpButton,
  html .embeddedServiceSidebarMinimizedDefaultUI.helpButton:hover {
    background-color: var(--graphiteBlackWhite15);
    border: none;
  }

  html .embeddedServiceSidebar.layout-docked .embeddedServiceHelpButton .helpButton .uiButton,
  html .embeddedServiceHelpButton .helpButton .uiButton,
  html .embeddedServiceSidebar.layout-docked .embeddedServiceSidebarMinimizedDefaultUI {
    width: auto;
    min-width: 144px;
    max-width: none;
    height: 48px;
    background-color: var(--graphiteBlackWhite15);
    border-radius: 0;
  }

  html
    .embeddedServiceSidebar.layout-docked
    .embeddedServiceSidebarMinimizedDefaultUI:not(.waiting)
    .minimizedText {
    flex-direction: row;
  }

  html .embeddedServiceHelpButton .helpButton .helpButtonEnabled:hover::before,
  html .embeddedServiceHelpButton .helpButton .helpButtonEnabled:focus::before {
    display: none;
  }

  html .embeddedServiceSidebarMinimizedDefaultUI.sidebarHeader,
  html .embeddedServiceSidebarMinimizedDefaultUI,
  html .embeddedServiceHelpButton .helpButton,
  html .embeddedServiceSidebar.layout-docked .dockableContainer {
    max-width: calc(100% - 4vw);
    inset-inline-end: 2vw;
    inset-block-end: 2vw;
    margin: 0;
    inset-inline-start: auto;
  }

  @media (min-width: 768px) {
    html .embeddedServiceSidebarMinimizedDefaultUI.sidebarHeader,
    html .embeddedServiceSidebarMinimizedDefaultUI,
    html .embeddedServiceHelpButton .helpButton,
    html .embeddedServiceSidebar.layout-docked .dockableContainer {
      max-width: calc(100% - 24px);
      inset-inline-end: 12px;
      inset-block-end: 12px;
      margin-inline-start: 0;
    }
  }

  @media (min-width: 960px) {
    html .embeddedServiceSidebarMinimizedDefaultUI.sidebarHeader,
    html .embeddedServiceSidebarMinimizedDefaultUI,
    html .embeddedServiceHelpButton .helpButton,
    html .embeddedServiceSidebar.layout-docked .dockableContainer {
      max-width: calc(100% - 32px);
      inset-inline-end: 16px;
      inset-block-end: 16px;
    }
  }

  /** fix mobile bug where SF applies styles in different order **/
  html .embeddedServiceSidebar.layout-docked .dockableContainer {
    max-width: calc(100% - 4vw);
    height: calc(100% - 4vw);
    width: calc(100% - 4vw);
  }

  @media (min-width: 600px) {
    html .embeddedServiceSidebar.layout-docked .dockableContainer {
      max-width: var(--lwc-sidebarHeight, 360px);
      max-height: var(--lwc-sidebarHeight, 498px);
    }
  }
  /** END fix mobile bug where SF applies styles in different order **/

  html .embeddedServiceSidebarMinimizedDefaultUI.helpButton .messageContent {
    justify-content: flex-start;
  }

  html .embeddedServiceSidebarMinimizedDefaultUI .embeddedServiceIcon {
    display: none;
  }

  html .embeddedServiceHelpButton .embeddedServiceIcon {
    display: none !important;
  }

  html .embeddedServiceHelpButton .uiButton .helpButtonLabel {
    justify-content: flex-start;
    text-decoration: none;
  }

  html .embeddedServiceHelpButton .uiButton .helpButtonLabel > .message {
    background: none;
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
    color: white;
    border: none;
    margin: 0;
  }

  /* body grey outline */
  html .embeddedServiceSidebar .sidebarBody {
    border: 1px solid var(--greyNurse);
    border-top: none;
    box-sizing: border-box;
  }

  html .embeddedServiceLiveAgentSidebarFeature {
    width: 100%;
  }

  html .embeddedServiceLiveAgentSidebarFeature p {
    text-align: start;
    margin: 24px 16px;
  }

  /* minimised chat tab */
  html .embeddedServiceSidebarMinimizedDefaultUI {
    background: var(--graphiteBlackWhite15);
    box-shadow: none;
    border: none;
    height: 48px;
  }

  html .embeddedServiceSidebarMinimizedDefaultUI .minimizedImage {
    display: none;
  }

  html .embeddedServiceSidebarMinimizedDefaultUI .minimizedText > .message {
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
    font-weight: normal;
    color: white;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
  }

  html .embeddedServiceSidebarMinimizedDefaultUI .messageContent {
    justify-content: flex-start;
  }

  /* loading screen */
  html .loadingBall {
    display: none !important;
  }

  /* Queue position message */
  html .queuePositionMessage p {
    margin-inline-start: 0;
    margin-bottom: 0;
  }

  /* chat bubble padding */
  html .embeddedServiceLiveAgentStateChatPlaintextMessageDefaultUI.plaintextContent {
    padding: 12px;
  }

  /* chat bubble icon*/
  html .embeddedServiceLiveAgentStateWaiting .embeddedServiceLiveAgentQueuePosition {
    margin: 0;
  }

  html .embeddedServiceLiveAgentQueuePosition .queuePositionChatIcon {
    display: none;
  }

  /* Large number for queue position - cannot access so style whole container */
  html .embeddedServiceSidebarState.embeddedServiceLiveAgentStateWaiting * {
    font-size: var(--base-fontSize) !important;
    line-height: var(--base-lineHeight) !important;
    text-align: start;
    margin-top: 0;
  }

  /* loading screen text */
  html .embeddedServiceLiveAgentStateWaiting .waitingGreetingContent {
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
    text-align: start;
    margin-bottom: 16px;
  }

  html .embeddedServiceLiveAgentQueuePosition.queuePositionWaiting .youAreNextMessage {
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
    line-height: 18px;
    text-align: start;
    margin: 0 0 18px 0;
  }

  html .embeddedServiceLiveAgentQueuePosition .queuePositionMessage {
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
    text-align: start;
    color: var(--stormGrey);
  }

  html .embeddedServiceLiveAgentStateWaiting .embeddedServiceLiveAgentQueuePosition {
    align-self: flex-start;
  }

  /* leave chat screen */
  html .embeddedServiceSidebarDialogState .dialogTextContainer {
    justify-content: flex-start;
    flex-grow: 0;
    padding: 0 16px;
  }

  html .embeddedServiceSidebarDialogState #dialogTextBody {
    padding: 0;
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
    text-align: start;
    color: var(--stormGrey);
    margin: 0;
  }

  html .embeddedServiceSidebarDialogState #dialogTextTitle {
    text-align: start;
    font-weight: normal;
    color: var(--graphiteBlack);
    margin: 24px 0 16px;
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
  }

  html .embeddedServiceSidebarMinimizedDefaultUI:not(.minimizedContainer),
  html .embeddedServiceSidebarDialogState .dialogButton.dialog-button-0 {
    background: var(--ironGrey) none;
    transition: background-color 0.2s ease;
    border-radius: 0;
    border: none;
    padding: 15px 73px 15px 24px;
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
    color: white;
    font-weight: normal;
    margin: 32px 0 16px;
    box-shadow: none;
    width: 100%;
  }

  html .embeddedServiceSidebarDialogState .dialogButton.dialog-button-0:hover {
    background-color: var(--ironGrey60);
  }

  html .embeddedServiceSidebarButton {
    height: auto;
  }

  /* waiting cancel chat */
  html .embeddedServiceSidebarButton.uiButton--inverse:not(:disabled):hover,
  html .waitingCancelChat.embeddedServiceSidebarButton,
  html .waitingCancelChat.embeddedServiceSidebarButton:focus,
  html .waitingCancelChat.embeddedServiceSidebarButton:hover {
    background: var(--graphiteBlack15) none !important;
    box-shadow: none;
    width: 100%;
  }

  html .endChatButton.saveTranscriptButton.uiButton--inverse,
  html .endChatButton.saveTranscriptButton.uiButton--inverse:not(:disabled):hover,
  html .dialogButton.uiButton--inverse:not(:disabled):hover,
  html .embeddedServiceSidebarButton.dialog-button-1:hover,
  html .embeddedServiceSidebarButton.dialog-button-1:focus {
    background: none !important;
    outline: none;
    box-shadow: none;
    padding-inline-start: 0px;
  }

  html .endChatButton.saveTranscriptButton.uiButton--inverse {
    display: none;
  }

  @media (min-width: 768px) {
    html .endChatButton.saveTranscriptButton.uiButton--inverse {
      display: flex;
    }
  }

  html .endChatButton.saveTranscriptButton.uiButton--inverse .label::before {
    display: none;
  }

  html .endChatButton.saveTranscriptButton.uiButton--inverse::after {
    content: "";
    display: inline-block;
    height: 24px;
    width: 24px;
    margin-inline-start: 4px;
    background-image: var(--download-icon);
  }

  html .waitingCancelChat.embeddedServiceSidebarButton .label {
    color: var(--graphiteBlack);
  }

  html .waitingCancelChat.embeddedServiceSidebarButton:hover .label {
    color: var(--graphiteBlack60);
  }

  /* No agents available */
  html .embeddedServiceSidebarButton .label,
  html .embeddedServiceSidebarButton:disabled .label {
    text-align: start;
  }

  html .embeddedServiceSidebarDialogState .dialogButton {
    background: none;
    padding: 0;
  }

  /* waiting state */
  html .embeddedServiceLiveAgentStateWaiting .waitingStateContent {
    justify-content: flex-start;
    flex-grow: 0;
  }

  /* down arrow for more messages */
  html
    .unseenMessageNotification[embeddedService-chatUnseenMessageNotification_chatUnseenMessageNotification] {
    inset-inline-start: 50%;
    transform: translate3d(-50%, 0, 0);
  }

  html
    .embeddedServiceLiveAgentStateChatInputFooter
    .unseenMessageNotificationWrapper
    .scrollDownButton
    .slds-button_icon-border {
    width: 24px;
    min-width: 24px;
    height: 24px;
    min-height: 24px;
    margin: auto;
    font-weight: normal;
    background: transparent;
    color: var(--greyNurse);
  }

  /* Download transcript */
  html .embeddedServiceLiveAgentStateChatInputFooter .footerMenuWrapper .footer-menu .slds-dropdown,
  html
    .embeddedServiceLiveAgentStateChatInputFooter
    .footerMenuWrapper
    .footer-menu-items
    .slds-dropdown__item,
  html .embeddedServiceLiveAgentStateChatInputFooter .footerMenuWrapper .footer-menu-items,
  html .embeddedServiceLiveAgentStateChatInputFooter .footerMenuWrapper .footer-menu-items:hover {
    border: none;
    box-shadow: none;
  }

  html
    .embeddedServiceLiveAgentStateChatInputFooter
    .footerMenuWrapper
    .footer-menu-items
    .slds-dropdown__item
    > a,
  html
    .embeddedServiceLiveAgentStateChatInputFooter
    .footerMenuWrapper
    .footer-menu-items
    .slds-dropdown__item
    > a:hover,
  html
    .embeddedServiceLiveAgentStateChatInputFooter
    .footerMenuWrapper
    .footer-menu-items
    .slds-dropdown__item
    > a:focus {
    background-color: var(--greyWhite);
    color: var(--graphiteBlack60);
    font-size: var(--base-fontSize);
    line-height: var(--base-lineHeight);
    border: none;
    box-shadow: none;
    justify-content: flex-start;
    text-align: start;
    padding-inline-start: 24px;
    height: 48px;
  }

  html
    .embeddedServiceLiveAgentStateChatInputFooter
    .footerMenuWrapper
    .footer-menu-items
    .slds-dropdown__item
    > a:focus {
    outline: none;
  }

  /** upload **/
  html .embeddedServiceLiveAgentStateChatInputFooter .footerMenuWrapper {
    display: none;
  }

  html .embeddedServiceLiveAgentStateChatInputFooter .chasitorControls .chatActionButton {
    padding: 0 8px;
    border: none;
    height: 100%;
    display: flex;
    align-items: center;
  }

  html .paperClipButton span.embeddedServiceIcon {
    width: 24px;
  }

  html .embeddedServiceLiveAgentStateChatAction.uiButton.small svg {
    height: 24px;
    width: 24px;
    visibility: hidden;
  }

  html .embeddedServiceLiveAgentStateChatAction.uiButton.small::before {
    content: "";
    display: inline-block;
    height: 24px;
    min-width: 24px;
    background: var(--file-remove-icon) center center no-repeat;
  }

  html .embeddedServiceLiveAgentStateChatInputFooter .chasitorControls .chatActionButton:hover {
    background: none;
  }

  html
    .embeddedServiceLiveAgentStateChatInputFooter
    .chasitorControls
    .fileInfo
    + button.chatActionButton {
    height: 40px;
    min-width: 40px;
    background: var(--ironGrey);
  }

  html
    .embeddedServiceLiveAgentStateChatInputFooter
    .chasitorControls
    .fileInfo
    + button.chatActionButton:hover {
    background-color: var(--ironGrey60);
  }

  html
    .embeddedServiceLiveAgentStateChatInputFooter
    .chasitorControls
    .fileInfo
    + button.chatActionButton::before {
    content: "";
    display: inline-block;
    background: var(--upload-light-icon) center center no-repeat;
    height: 24px;
    min-width: 24px;
  }

  html
    .embeddedServiceLiveAgentStateChatInputFooter
    .embeddedServiceLiveAgentStateChatAction.Upload
    svg {
    display: none;
  }

  html .fileInfo + .chatActionButton svg {
    visibility: hidden;
  }

  html
    .embeddedServiceLiveAgentStateChatAction.uiButton:not(:disabled):focus
    .embeddedServiceIcon:before {
    position: relative;
    inset-block-start: auto;
    inset-inline-start: auto;
    width: 24px;
    height: 24px;
    border-radius: 0;
    pointer-events: auto;
  }

  html .chatActionButton.paperClipButton .embeddedServiceIcon svg {
    visibility: hidden;
  }

  html .chatActionButton.paperClipButton .embeddedServiceIcon::before {
    content: "";
    display: inline-block;
    background-image: var(--upload-dark-icon);
    height: 24px;
    min-width: 24px;
  }

  html .embeddedServiceLiveAgentStateChat .endChatContainer .endChatButton {
    margin: 0 16px 16px;
  }

  @media (min-width: 768px) {
    html .embeddedServiceLiveAgentStateChat .endChatContainer .endChatButton {
      margin: 0 16px;
    }
  }

  html .embeddedServiceLiveAgentStateChatInputFooter .fileIcon svg {
    display: none;
  }

  html .embeddedServiceLiveAgentStateChatInputFooter .fileIcon::before {
    content: "";
    display: inline-block;
    background-image: var(--file-icon);
    height: 32px;
    min-width: 24px;
  }

  html .embeddedServiceLiveAgentStateChatFileTransferMessage .fileInfo span:nth-of-type(1),
  html .embeddedServiceLiveAgentStateChatInputFooter .fileName {
    color: var(--graphiteBlack);
    font-size: 16px;
    line-height: 18px;
  }

  html .embeddedServiceLiveAgentStateChatFileTransferMessage .fileInfo span:nth-of-type(2),
  html .embeddedServiceLiveAgentStateChatInputFooter .fileDescription {
    color: var(--stormGrey);
    font-size: 12px;
    line-height: 14px;
  }

  html .embeddedServiceLiveAgentStateChatFileTransferMessage .fileInfo {
    padding-inline-start: 10px;
  }

  html .embeddedServiceLiveAgentStateChatFileTransferMessage .fileIcon.embeddedServiceIcon {
    padding-top: 0;
  }

  html .embeddedServiceLiveAgentStateChatFileTransferMessage .fileIcon.embeddedServiceIcon::before {
    content: "";
    display: inline-block;
    background-image: var(--file-icon);
    height: 32px;
    min-width: 24px;
  }

  html .embeddedServiceLiveAgentStateChatFileTransferMessage .fileIcon.embeddedServiceIcon svg {
    display: none;
  }

  html .embeddedServiceLiveAgentStateChatInputFooter .fileTooLarge {
    justify-content: flex-start;
  }

  html .embeddedServiceLiveAgentStateChatInputFooter .fileTooLarge a:hover {
    text-decoration: none;
  }

  html .embeddedServiceLiveAgentStateChatInputFooter .fileTooLarge a:focus {
    outline: none;
  }

  html .embeddedServiceLiveAgentStateChatInputFooter .selectNewFile {
    color: var(--graphiteBlack);
    font-size: 16px;
    line-height: 18px;
    padding-inline-start: 6px;
  }

  /** remove image not found from safari **/
  html img[embeddedService-chatHeader_chatHeader] {
    display: none;
  }

  /** safari margin fix for upload button **/
  html
    .embeddedServiceLiveAgentStateChatInputFooter
    .embeddedServiceLiveAgentStateChatAction.Upload {
    margin-inline-end: 0;
  }

  html .embeddedServiceLiveAgentStateChatAction.uiButton:disabled svg {
    visibility: hidden;
  }

  /** colored chat icons  **/
  html .sidebarHeader .minimizedText::before,
  html .sidebarHeader h2::before,
  html .helpButtonLabel::before {
    content: "";
    height: 6px;
    width: 6px;
    border-radius: 50%;
    background-color: var(--onlineGreen);
    display: inline-block;
    margin: 0 8px 0 12px;
  }

  html .sidebarHeader h2 {
    display: flex;
    align-items: center;
  }

  html .sidebarHeader .minimizedText::before {
    margin: 0 12px 0 10px;
  }

  html .sidebarHeader h2::before {
    margin-inline-end: 12px;
  }

  html .helpButtonDisabled .helpButtonLabel::before {
    background-color: var(--offlineRed);
  }

  /** give more space to minimized button with offline/online icon**/
  html .embeddedServiceSidebarMinimizedDefaultUI .content {
    padding-inline-end: 18px;
  }
  /** hide the secondary queue position counter in the chat pop-up **/
  html .embeddedServiceLiveAgentQueuePosition.queuePositionWaiting .queuePositionNumber {
    display: none;
  }

  /* by default, hide the original button */
  body .embeddedServiceHelpButton .helpButton {
    visibility: hidden;
  }

  body .embeddedServiceHelpButton.ptm-cloned-chat-button .helpButton {
    visibility: visible;
  }

  .embeddedServiceHelpButton .helpButton .helpButtonDisabled {
    pointer-events: none;
  }

  /* Chat Button (cloned) STATIC */
  html .ptm-cloned-chat-button--static {
    position: static;
    margin: 16px 0px;
  }
  html .ptm-cloned-chat-button--static .helpButton {
    position: static;
    width: auto !important;
  }
  /* make sure this more specific than .embeddedServiceHelpButton which loads afterwards */
  html .ptm-cloned-chat-button--closed {
    display: none;
  }
  /* Chat Button (cloned) STATIC */

  /* Chat online status outside of chat buttons */
  html [data-track-button="support"] svg {
    border-radius: 0;
  }

  html [data-track-button="support"] + div {
    display: none;
  }

  html .ptm-chat-status-svg-dot {
    transition: fill 500ms;
    stroke: currentColor;
    fill: var(--offlineRed) !important;
  }
  html .ptm-chat-status-svg-dot--online {
    fill: var(--onlineGreen) !important;
  }
  /* Chat online status outside of chat buttons */

  /* Chat Button (cloned) Variant:TOP_LEFT */
  html .ptm-cloned-chat-button--top-left {
    position: relative;
    inset-inline-start: 0px;
    flex: 1 0 0%;
    margin: -12px 0;
  }
  html .ptm-cloned-chat-button--top-left .helpButton {
    position: relative;
    inset-inline-start: 0px;
    inset-block-start: 0px;
    margin-inline-start: 30px;
    display: inline-block;
  }
  @media (max-width: 400px) {
    html .ptm-cloned-chat-button--top-left .helpButton {
      margin-inline-start: 0;
    }
    html .ptm-cloned-chat-button--top-left .helpButton .uiButton {
      min-width: 105px;
      padding: 0;
    }
  }
  /* Chat Button (cloned) Variant:TOP_LEFT */
`;



const $1118485e44c25ac3$var$createOnAvailabilityEventHandler = (action)=>(event)=>{
        action(event.detail.data);
    };
/**
 * Checks if agent is available by listening to onAvailability event
 * which is triggered every 60 seconds.
 *
 * @returns { isAgentAvailable: { boolean } }
 */ const $1118485e44c25ac3$var$useOnAgentAvailabilityEvent = ({ consent: consent , chatInformation: chatInformation , isSettingsCallCompleted: isSettingsCallCompleted  })=>{
    const [isAgentAvailable, setIsAgentAvailableLocal] = (0, $hgUW1$useState)(false);
    // initial state is based on agentAvailableOnButtonClick
    (0, $hgUW1$useEffect)(()=>{
        setIsAgentAvailableLocal(!!window?.embedded_svc?.settings.agentAvailableOnButtonClick);
    }, [
        isSettingsCallCompleted
    ]);
    (0, $hgUW1$useEffect)(()=>{
        const handler = $1118485e44c25ac3$var$createOnAvailabilityEventHandler((data)=>{
            if (consent && chatInformation?.chatConfiguration) setIsAgentAvailableLocal(Boolean(data.isAgentAvailable));
        });
        // add event listener to check agent availability
        // this event will be fired every 60 seconds
        window.addEventListener("onAvailability", (event)=>{
            handler(event);
        });
        return ()=>{
            window.removeEventListener("onAvailability", handler);
        };
    }, [
        consent,
        chatInformation?.chatConfiguration
    ]);
    return {
        isAgentAvailable: isAgentAvailable
    };
};
var $1118485e44c25ac3$export$2e2bcd8739ae039 = $1118485e44c25ac3$var$useOnAgentAvailabilityEvent;



const $013481e95ece6feb$var$useOnSettingsCallCompletedEvent = ()=>{
    const [isSettingsCallCompleted, setIsSettingsCallCompleted] = (0, $hgUW1$useState)(false);
    const handler = (0, $hgUW1$useCallback)(()=>{
        setIsSettingsCallCompleted(true);
    }, []);
    (0, $hgUW1$useEffect)(()=>{
        window.addEventListener("onSettingsCallCompleted", handler);
        return ()=>{
            window.removeEventListener("onSettingsCallCompleted", handler);
        };
    }, []);
    return {
        isSettingsCallCompleted: isSettingsCallCompleted
    };
};
var $013481e95ece6feb$export$2e2bcd8739ae039 = $013481e95ece6feb$var$useOnSettingsCallCompletedEvent;



let $62ba562828888109$export$284f739ccaf06b2d;
(function(SupportDialogActionTypes) {
    SupportDialogActionTypes["SET_OPEN"] = "SET_OPEN";
    SupportDialogActionTypes["CLOSE_DIALOG"] = "CLOSE_DIALOG";
    SupportDialogActionTypes["SET_LOADING"] = "SET_LOADING";
    SupportDialogActionTypes["SET_LOADING_SALESFORCE_CHAT"] = "SET_LOADING_SALESFORCE_CHAT";
    SupportDialogActionTypes[/**
   * Salesforce only: show consent dialog to `Manage cookies` when no consent is given
   */ "SET_CONSENT_DIALOG"] = "SET_CONSENT_DIALOG";
    SupportDialogActionTypes["SET_MENU_ITEMS"] = "SET_MENU_ITEMS";
    SupportDialogActionTypes["SET_ICON_BUTTON"] = "SET_ICON_BUTTON";
    SupportDialogActionTypes["SET_INITIAL_DATA"] = "SET_INITIAL_DATA";
    SupportDialogActionTypes["HIDE_ICON_BUTTON_AND_CLOSE_MENU"] = "HIDE_ICON_BUTTON_AND_CLOSE_MENU";
    SupportDialogActionTypes[/**
   * Salesforce only: load OneTrust SDK
   */ "SET_ONETRUST_DIALOG"] = "SET_ONETRUST_DIALOG";
    SupportDialogActionTypes["SET_GENESYS_CHAT_ACTIVE"] = "SET_GENESYS_CHAT_ACTIVE";
    SupportDialogActionTypes["SET_CHAT_TYPE"] = "SET_CHAT_TYPE";
    SupportDialogActionTypes["UPDATE_OPEN_BUTTON_TEXT"] = "UPDATE_OPEN_BUTTON_TEXT";
})($62ba562828888109$export$284f739ccaf06b2d || ($62ba562828888109$export$284f739ccaf06b2d = {}));
const $62ba562828888109$export$d4c72bab9d6cc13a = {
    open: false,
    genesysChatActive: false,
    chatType: (0, $f2754c44a13f16ee$export$c87fd205be4f689b).salesforce,
    showPopover: false,
    loading: false,
    isLoadingSalesforceChat: false,
    chatInformation: null,
    showConsentDialog: false,
    ariaLabels: {
        openButton: "",
        closeButton: "",
        backButton: "",
        consentButton: "",
        consentDialogText: "",
        chatStatusOnline: "",
        chatStatusOffline: "",
        chatStatusLoading: "",
        firstName: "",
        lastName: "",
        email: ""
    },
    menuItems: [],
    showIconButton: true,
    showOnetrustDialog: false
};
const $62ba562828888109$var$parsePopoverVisibility = ({ open: open , chatType: chatType , genesysChatActive: genesysChatActive  })=>{
    if (chatType === (0, $f2754c44a13f16ee$export$c87fd205be4f689b).salesforce) return open;
    else return genesysChatActive === true ? true : open;
};
const $62ba562828888109$export$248353193ad0abbf = (state, action)=>{
    const newState = JSON.parse(JSON.stringify(state));
    switch(action.type){
        case $62ba562828888109$export$284f739ccaf06b2d.SET_OPEN:
            return {
                ...newState,
                open: action.payload,
                showPopover: $62ba562828888109$var$parsePopoverVisibility({
                    open: action.payload,
                    chatType: newState.chatType,
                    genesysChatActive: newState.genesysChatActive
                })
            };
        case $62ba562828888109$export$284f739ccaf06b2d.CLOSE_DIALOG:
            return {
                ...newState,
                open: false,
                showConsentDialog: false,
                showPopover: $62ba562828888109$var$parsePopoverVisibility({
                    open: false,
                    chatType: newState.chatType,
                    genesysChatActive: newState.genesysChatActive
                })
            };
        case $62ba562828888109$export$284f739ccaf06b2d.SET_LOADING:
            return {
                ...newState,
                loading: action.payload
            };
        case $62ba562828888109$export$284f739ccaf06b2d.SET_LOADING_SALESFORCE_CHAT:
            return {
                ...newState,
                isLoadingSalesforceChat: action.payload
            };
        case $62ba562828888109$export$284f739ccaf06b2d.SET_INITIAL_DATA:
            return {
                ...newState,
                chatInformation: action.payload.chatInformation,
                menuItems: action.payload.menuItems,
                ariaLabels: action.payload.ariaLabels
            };
        case $62ba562828888109$export$284f739ccaf06b2d.SET_CONSENT_DIALOG:
            return {
                ...newState,
                showConsentDialog: action.payload
            };
        case $62ba562828888109$export$284f739ccaf06b2d.SET_ONETRUST_DIALOG:
            return {
                ...newState,
                showOnetrustDialog: action.payload
            };
        case $62ba562828888109$export$284f739ccaf06b2d.SET_MENU_ITEMS:
            return {
                ...newState,
                menuItems: action.payload
            };
        case $62ba562828888109$export$284f739ccaf06b2d.SET_ICON_BUTTON:
            return {
                ...newState,
                showIconButton: action.payload
            };
        case $62ba562828888109$export$284f739ccaf06b2d.SET_CHAT_TYPE:
            return {
                ...newState,
                chatType: action.payload
            };
        case $62ba562828888109$export$284f739ccaf06b2d.SET_GENESYS_CHAT_ACTIVE:
            if (action.payload === true) // close whenever the chat is minimized
            newState.open = false;
            return {
                ...newState,
                genesysChatActive: action.payload,
                showPopover: $62ba562828888109$var$parsePopoverVisibility({
                    open: newState.open,
                    chatType: newState.chatType,
                    genesysChatActive: action.payload
                })
            };
        case $62ba562828888109$export$284f739ccaf06b2d.HIDE_ICON_BUTTON_AND_CLOSE_MENU:
            return {
                ...newState,
                isLoadingSalesforceChat: false,
                showIconButton: false,
                open: false,
                showPopover: $62ba562828888109$var$parsePopoverVisibility({
                    open: false,
                    chatType: newState.chatType,
                    genesysChatActive: newState.genesysChatActive
                })
            };
        default:
            return state;
    }
};
const $62ba562828888109$export$3ee49b4c70c0ec29 = (initialArg)=>initialArg;



const $463f2df074aed427$export$2c66f0d7b813d157 = (menuItems, consent, isChatOpen, isSettingsCallCompleted, isLoadingSalesforceChat)=>{
    return menuItems.map((menuItem)=>{
        // Skip if status is undefined
        if (menuItem.status === undefined) return menuItem;
        // Case: No cookie consent
        if (!consent) // status must be explicitly set to null because undefined will never pass the first test again
        return {
            ...menuItem,
            status: null
        };
        if (isChatOpen && !isSettingsCallCompleted) return {
            ...menuItem,
            status: (0, $5191fc15630cefd3$export$9354cf8072350acf).offline
        };
        if (isChatOpen && isSettingsCallCompleted && isLoadingSalesforceChat) return {
            ...menuItem,
            status: (0, $5191fc15630cefd3$export$9354cf8072350acf).loading
        };
        // Case: Online (agent availability is covered in the chat itself)
        if (isChatOpen && isSettingsCallCompleted) return {
            ...menuItem,
            status: (0, $5191fc15630cefd3$export$9354cf8072350acf).online
        };
        // Default case: Offline
        return {
            ...menuItem,
            status: (0, $5191fc15630cefd3$export$9354cf8072350acf).offline
        };
    });
};




const $8c84db282b492cea$var$otSdkStubSrc = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
/**
 * OneTrust ID information:
 * https://polestarjira.atlassian.net/wiki/spaces/Privacy/pages/2851897518/Add+a+cookie+banner+to+a+web+project
 */ const $8c84db282b492cea$var$htmlString = `
<script
src=${$8c84db282b492cea$var$otSdkStubSrc}
type="text/javascript"
charSet="UTF-8"
id="onetrust"
data-testid="onetrust"
data-domain-script="2b8f0235-bba3-48f8-b40b-77394cd12e03"
async
/>
<script async> function OptanonWrapper() {};</script>
`;
/**
 * Cookie banner documentation can be found here:
 https://polestarjira.atlassian.net/wiki/spaces/Privacy/pages/2783608892/Implementation+One+Trust+configuration
 */ const $8c84db282b492cea$var$CookieConsentFragment = ()=>{
    const divRef = (0, $hgUW1$useRef)(null);
    (0, $hgUW1$useEffect)(()=>{
        // @todo check how this behaviour changes when the script is already loaded, which should be the normal case
        // should this be loaded in head instead?
        // document.querySelector('script[src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"]');
        const isScriptLoaded = document?.querySelector(`script[src="${$8c84db282b492cea$var$otSdkStubSrc}"]`);
        if (divRef.current && !isScriptLoaded) {
            const fragment = document.createRange().createContextualFragment($8c84db282b492cea$var$htmlString);
            divRef?.current.append(fragment);
        }
    }, []);
    return /*#__PURE__*/ (0, $hgUW1$jsx)("div", {
        ref: divRef
    });
};
var $8c84db282b492cea$export$2e2bcd8739ae039 = $8c84db282b492cea$var$CookieConsentFragment;



const $7aeb0cf0b3a50b3f$var$loadAgentSrc = "https://c.la1-c2-lo2.salesforceliveagent.com/content/g/js/53.0/deployment.js";
const $7aeb0cf0b3a50b3f$var$loadLiveAgent = ()=>{
    const isScriptLoaded = document.querySelector(`script[src="${$7aeb0cf0b3a50b3f$var$loadAgentSrc}"]`);
    if (isScriptLoaded) return;
    const scriptElement = document.createElement("script");
    scriptElement.setAttribute("defer", "");
    scriptElement.setAttribute("src", $7aeb0cf0b3a50b3f$var$loadAgentSrc);
    scriptElement.onerror = ()=>{
        window.dispatchEvent(new CustomEvent("loadLiveAgentScriptError", {
            detail: {
                bubbles: true,
                composed: false
            }
        }));
    };
};
var $7aeb0cf0b3a50b3f$export$2e2bcd8739ae039 = $7aeb0cf0b3a50b3f$var$loadLiveAgent;


const $ef0309c2c1d33d42$var$salesforceChatSrc = {
    production: "https://polestar-crm.my.salesforce.com/embeddedservice/5.0/esw.min.js",
    development: "https://polestar-crm--staging.sandbox.my.salesforce.com/embeddedservice/5.0/esw.min.js"
};
// https://cleverbeagle.com/blog/articles/tutorial-how-to-load-third-party-scripts-dynamically-in-javascript
const $ef0309c2c1d33d42$var$startChat = async (chatConfiguration)=>{
    (0, $7aeb0cf0b3a50b3f$export$2e2bcd8739ae039)();
    // TODO: maybe also handle failures, for example because of adblockers
    return new Promise((resolve, reject)=>{
        const salesforceChatSrcEnvironment = $ef0309c2c1d33d42$var$salesforceChatSrc[chatConfiguration.environment];
        const isScriptLoaded = document.querySelector(`script[src="${salesforceChatSrcEnvironment}"]`);
        if (!isScriptLoaded) {
            const scriptElement = document.createElement("script");
            scriptElement.setAttribute("defer", "");
            scriptElement.setAttribute("src", salesforceChatSrcEnvironment);
            scriptElement.id = "salesforce-script";
            document.body.appendChild(scriptElement);
            /* @todo not sure if this is needed (currently used in .com we listen to this error on support page)
       */ scriptElement.onerror = ()=>{
                window.dispatchEvent(new CustomEvent("chatScriptError", {
                    detail: {
                        bubbles: true,
                        composed: false
                    }
                }));
                reject();
            };
            scriptElement.onload = async ()=>{
                if (!window?.embedded_svc) {
                    console.warn("Cannot instantiate chat, missing window.embedded_svc");
                    return;
                }
                /*
         * More information at https://developer.salesforce.com/docs/atlas.en-us.snapins_web_dev.meta/snapins_web_dev/snapins_web_overview.htm
         */ const settings = {
                    displayHelpButton: false,
                    enabledFeatures: [
                        "LiveAgent"
                    ],
                    entryFeature: "LiveAgent",
                    extraPrechatInfo: [
                        {
                            entityFieldMaps: [
                                {
                                    doCreate: false,
                                    doFind: true,
                                    fieldName: "LastName",
                                    isExactMatch: true,
                                    label: "Last Name"
                                },
                                {
                                    doCreate: false,
                                    doFind: true,
                                    fieldName: "FirstName",
                                    isExactMatch: true,
                                    label: "First Name"
                                },
                                {
                                    doCreate: false,
                                    doFind: true,
                                    fieldName: "Email",
                                    isExactMatch: true,
                                    label: "Email"
                                }
                            ],
                            entityName: "Contact"
                        }
                    ],
                    language: chatConfiguration.language,
                    defaultMinimizedText: chatConfiguration.defaultMinimizedText,
                    disabledMinimizedText: chatConfiguration.disabledMinimizedText,
                    loadingText: chatConfiguration.loadingText
                };
                Object.assign(window.embedded_svc.settings, settings);
                window.embedded_svc.init(chatConfiguration.baseCoreUrl, chatConfiguration.communityEndpointUrl, "https://service.force.com", chatConfiguration.orgId, chatConfiguration.eswConfigDevName, {
                    baseLiveAgentContentURL: chatConfiguration.baseLiveAgentContentUrl,
                    baseLiveAgentURL: chatConfiguration.baseLiveAgentUrl,
                    deploymentId: chatConfiguration.deploymentId,
                    buttonId: chatConfiguration.buttonId,
                    eswLiveAgentDevName: chatConfiguration.eswLiveAgentDevName,
                    isOfflineSupportEnabled: false
                });
                // ANALYTICS: register analytics events
                window.embedded_svc.addEventHandler("onHelpButtonClick", ()=>{
                    window?.dataLayer?.push({
                        event: "chat.click"
                    });
                });
                window.embedded_svc.addEventHandler("onChatEstablished", ()=>{
                    window?.dataLayer?.push({
                        event: "chat.established"
                    });
                });
                window.embedded_svc.addEventHandler("onChasitorMessage", ()=>{
                    window?.dataLayer?.push({
                        event: "chat.messagesend"
                    });
                });
                window.embedded_svc.addEventHandler("onAgentJoinedConference", ()=>{
                    window?.dataLayer?.push({
                        event: "chat.agentjoined"
                    });
                });
                window.embedded_svc.addEventHandler("onChatConferenceEnded", ()=>{
                    window?.dataLayer?.push({
                        event: "chat.ended"
                    });
                });
                window.embedded_svc.addEventHandler("onQueueUpdate", (data)=>{
                    window?.dataLayer?.push({
                        event: "chat.queueupdate",
                        "chat.status": data.queuePosition
                    });
                });
                window.embedded_svc.addEventHandler("onChatEndedByChasitor", ()=>{
                    window?.dataLayer?.push({
                        event: "chat.endedbyvisitor"
                    });
                });
                window.embedded_svc.addEventHandler("onChatEndedByAgent", ()=>{
                    window.dataLayer?.push({
                        event: "chat.endedbyagent"
                    });
                });
                window.embedded_svc.addEventHandler("afterMinimize", ()=>{
                    window.dispatchEvent(new CustomEvent("afterMinimize", {
                        detail: {
                            bubbles: true,
                            composed: false
                        }
                    }));
                });
                window.embedded_svc.addEventHandler("afterMaximize", ()=>{
                    window.dispatchEvent(new CustomEvent("afterMaximize", {
                        detail: {
                            bubbles: true,
                            composed: false
                        }
                    }));
                });
                window.embedded_svc.addEventHandler("afterDestroy", ()=>{
                    window.dispatchEvent(new CustomEvent("afterDestroy", {
                        detail: {
                            bubbles: true,
                            composed: false
                        }
                    }));
                });
                // Handle agent availability
                window.embedded_svc.addEventHandler("onAvailability", (data)=>{
                    window.dispatchEvent(new CustomEvent("onAvailability", {
                        bubbles: true,
                        composed: false,
                        detail: {
                            data: data
                        }
                    }));
                });
                // Handle loading chat settings
                window.embedded_svc.addEventHandler("onSettingsCallCompleted", (data)=>{
                    window.dispatchEvent(new CustomEvent("onSettingsCallCompleted", {
                        bubbles: true,
                        composed: false,
                        detail: {
                            data: data
                        }
                    }));
                });
            };
            document.body.appendChild(scriptElement);
        }
        resolve(true);
    });
};
var $ef0309c2c1d33d42$export$2e2bcd8739ae039 = $ef0309c2c1d33d42$var$startChat;





const $5d7f32e750ccd024$export$62db5aabdf1ac6a2 = (menuItems, isGenesys = false)=>menuItems.filter((item)=>{
        if (isGenesys && item?.["data-type"] === (0, $f2754c44a13f16ee$export$c87fd205be4f689b).salesforce) // skip Salesforce
        return false;
        if (!isGenesys && (item.items?.[0])?.["data-type"] === (0, $f2754c44a13f16ee$export$c87fd205be4f689b).genesys) // skip Genesys
        return false;
        return true;
    });


// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
let $b4bcfd28199791f9$var$passiveSupported = false;
try {
    const options = {
        get passive () {
            $b4bcfd28199791f9$var$passiveSupported = true;
            return false;
        }
    };
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.addEventListener("test", null, options);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.removeEventListener("test", null, options);
} catch (err) {
    $b4bcfd28199791f9$var$passiveSupported = false;
}
const $b4bcfd28199791f9$export$1c82bb05768c9ea1 = $b4bcfd28199791f9$var$passiveSupported ? {
    passive: true
} : false;
const $b4bcfd28199791f9$export$6a9dd95b3d8b84ef = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ locale: locale , environment: environment , openButton: openButton , fallBackDomain: fallBackDomain , offset: offset , isSupportButtonVisible: isSupportButtonVisible = true , onOpen: onOpen , showLogs: showLogs = false , ...props }, ref)=>{
    const initialOpenRef = (0, $hgUW1$useRef)(true);
    const hasRequestedChat = (0, $hgUW1$useRef)(false);
    const initialStateWithOpenButton = {
        ...(0, $62ba562828888109$export$d4c72bab9d6cc13a),
        ariaLabels: {
            ...(0, $62ba562828888109$export$d4c72bab9d6cc13a).ariaLabels,
            openButton: openButton || (0, $62ba562828888109$export$d4c72bab9d6cc13a).ariaLabels.openButton
        }
    };
    const consent = (0, $9befe8313eed890c$export$2e2bcd8739ae039)();
    const oneTrustPopupOpen = (0, $b8a0a86fb7e17780$export$2e2bcd8739ae039)();
    const { isChatActive: isChatActive , updateChatConfiguration: updateChatConfiguration , openGenesysChat: openGenesysChat , setGenesysImplementation: setGenesysImplementation , setLogging: setLogging , isGenesysImplemented: isGenesysImplemented , canMenuShown: canMenuShown , setLoadingData: setLoadingData , closeDialog: closeDialog , showForm: showForm , formBackClick: formBackClick , isLoadingData: isLoadingData , loadSDK: loadSDK  } = (0, $1972cb1a4960efb2$export$9804cccfc8dc0bb9)();
    (0, $hgUW1$useEffect)(()=>{
        setLogging(showLogs);
    }, [
        showLogs
    ]);
    const [state, dispatch] = (0, $hgUW1$useReducer)((0, $62ba562828888109$export$248353193ad0abbf), initialStateWithOpenButton, (0, $62ba562828888109$export$3ee49b4c70c0ec29));
    const { open: open , loading: loading , showPopover: showPopover , isLoadingSalesforceChat: isLoadingSalesforceChat , chatInformation: chatInformation , showConsentDialog: showConsentDialog , ariaLabels: ariaLabels , menuItems: menuItems , showIconButton: showIconButton , showOnetrustDialog: showOnetrustDialog  } = state;
    const isChatOpen = (0, $hgUW1$useMemo)(()=>chatInformation?.openingHours ? (0, $99c6dd255cd875dc$export$2e2bcd8739ae039)(chatInformation.openingHours) : false, [
        chatInformation?.openingHours
    ]);
    const { isSettingsCallCompleted: isSettingsCallCompleted  } = (0, $013481e95ece6feb$export$2e2bcd8739ae039)();
    const { isAgentAvailable: isAgentAvailable  } = (0, $1118485e44c25ac3$export$2e2bcd8739ae039)({
        consent: consent,
        chatInformation: chatInformation,
        isSettingsCallCompleted: isSettingsCallCompleted
    });
    // this is needed while the getInitialData may be executed when the consent is not yet available.
    const consentRef = (0, $hgUW1$useRef)(false);
    consentRef.current = consent;
    const getInitialData = async ()=>{
        setLoadingData(true);
        const [menuItemsResponse, chatConfiguration, openingHours] = await Promise.all([
            (0, $f24a6c0f784f8ad3$export$2e2bcd8739ae039)(locale, environment, fallBackDomain),
            (0, $ce78962a2070b423$export$2e2bcd8739ae039)(locale, environment),
            // TODO: can be removed when Salesforce chat is replaced with Genesys
            (0, $cb1b605f753cb90f$export$2e2bcd8739ae039)(locale, environment)
        ]);
        const payload = {
            chatInformation: {
                chatConfiguration: chatConfiguration,
                openingHours: openingHours
            },
            menuItems: // prevent duplicate chat items in staging environments
            (0, $5d7f32e750ccd024$export$62db5aabdf1ac6a2)(menuItemsResponse.content, !!chatConfiguration?.genesysConfiguration),
            ariaLabels: {
                ...menuItemsResponse.labels,
                openButton: openButton || menuItemsResponse.labels.openButton
            }
        };
        if (chatConfiguration?.genesysConfiguration) updateChatConfiguration(chatConfiguration.genesysConfiguration);
        // check if Genesys is available for this market
        setGenesysImplementation(!!chatConfiguration?.genesysConfiguration);
        dispatch({
            type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_INITIAL_DATA,
            payload: {
                ...payload,
                chatType: menuItemsResponse.chatType || (0, $f2754c44a13f16ee$export$c87fd205be4f689b).salesforce
            }
        });
        if (chatConfiguration?.genesysConfiguration && consentRef.current) // trigger Genesys SDK to load
        loadSDK();
        // reset loading icon
        dispatch({
            type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_LOADING,
            payload: false
        });
    };
    // prevent side effects by Salesforce SDK when Genesys is used.
    const settingsCallCompleted = isGenesysImplemented() ? true : isSettingsCallCompleted;
    // update the status of the chat menu item
    (0, $hgUW1$useEffect)(()=>{
        if (menuItems.length === 0) // prevent unnecessary renders if data is not changed
        return;
        const menuWithStatus = (0, $463f2df074aed427$export$2c66f0d7b813d157)(menuItems, consent, isChatOpen, settingsCallCompleted, isLoadingSalesforceChat);
        dispatch({
            type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_MENU_ITEMS,
            payload: menuWithStatus
        });
        // prevent showing the menu during direct openings
        setLoadingData(false);
    }, [
        open,
        isAgentAvailable,
        isChatOpen,
        consent,
        settingsCallCompleted,
        isLoadingSalesforceChat
    ]);
    const handleConsentBackClick = (0, $hgUW1$useCallback)(()=>{
        dispatch({
            type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_CONSENT_DIALOG,
            payload: false
        });
    }, []);
    const handleFormBackClick = (0, $hgUW1$useCallback)(()=>{
        formBackClick();
        dispatch({
            type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_LOADING,
            payload: false
        });
        dispatch({
            type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_OPEN,
            payload: true
        });
    }, []);
    const handleConsentClick = (0, $hgUW1$useCallback)(()=>{
        if (window?.Optanon) window?.Optanon.ToggleInfoDisplay();
        else dispatch({
            type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_ONETRUST_DIALOG,
            payload: true
        });
    }, []);
    const handleOpen = (0, $hgUW1$useCallback)(async ()=>{
        (0, $cfc57243d48ecb76$export$1af36040bd10a2aa)();
        onOpen?.();
        dispatch({
            type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_OPEN,
            payload: true
        });
    }, []);
    const handleClose = ()=>{
        closeDialog();
        dispatch({
            type: (0, $62ba562828888109$export$284f739ccaf06b2d).CLOSE_DIALOG
        });
    };
    const { [(0, $hgUW1$ThemeTypes).light]: light  } = (0, $hgUW1$useThemes)();
    const mergedTheme = (0, $hgUW1$extendTheme)(light, (0, $935194a21c37b04b$export$2e2bcd8739ae039));
    const showConsent = (0, $hgUW1$useCallback)(()=>{
        const shouldShowConsentDialog = !consent;
        if (showConsentDialog !== shouldShowConsentDialog) {
            hasRequestedChat.current = true;
            dispatch({
                type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_CONSENT_DIALOG,
                payload: shouldShowConsentDialog
            });
        }
        return shouldShowConsentDialog;
    }, [
        consent,
        showConsentDialog
    ]);
    const handleClick = async (e)=>{
        const isChatButton = e.target.dataset?.type === (0, $f2754c44a13f16ee$export$c87fd205be4f689b).salesforce;
        if (isChatButton) {
            (0, $cfc57243d48ecb76$export$610503f776ddf63f)("chat_menu_item_click", e.target?.innerText);
            // if they click the chat button and they haven't consented, show the consent dialog
            if (showConsent()) return;
        }
        if (!isChatButton || !isChatOpen) return;
        if (isSettingsCallCompleted) {
            // trigger to open custom Salesforce chat window
            dispatch({
                type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_LOADING_SALESFORCE_CHAT,
                payload: true
            });
            window?.embedded_svc?.bootstrapEmbeddedService();
        } else console.error("Could not open chat window since settings call was not completed");
    };
    // load data only intially and once
    (0, $hgUW1$useEffect)(()=>{
        // load data only on first open
        if (initialOpenRef.current) {
            initialOpenRef.current = false;
            dispatch({
                type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_LOADING,
                payload: true
            });
            getInitialData();
        }
    }, []);
    /**
     * If a user has clicked the chat and requested the chat window to open & also has consented to the chat cookies
     * the chat should fire up
     */ (0, $hgUW1$useEffect)(()=>{
        if (hasRequestedChat.current && consent && isSettingsCallCompleted) {
            dispatch({
                type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_LOADING_SALESFORCE_CHAT,
                payload: true
            });
            // trigger to open custom Salesforce chat window
            window?.embedded_svc?.bootstrapEmbeddedService();
            hasRequestedChat.current = false;
        }
    }, [
        hasRequestedChat.current,
        consent,
        isSettingsCallCompleted,
        isLoadingSalesforceChat
    ]);
    // event listeners to hide/show the icon button when the chat window is minimized/closed
    (0, $hgUW1$useEffect)(()=>{
        const displayIconButton = ()=>{
            dispatch({
                type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_ICON_BUTTON,
                payload: true
            });
        };
        const hideIconButton = ()=>{
            dispatch({
                type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_ICON_BUTTON,
                payload: false
            });
        };
        // we keep the menu open with loading status until the chat window appears
        const hideIconButtonAndCloseMenu = ()=>{
            dispatch({
                type: (0, $62ba562828888109$export$284f739ccaf06b2d).HIDE_ICON_BUTTON_AND_CLOSE_MENU
            });
        };
        window.addEventListener("afterMinimize", hideIconButton);
        window.addEventListener("afterMaximize", hideIconButtonAndCloseMenu);
        window.addEventListener("afterDestroy", displayIconButton);
        return ()=>{
            window.removeEventListener("afterMinimize", hideIconButton);
            window.removeEventListener("afterMaximize", hideIconButtonAndCloseMenu);
            window.removeEventListener("afterDestroy", displayIconButton);
        };
    }, []);
    /**
     * Handle a click from the in-page GenesysChatButton to directly open the Genesys chat window and check if a form is needed first
     */ const handleOpenGenesysChat = async ()=>{
        if (isChatActive) document?.body?.dispatchEvent(new Event("supportDialog.genesys.loading.done"));
        else {
            // only open when the chat window is not yet opened
            dispatch({
                type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_LOADING,
                payload: true
            });
            await handleOpen();
            // reset to true
            dispatch({
                type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_LOADING,
                payload: true
            });
            await openGenesysChat(true);
            dispatch({
                type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_LOADING,
                payload: false
            });
        }
    };
    (0, $hgUW1$useEffect)(()=>{
        // handle direct opening of the Genesys chat window and check if a form is needed first
        document.body.addEventListener("supportDialog.genesys.openChat", handleOpenGenesysChat, $b4bcfd28199791f9$export$1c82bb05768c9ea1);
        return ()=>{
            document.body.removeEventListener("supportDialog.genesys.openChat", handleOpenGenesysChat);
        };
    }, [
        handleOpenGenesysChat
    ]);
    (0, $hgUW1$useEffect)(()=>{
        // update genesys chat status into reducer
        dispatch({
            type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_GENESYS_CHAT_ACTIVE,
            payload: isChatActive
        });
    }, [
        isChatActive
    ]);
    // ensure that direct execution by the ChatButton with Genesys waits on loading the SDK before showing the popover
    const openPopover = isGenesysImplemented() ? canMenuShown ? showForm ? showForm : showPopover : false : showPopover;
    // initialize Salesforce chat settings
    (0, $hgUW1$useEffect)(()=>{
        if (open && consent && isChatOpen && chatInformation?.chatConfiguration && !window?.embedded_svc) (async ()=>{
            if (!chatInformation?.chatConfiguration) return;
            await (0, $ef0309c2c1d33d42$export$2e2bcd8739ae039)(chatInformation.chatConfiguration);
        })();
    }, [
        isChatOpen,
        open,
        consent,
        chatInformation?.chatConfiguration
    ]);
    (0, $hgUW1$useEffect)(()=>{
        if (consent && !oneTrustPopupOpen) // do not show the consent dialog anymore when OneTrust popup is gone and consent is given
        dispatch({
            type: (0, $62ba562828888109$export$284f739ccaf06b2d).SET_CONSENT_DIALOG,
            payload: false
        });
    }, [
        oneTrustPopupOpen,
        consent
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsxs)((0, $hgUW1$ThemeProvider), {
        theme: mergedTheme,
        children: [
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$Global), {
                styles: (0, $4f516b8bb7114aea$export$aa0e86c7c0d2f400)
            }),
            /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e3139fef3a909170$export$2e2bcd8739ae039), {
                ...props,
                ref: ref,
                items: menuItems,
                consentContent: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8f649985e8a19246$export$2e2bcd8739ae039), {
                    onConsentClick: handleConsentClick,
                    consentLabel: ariaLabels.consentButton,
                    consentDialogText: ariaLabels.consentDialogText
                }),
                showConsentDialog: showConsentDialog,
                onConsentBackClick: handleConsentBackClick,
                onFormBackClick: handleFormBackClick,
                open: openPopover,
                loading: isGenesysImplemented() ? isLoadingData || loading : isLoadingSalesforceChat || loading,
                onOpen: handleOpen,
                onClick: handleClick,
                onClose: handleClose,
                ariaLabels: ariaLabels,
                showIconButton: showIconButton,
                offset: offset,
                isSupportButtonVisible: isSupportButtonVisible
            }),
            showOnetrustDialog && /*#__PURE__*/ (0, $hgUW1$jsx)((0, $8c84db282b492cea$export$2e2bcd8739ae039), {})
        ]
    });
});
$b4bcfd28199791f9$export$6a9dd95b3d8b84ef.displayName = "SupportDialog";



const $1972cb1a4960efb2$var$isSSR = typeof window === "undefined";
// Create the context with a default value of `undefined`
const $1972cb1a4960efb2$var$GenesysContext = /*#__PURE__*/ (0, $hgUW1$createContext)(undefined);
const $1972cb1a4960efb2$export$9804cccfc8dc0bb9 = ()=>{
    const context = (0, $hgUW1$useContext)($1972cb1a4960efb2$var$GenesysContext);
    if (!context) throw new Error("useGenesys must be used within a GenesysProvider");
    return context;
};
let $1972cb1a4960efb2$export$d593155b9bc52923;
(function(GenesysProviderTypes) {
    GenesysProviderTypes["CHAT_BUTTON"] = "chat-button";
    GenesysProviderTypes["MENU"] = "menu";
})($1972cb1a4960efb2$export$d593155b9bc52923 || ($1972cb1a4960efb2$export$d593155b9bc52923 = {}));
const $1972cb1a4960efb2$export$e5958a3f2d721b65 = ({ children: children , type: type = $1972cb1a4960efb2$export$d593155b9bc52923.MENU  })=>{
    const [environment, setEnvironment] = (0, $hgUW1$useState)(undefined);
    const [deploymentId, setDeploymentId] = (0, $hgUW1$useState)(undefined);
    // check if the personal information is stored in the Genesys database already
    const localStorageKey = "polestar.support-dialog";
    const localStorageMessagesKey = "polestar.support-dialog.lastMessageId";
    const dayMilliseconds = 86400000;
    const [firstName, setFirstName] = (0, $hgUW1$useState)("");
    const [lastName, setLastName] = (0, $hgUW1$useState)("");
    const [email, setEmail] = (0, $hgUW1$useState)("");
    const focusIconButtonFunction = (0, $hgUW1$useRef)(null);
    const chatInitiated = (0, $hgUW1$useRef)(false);
    const genesysChatButtonReference = (0, $hgUW1$useRef)(null);
    const directChatTriggered = (0, $hgUW1$useRef)(false);
    const [genesysImplemented, setGenesysImplemented] = (0, $hgUW1$useState)(false);
    // this is necessary because sometimes the chat will not open because some internal state is not ready. The documentation mentions Messenger.ready event and that is ready, but no other events are mentioned. Something is missing in the documentation.
    // const startChatTimeout = useRef<NodeJS.Timeout | null>(null);
    const [loggingEnabled, enableLogging] = (0, $hgUW1$useState)(false);
    const [state, dispatch] = (0, $hgUW1$useReducer)((0, $82f9b1b8e367eb3b$export$1650419e431d3ba3), {
        type: type,
        sdkDatabasePluginReady: false,
        sdkMessengerPluginReady: false,
        sdkMessagingPluginReady: false,
        sdkMessagingPluginConnectionStarted: false,
        sdkMessagingPluginConversationRestored: false,
        sdkReady: false,
        sdkLoaded: false,
        directExecution: false,
        databaseSet: false,
        databaseUpdated: false,
        messages: 0,
        lastMessageId: $1972cb1a4960efb2$var$isSSR ? "-1" : window?.localStorage?.getItem(localStorageMessagesKey) || "-1",
        environment: undefined,
        deploymentId: undefined,
        loggingEnabled: false,
        messengerOpened: false,
        showForm: false
    });
    const localStorageGenesysMessengerEnabled = deploymentId ? Boolean(JSON.parse($1972cb1a4960efb2$var$isSSR ? "" : window?.localStorage?.getItem(`_${deploymentId}:gcmcopn`) || "{}")?.value) : undefined;
    const localStorageGenesysConversationEnabled = deploymentId ? Boolean(JSON.parse($1972cb1a4960efb2$var$isSSR ? "" : window?.localStorage?.getItem(`_${deploymentId}:gcmcsessionActive`) || "{}")?.value) : undefined;
    const isSDKReady = state.sdkReady;
    const isLoadingData = state.isLoadingData || false;
    const isChatActive = state.messengerOpened;
    const canMenuShown = state.showForm ? true : state.isLoadingData === false ? state.directExecution ? state.messengerOpened && state.sdkDatabasePluginReady && state.sdkMessengerPluginReady && state.sdkMessagingPluginReady : !state.messengerOpened : false;
    const messages = state.messages;
    const consent = (0, $9befe8313eed890c$export$2e2bcd8739ae039)();
    /**
   * All personal information is saved so start the chat
   */ const entriesSaved = ()=>{
        dispatch({
            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).PERSONAL_INFORMATION_STORED,
            value: true
        });
        try {
            window.localStorage.setItem(localStorageKey, Date.now().toString());
            window.localStorage.setItem(localStorageMessagesKey, state.lastMessageId || "-1");
            (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("entries saved, so start chat");
            // personal information is stored, waited on the Database.updated event so open up the chat window
            (0, $fa80a63b2c4a0c94$export$a5cfd6b9de5c382f)();
        } catch (error) {
            console.error("SupportDialog: could not save to localStorage due to", error);
        // TODO: what to show?
        }
    };
    /**
   * Save personal information from the form by sending it to Genesys
   */ const savePersonalInformation = (value)=>{
        (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("save personal information", value, {
            databaseReady: state.sdkDatabasePluginReady
        });
        if (state.sdkDatabasePluginReady) {
            (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("Trigger Database.set");
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window?.Genesys?.("command", "Database.set", {
                messaging: {
                    customAttributes: {
                        customerFirstName: value.firstName,
                        customerLastName: value.lastName,
                        customerEmail: value.email,
                        browser: $1972cb1a4960efb2$var$isSSR ? "impossible" : window?.navigator?.userAgent || "unknown",
                        url: $1972cb1a4960efb2$var$isSSR ? "impossible" : window?.location?.href || "unknown"
                    }
                }
            }, ()=>{
                dispatch({
                    type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).DATABASE_SET,
                    value: true
                });
            }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (e)=>{
                console.error("SupportDialog: failed to save personal information due to", e);
                dispatch({
                    type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).DATABASE_SET,
                    value: false
                });
            });
            (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("saved personal information");
        } else // TODO: show a message? because it should be loaded?
        console.warn("SupportDialog: Genesys database is not ready yet so no information is stored.");
    };
    /**
   * Store locally after every keystroke
   */ const storePersonalInformation = (value)=>{
        setFirstName(value.firstName || "");
        setLastName(value.lastName || "");
        setEmail(value.email || "");
    };
    const getPersonalInformation = ()=>({
            firstName: firstName,
            lastName: lastName,
            email: email
        });
    /**
   * Save all information necessary when embedding the Genesys script
   */ const updateChatConfiguration = (value)=>{
        (0, $7bb9128d6aa2a32d$export$706d24ac8338084e)("updateChatConfiguration", value?.environment);
        if (value) {
            setEnvironment(value.environment);
            setDeploymentId(value.deploymentId);
            dispatch({
                type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).ENVIRONMENT_ID,
                value: value.environment
            });
            dispatch({
                type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).DEPLOYMENT_ID,
                value: value.deploymentId
            });
        }
    };
    /**
   * Save reference to be able to directly trigger the chat button when later necessary
   */ const setGenesysChatTrigger = (value)=>{
        genesysChatButtonReference.current = value;
    };
    const hasGenesysChatTrigger = ()=>genesysChatButtonReference.current !== null;
    /**
   * Focus on icon button when minimized to help with a11y flows
   */ const setFocusIconButton = (func)=>{
        focusIconButtonFunction.current = func;
    };
    const isTriggeredByChatButton = ()=>state.directExecution;
    /**
   * Reset after popover is closed
   */ const popoverClosed = ()=>{
        dispatch({
            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).LOADING_DATA,
            value: false
        });
    };
    /**
   * Provide boolean to know if the chat is coming from Salesforce or Genesys
   */ const isGenesysImplemented = ()=>genesysImplemented;
    const setGenesysImplementation = (value)=>{
        setGenesysImplemented(value);
    };
    const closeDialog = ()=>{
        // cleanup internal state when the menu is closed
        dispatch({
            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).NEXT_STEP,
            value: []
        });
        dispatch({
            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).DIRECT_EXECUTION,
            value: false
        });
        dispatch({
            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).SHOW_FORM,
            value: false
        });
    };
    const clearConversation = ()=>{
        // conversation cleared, so remove personal information
        window.localStorage.removeItem(localStorageKey);
        storePersonalInformation({
            firstName: "",
            lastName: "",
            email: ""
        });
        // clear internal messages counter
        dispatch({
            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).MESSAGES_CLEAR,
            value: true
        });
    };
    /**
   * Internal function to provide logging for debugging purposes only
   */ const setLogging = (val)=>{
        enableLogging(val);
        dispatch({
            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).LOGGING_ENABLED,
            value: val
        });
        if (typeof window !== "undefined") // used at logFunction.ts:
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.polestarChatLogging = val;
    };
    /**
   * This only happens when directly clicking the ChatButton
   */ const openGenesysChat = (0, $hgUW1$useCallback)(async (inPage = false)=>{
        const openType = inPage ? (0, $82f9b1b8e367eb3b$export$706f72478c189308).OPEN_DIRECTLY : (0, $82f9b1b8e367eb3b$export$706f72478c189308).OPEN;
        const steps = [];
        // might be skipped later when it is clear if there is data stored for Genesys in localStorage
        steps.push((0, $82f9b1b8e367eb3b$export$706f72478c189308).FORM);
        steps.push(openType);
        // define steps
        dispatch({
            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).NEXT_STEP,
            value: steps
        });
    }, [
        environment,
        deploymentId,
        state
    ]);
    const loadSDK = ()=>{
        dispatch({
            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).LOADING_DATA,
            value: true
        });
        dispatch({
            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).NEXT_STEP,
            value: [
                (0, $82f9b1b8e367eb3b$export$706f72478c189308).LOAD_DATA
            ]
        });
    };
    /**
   * Return if window.Genesys is available
   */ const isChatLoaded = ()=>// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        !!window?.Genesys;
    const setLoadingData = (value)=>{
        dispatch({
            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).LOADING_DATA,
            value: value
        });
    };
    const handleDirectOpening = ()=>{
        // ChatButton has its own React.Context so to know how Genesys is triggered, listen for the ChatButton open event
        if (!state.directExecution) {
            dispatch({
                type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).LOADING_DATA,
                value: true
            });
            dispatch({
                type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).DIRECT_EXECUTION,
                value: true
            });
        }
        if (state.showForm) // form is already shown so reset the loading state
        document?.body?.dispatchEvent(new Event("supportDialog.genesys.loading.done"));
    };
    const formBackClick = ()=>{
        dispatch({
            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).SHOW_FORM,
            value: false
        });
        dispatch({
            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).NEXT_STEP,
            value: []
        });
    };
    const loadingStateChanged = state.isLoadingData;
    (0, $hgUW1$useEffect)(()=>{
        if (!loadingStateChanged) document?.body?.dispatchEvent(new Event("supportDialog.genesys.loading.done"));
    }, [
        loadingStateChanged
    ]);
    (0, $hgUW1$useEffect)(()=>{
        // send to ChatButton to indicate that new messages are available
        document?.body?.dispatchEvent(new CustomEvent("supportDialog.genesys.messages", {
            detail: messages
        }));
    }, [
        messages
    ]);
    (0, $hgUW1$useEffect)(()=>{
        if (!state.isLoadingData && state.messengerOpened) document?.body?.dispatchEvent(new Event("supportDialog.genesys.loading.done"));
        if (state.nextStep && state.nextStep.length > 0) {
            const step = state.nextStep.slice(0, 1)[0];
            if (step === (0, $82f9b1b8e367eb3b$export$706f72478c189308).LOAD_DATA && state.sdkDatabasePluginReady && state.sdkMessengerPluginReady) {
                const formIndex = state.nextStep.findIndex((item)=>item === (0, $82f9b1b8e367eb3b$export$706f72478c189308).FORM);
                // the SDK is (already) loaded so skip the loading step
                dispatch({
                    type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).NEXT_STEP,
                    value: state.nextStep.slice(state.isPersonalInformationStored && formIndex ? formIndex + 1 : 1)
                });
                return;
            }
            switch(step){
                case (0, $82f9b1b8e367eb3b$export$706f72478c189308).LOAD_DATA:
                    if (state.environment && state.deploymentId && !chatInitiated.current && consent) {
                        chatInitiated.current = true;
                        // load library only once
                        (0, $9cbbd2c6a2e58c1c$export$408f97352dd89169)({
                            dispatch: dispatch,
                            environment: state.environment,
                            deploymentId: state.deploymentId,
                            loggingEnabled: loggingEnabled,
                            directChatTriggered: directChatTriggered,
                            entriesSaved: entriesSaved,
                            focusIconButtonFunction: focusIconButtonFunction,
                            clearConversation: clearConversation
                        });
                        dispatch({
                            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).SDK_LOADED,
                            value: true
                        });
                    } else if (state.environment && state.deploymentId && chatInitiated.current && consent) {
                        // cleanup because it is already loaded to prevent race conditions
                        dispatch({
                            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).NEXT_STEP,
                            value: state.nextStep.slice(1)
                        });
                        dispatch({
                            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).LOADING_DATA,
                            value: false
                        });
                    }
                    break;
                case (0, $82f9b1b8e367eb3b$export$706f72478c189308).FORM:
                    if (!state.showForm && !state.isPersonalInformationStored) dispatch({
                        type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).SHOW_FORM,
                        value: true
                    });
                    else if (!state.showForm && state.isPersonalInformationStored) // form set already so go to next step
                    dispatch({
                        type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).NEXT_STEP,
                        value: state.nextStep.slice(1)
                    });
                    break;
                case (0, $82f9b1b8e367eb3b$export$706f72478c189308).OPEN:
                    if (state.sdkDatabasePluginReady && state.sdkMessengerPluginReady) {
                        dispatch({
                            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).LOADING_DATA,
                            value: false
                        });
                        (0, $fa80a63b2c4a0c94$export$a5cfd6b9de5c382f)();
                        // cleanup
                        dispatch({
                            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).NEXT_STEP,
                            value: state.nextStep.slice(1)
                        });
                    }
                    // open chat-window but save the last message id to know if a new message is restored the "new-message" indicator is shown
                    window.localStorage.setItem(localStorageMessagesKey, state.lastMessageId || "-1");
                    break;
                case (0, $82f9b1b8e367eb3b$export$706f72478c189308).OPEN_DIRECTLY:
                    if (state.sdkDatabasePluginReady && state.sdkMessengerPluginReady) {
                        dispatch({
                            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).LOADING_DATA,
                            value: false
                        });
                        (0, $fa80a63b2c4a0c94$export$a5cfd6b9de5c382f)();
                        // cleanup
                        dispatch({
                            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).NEXT_STEP,
                            value: state.nextStep.slice(1)
                        });
                    }
                    // open chat-window but save the last message id to know if a new message is restored the "new-message" indicator is shown
                    window.localStorage.setItem(localStorageMessagesKey, state.lastMessageId || "-1");
                    break;
            }
        }
    }, [
        state
    ]);
    (0, $hgUW1$useEffect)(()=>{
        // check if information is already provided and only after hydration
        dispatch({
            type: (0, $82f9b1b8e367eb3b$export$dc3c40f9a324927c).PERSONAL_INFORMATION_STORED,
            value: (localStorageGenesysMessengerEnabled || localStorageGenesysConversationEnabled) && Date.now() < Number(window.localStorage?.getItem(localStorageKey) || "0") + /* Genesys resets after 72 hours */ 3 * dayMilliseconds || false
        });
    }, [
        localStorageKey,
        localStorageGenesysMessengerEnabled,
        localStorageGenesysConversationEnabled,
        deploymentId
    ]);
    const isSDKLoaded = state.sdkLoaded;
    (0, $hgUW1$useEffect)(()=>{
        // consent is set to true, but SDK is not yet loaded
        if (consent && !isLoadingData && !isSDKLoaded) loadSDK();
    }, [
        consent,
        isLoadingData,
        isSDKLoaded
    ]);
    (0, $hgUW1$useEffect)(()=>{
        // handle direct opening of the Genesys chat window and check if a form is needed first
        document.body.addEventListener("supportDialog.genesys.openChat", handleDirectOpening, (0, $b4bcfd28199791f9$export$1c82bb05768c9ea1));
        return ()=>{
            document.body.removeEventListener("supportDialog.genesys.openChat", handleDirectOpening);
        };
    }, [
        handleDirectOpening
    ]);
    return /*#__PURE__*/ (0, $hgUW1$jsx)($1972cb1a4960efb2$var$GenesysContext.Provider, {
        value: {
            isChatActive: isChatActive,
            showForm: state.showForm || false,
            formBackClick: formBackClick,
            isSDKReady: isSDKReady,
            isLoadingData: isLoadingData,
            messages: messages,
            getPersonalInformation: getPersonalInformation,
            savePersonalInformation: savePersonalInformation,
            storePersonalInformation: storePersonalInformation,
            updateChatConfiguration: updateChatConfiguration,
            hasGenesysChatTrigger: hasGenesysChatTrigger,
            openGenesysChat: openGenesysChat,
            setGenesysChatTrigger: setGenesysChatTrigger,
            setFocusIconButton: setFocusIconButton,
            isTriggeredByChatButton: isTriggeredByChatButton,
            popoverClosed: popoverClosed,
            isGenesysImplemented: isGenesysImplemented,
            setGenesysImplementation: setGenesysImplementation,
            isChatLoaded: isChatLoaded,
            setLogging: setLogging,
            canMenuShown: canMenuShown,
            setLoadingData: setLoadingData,
            closeDialog: closeDialog,
            loadSDK: loadSDK
        },
        children: children
    });
};



const $b6e745f4ad9febb0$export$37be97b52ad59ecc = /*#__PURE__*/ (0, $hgUW1$forwardRef)((props, ref)=>/*#__PURE__*/ (0, $hgUW1$jsx)((0, $1972cb1a4960efb2$export$e5958a3f2d721b65), {
        children: /*#__PURE__*/ (0, $hgUW1$jsx)((0, $b4bcfd28199791f9$export$6a9dd95b3d8b84ef), {
            ref: ref,
            ...props
        }, "support-dialog-base")
    }));
$b6e745f4ad9febb0$export$37be97b52ad59ecc.displayName = "SupportDialog";






















const $d2b84c395e40d2ab$export$b866cf1077b23cec = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ onClick: onClick , disabled: disabled , minimizedText: minimizedText , hasMessages: hasMessages = false , salesforce: salesforce , ...props }, ref)=>/*#__PURE__*/ (0, $hgUW1$jsx)($d2b84c395e40d2ab$var$StyledPrimaryButton, {
        ref: ref,
        ...props,
        icon: salesforce?.available ? undefined : (0, $hgUW1$Icons).support,
        iconPosition: (0, $hgUW1$Alignments).right,
        onClick: onClick,
        disabled: disabled,
        hasMessages: hasMessages,
        salesforce: salesforce,
        children: minimizedText
    }));
$d2b84c395e40d2ab$export$b866cf1077b23cec.displayName = "ChatButtonBase";
const $d2b84c395e40d2ab$var$StyledPrimaryButton = (0, $hgUW1$emotionstyled)((0, $hgUW1$PrimaryButton), (0, $hgUW1$shouldNotForwardProps1)(false, "hasMessages", "salesforce"))(({ theme: theme , hasMessages: hasMessages , disabled: disabled , salesforce: salesforce  })=>(0, $hgUW1$css)((0, $hgUW1$css)`
      [data-type="icon"] {
        color: currentColor !important;
      }
    `, hasMessages && (0, $hgUW1$css)`
        & span[data-type="icon"]:after {
          content: "";
          display: block;
          position: absolute;
          inset-block-start: -${(0, $hgUW1$createCustomSpacing)(0.25)};
          inset-inline-end: -${(0, $hgUW1$createCustomSpacing)(0.25)};
          background: ${theme.supportDialog.dialog.button.status.online.color};
          border: ${(0, $hgUW1$createCustomSpacing)(2 / 16)} solid ${(0, $hgUW1$Colors).ironGrey};
          border-radius: ${(0, $hgUW1$Spacings).xSmall};
          width: ${(0, $hgUW1$createCustomSpacing)(0.75)};
          height: ${(0, $hgUW1$createCustomSpacing)(0.75)};
          transition: border-color 0;
        }

        &:hover span[data-type="icon"]:after {
          border-color: ${(0, $hgUW1$blend)((0, $hgUW1$Colors).ironGrey, theme._name && theme._name.indexOf((0, $hgUW1$ThemeTypes).light) > -1 ? (0, $hgUW1$Colors).white : (0, $hgUW1$Colors).black, (0, $hgUW1$Opacities).low)};
        }
        &:disabled span[data-type="icon"]:after {
          display: none;
        }
      `, hasMessages && disabled && (0, $hgUW1$css)`
        background: ${(0, $hgUW1$blend)(theme.polestarApp.backgroundColor, theme.supportDialog.dialog.button.status.online.color, (0, $hgUW1$Opacities).low)};
      `, !!salesforce && !!salesforce.available && (0, $hgUW1$css)((0, $a882efb81830fa38$export$6b53d3d1caa77bef), (0, $hgUW1$css)`
          &::after {
            position: relative;
            inset-block-start: calc(50% - ${(0, $hgUW1$Spacings).xxSmall});
            background-color: ${salesforce.iconColor};
          }
        `)));



const $b3ce74476eeabff0$var$chatButtonTheme = {
    light: {
        chatButton: {
            status: {
                online: {
                    // TODO: this is an overwrite due to https://polestarjira.atlassian.net/browse/PCW-6363 - adjust to token when available
                    color: "rgb(6, 169, 89)"
                },
                offline: {
                    color: (0, $hgUW1$withOpacity)((0, $hgUW1$Colors).white, (0, $hgUW1$Opacities).low)
                },
                busy: {
                    color: "rgb(6, 169, 89)"
                }
            }
        }
    },
    dark: {
        chatButton: {
            status: {
                online: {
                    color: (0, $hgUW1$Colors).success
                },
                offline: {
                    color: (0, $hgUW1$withOpacity)((0, $hgUW1$Colors).white, (0, $hgUW1$Opacities).low)
                },
                busy: {
                    color: (0, $hgUW1$Colors).success
                }
            }
        }
    }
};
var $b3ce74476eeabff0$export$2e2bcd8739ae039 = $b3ce74476eeabff0$var$chatButtonTheme;




const $d59d27fc90026e7c$var$useHasOneTrust = ()=>{
    const [hasOneTrust, setHasOneTrust] = (0, $hgUW1$useState)(false);
    const timeout = (0, $hgUW1$useRef)(null);
    const interval = (0, $hgUW1$useRef)(null);
    (0, $hgUW1$useEffect)(()=>{
        if (interval.current) clearInterval(interval.current);
        interval.current = setTimeout(()=>{
            if (!(0, $hgUW1$isSSR) && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            !!window.OneTrust) {
                clearInterval(interval.current);
                clearTimeout(timeout.current);
                setHasOneTrust(true);
            }
        }, 50);
        if (timeout.current) clearInterval(timeout.current);
        timeout.current = setTimeout(()=>{
            clearInterval(interval.current);
        }, 8000);
    }, []);
    return hasOneTrust;
};
var $d59d27fc90026e7c$export$2e2bcd8739ae039 = $d59d27fc90026e7c$var$useHasOneTrust;


const $e322de2051adfe14$var$getStatus = (consent, isChatOpen, isSettingsCallCompleted, isLoadingSalesforceChat)=>{
    if (!consent) return (0, $5191fc15630cefd3$export$9354cf8072350acf).offline;
    if (isChatOpen && !isSettingsCallCompleted) return (0, $5191fc15630cefd3$export$9354cf8072350acf).offline;
    if (isChatOpen && isSettingsCallCompleted && isLoadingSalesforceChat) return (0, $5191fc15630cefd3$export$9354cf8072350acf).loading;
    if (isChatOpen && isSettingsCallCompleted) return (0, $5191fc15630cefd3$export$9354cf8072350acf).online;
    return (0, $5191fc15630cefd3$export$9354cf8072350acf).offline;
};
const $e322de2051adfe14$var$SalesforceChatButton = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ locale: locale , environment: environment , setLoading: setLoading , chatConfiguration: chatConfiguration , disabled: disabled = false , ...props }, ref)=>{
    const theme = (0, $hgUW1$useTheme1)();
    const mergedTheme = (0, $hgUW1$extendTheme)(theme, (0, $b3ce74476eeabff0$export$2e2bcd8739ae039)[theme._type]);
    const [openingHours, setOpeningHours] = (0, $hgUW1$useState)();
    const [isLoadingSalesforceChat, setIsLoadingSalesforceChat] = (0, $hgUW1$useState)(false);
    const [chatWindowOpen, setChatWindowOpen] = (0, $hgUW1$useState)(false);
    const [status, setStatus] = (0, $hgUW1$useState)((0, $5191fc15630cefd3$export$9354cf8072350acf).offline);
    const hasOneTrust = (0, $d59d27fc90026e7c$export$2e2bcd8739ae039)();
    const consent = (0, $9befe8313eed890c$export$2e2bcd8739ae039)();
    const { isSettingsCallCompleted: isSettingsCallCompleted  } = (0, $013481e95ece6feb$export$2e2bcd8739ae039)();
    const getInitialData = async ()=>{
        const [output] = await Promise.all([
            (0, $cb1b605f753cb90f$export$2e2bcd8739ae039)(locale, environment)
        ]);
        setOpeningHours(output);
        setLoading(false);
    };
    const isChatOpen = (0, $hgUW1$useMemo)(()=>openingHours ? (0, $8a31e91003e0f2d7$export$2e2bcd8739ae039)(openingHours) : false, [
        openingHours
    ]);
    const { isAgentAvailable: isAgentAvailable  } = (0, $1118485e44c25ac3$export$2e2bcd8739ae039)({
        consent: consent,
        chatInformation: {
            chatConfiguration: chatConfiguration,
            openingHours: openingHours
        },
        isSettingsCallCompleted: isSettingsCallCompleted
    });
    (0, $hgUW1$useEffect)(()=>{
        if (!disabled) setStatus($e322de2051adfe14$var$getStatus(consent, isChatOpen, isSettingsCallCompleted, isLoadingSalesforceChat));
    }, [
        isAgentAvailable,
        consent,
        isChatOpen,
        isSettingsCallCompleted,
        isLoadingSalesforceChat
    ]);
    (0, $hgUW1$useEffect)(()=>{
        getInitialData();
    }, []);
    const handleClick = async ()=>{
        (0, $cfc57243d48ecb76$export$aad702b77ef29b16)(chatConfiguration?.defaultMinimizedText);
        if (!consent) // show OneTrust consent window for the functional cookies to inspect
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window?.OneTrust?.ToggleInfoDisplay();
        else if (!chatWindowOpen) {
            // trigger to open custom Salesforce chat window only when not already open
            if (isSettingsCallCompleted) {
                window?.embedded_svc?.bootstrapEmbeddedService();
                setIsLoadingSalesforceChat(true);
            } else console.error("Could not open chat window since settings call was not completed");
        }
    };
    // load salesforce scripts
    (0, $hgUW1$useEffect)(()=>{
        if (consent && isChatOpen && chatConfiguration && !window?.embedded_svc) (async ()=>{
            if (!chatConfiguration) return;
            await (0, $ef0309c2c1d33d42$export$2e2bcd8739ae039)(chatConfiguration);
        })();
    }, [
        isChatOpen,
        consent,
        chatConfiguration
    ]);
    const handleAfterMaximize = ()=>{
        setIsLoadingSalesforceChat(false);
        setChatWindowOpen(true);
    };
    const handleAfterDestroy = ()=>{
        setChatWindowOpen(false);
    };
    (0, $hgUW1$useEffect)(()=>{
        window.addEventListener("afterMaximize", handleAfterMaximize);
        window.addEventListener("afterDestroy", handleAfterDestroy);
        return ()=>{
            setIsLoadingSalesforceChat(false);
            window.removeEventListener("afterMaximize", handleAfterMaximize);
            window.removeEventListener("afterDestroy", handleAfterDestroy);
        };
    }, []);
    return(// Using chat config for getting the label and loading label for the chat button if in the future needed we can use the dictionary instead.
    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d2b84c395e40d2ab$export$b866cf1077b23cec), {
        ref: ref,
        onClick: handleClick,
        disabled: // first check if chatConfiguration forcing disabled (while other chat provider is used) then check if it is offline but has consent and then check if OneTrust is not loaded
        disabled || status === (0, $5191fc15630cefd3$export$9354cf8072350acf).offline && consent || !hasOneTrust,
        minimizedText: chatConfiguration?.defaultMinimizedText,
        loading: !!status && status === (0, $5191fc15630cefd3$export$9354cf8072350acf).loading || isLoadingSalesforceChat,
        salesforce: {
            available: !!status && status !== (0, $5191fc15630cefd3$export$9354cf8072350acf).loading,
            iconColor: // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            mergedTheme?.chatButton?.status[status]?.color
        },
        ...props
    }));
});
$e322de2051adfe14$var$SalesforceChatButton.displayName = "SalesforceChatButton";
var $e322de2051adfe14$export$2e2bcd8739ae039 = $e322de2051adfe14$var$SalesforceChatButton;







const $727dd0bb7a28c844$var$GenesysChatButton = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ setLoading: setLoading , minizedText: minizedText , ...props }, ref)=>{
    const [messages, setMessages] = (0, $hgUW1$useState)(0);
    const [disabled, setDisabled] = (0, $hgUW1$useState)(true);
    const handleClick = async ()=>{
        (0, $cfc57243d48ecb76$export$aad702b77ef29b16)("genesys_chat");
        setLoading(true);
        setDisabled(true);
        // trigger Genesys chat window directly (to show form first)
        document?.body?.dispatchEvent(new Event("supportDialog.genesys.openChat"));
    };
    // -------------- MESSAGES ----------------
    const updateMessages = (e)=>{
        if (e.detail !== undefined) setMessages(Number(e?.detail) || 0);
    };
    (0, $hgUW1$useEffect)(()=>{
        // handle direct opening of the Genesys chat window and check if a form is needed first
        document.body.addEventListener("supportDialog.genesys.messages", updateMessages, (0, $b4bcfd28199791f9$export$1c82bb05768c9ea1));
        return ()=>{
            document.body.removeEventListener("supportDialog.genesys.messages", updateMessages);
        };
    }, [
        updateMessages
    ]);
    // -------------- END MESSAGES ----------------
    // --------------------- Genesys chat button only ---------------------
    const loadingStateDone = ()=>{
        setDisabled(false);
    };
    (0, $hgUW1$useEffect)(()=>{
        // handle direct opening of the Genesys chat window and check if a form is needed first
        document.body.addEventListener("supportDialog.genesys.loading.done", loadingStateDone, (0, $b4bcfd28199791f9$export$1c82bb05768c9ea1));
        return ()=>{
            document.body.removeEventListener("supportDialog.genesys.loading.done", loadingStateDone);
        };
    }, [
        loadingStateDone
    ]);
    // --------------------- END Genesys chat button only ---------------------
    (0, $hgUW1$useEffect)(()=>{
        setLoading(false);
        setDisabled(false);
    }, []);
    return(// Using chat config for getting the label and loading label for the chat button if in the future needed we can use the dictionary instead.
    /*#__PURE__*/ (0, $hgUW1$jsx)((0, $d2b84c395e40d2ab$export$b866cf1077b23cec), {
        ref: ref,
        onClick: handleClick,
        disabled: disabled,
        minimizedText: minizedText,
        hasMessages: messages > 0,
        ...props
    }));
});
$727dd0bb7a28c844$var$GenesysChatButton.displayName = "GenesysChatButton";
var $727dd0bb7a28c844$export$2e2bcd8739ae039 = $727dd0bb7a28c844$var$GenesysChatButton;







const $68f0a1e026992fef$export$af9dc48491a7451d = /*#__PURE__*/ (0, $hgUW1$forwardRef)(({ usesGenesys: usesGenesys , ...props }, ref)=>{
    const [loading, setLoading] = (0, $hgUW1$useState)(true);
    const [loadingText, setLoadingText] = (0, $hgUW1$useState)("");
    const [currentTheme, setCurrentTheme] = (0, $hgUW1$useState)(null);
    const [useGenesys, setUseGenesys] = (0, $hgUW1$useState)(usesGenesys || false);
    const [chatConfiguration, setChatConfiguration] = (0, $hgUW1$useState)(null);
    const [forceDisabled, setForceDisabled] = (0, $hgUW1$useState)(undefined);
    const theme = (0, $hgUW1$useTheme)();
    (0, $hgUW1$useEffect)(()=>{
        // overwrite colors with styling based on the SupportDialog background: Colors.ironGrey
        theme.button.primary.states.enabled.color = (0, $hgUW1$Colors).white;
        theme.button.primary.states.enabled.backgroundColor = (0, $hgUW1$Colors).ironGrey;
        theme.button.primary.states.hover.color = (0, $hgUW1$Colors).white;
        theme.button.primary.states.hover.backgroundColor = (0, $hgUW1$blend)((0, $hgUW1$Colors).ironGrey, theme._name === (0, $hgUW1$ThemeTypes).light ? (0, $hgUW1$Colors).white : (0, $hgUW1$Colors).black, (0, $hgUW1$Opacities).low);
        theme.button.primary.states.active.color = (0, $hgUW1$Colors).white;
        theme.button.primary.states.active.backgroundColor = (0, $hgUW1$Colors).ironGrey;
        if (!useGenesys) {
            // override styling for salesforce
            theme.button.primary.states.disabled.color = (0, $hgUW1$blend)(theme.polestarApp.backgroundColor, (0, $hgUW1$Colors).white, (0, $hgUW1$Opacities).low);
            theme.button.primary.states.disabled.backgroundColor = (0, $hgUW1$blend)(theme.polestarApp.backgroundColor, (0, $hgUW1$Colors).ironGrey, (0, $hgUW1$Opacities).xLow);
        } else {
            // override styling for genesys
            const backgroundColor = (0, $hgUW1$blend)((0, $hgUW1$Colors).ironGrey, theme._name === (0, $hgUW1$ThemeTypes).light ? (0, $hgUW1$Colors).white : (0, $hgUW1$Colors).black, (0, $hgUW1$Opacities).low);
            theme.button.primary.states.disabled.color = (0, $hgUW1$blend)(backgroundColor, (0, $hgUW1$Colors).white, (0, $hgUW1$Opacities).low);
            theme.button.primary.states.disabled.backgroundColor = backgroundColor;
        }
        const mergedTheme = (0, $hgUW1$extendTheme)(theme, (0, $935194a21c37b04b$export$2e2bcd8739ae039));
        setCurrentTheme(mergedTheme);
    }, [
        useGenesys
    ]);
    const getInitialData = async ()=>{
        setLoading(true);
        const [chatConfiguration] = await Promise.all([
            (0, $ce78962a2070b423$export$2e2bcd8739ae039)(props.locale, props.environment)
        ]);
        setLoadingText(chatConfiguration?.loadingText || "");
        setChatConfiguration(chatConfiguration);
        if (usesGenesys) {
            // is a button for Genesys
            if (chatConfiguration?.genesysConfiguration !== null) setUseGenesys(true);
            else setForceDisabled(true);
        } else // is a button for Salesforce
        if (chatConfiguration?.genesysConfiguration === null) setUseGenesys(false);
        else setForceDisabled(true);
        if (usesGenesys === true && chatConfiguration?.genesysConfiguration !== null) setUseGenesys(true);
        if (chatConfiguration === undefined) // no data available so block in-page ChatButtons
        setForceDisabled(true);
        setLoading(false);
    };
    (0, $hgUW1$useEffect)(()=>{
        getInitialData();
    }, []);
    // --------------------- Genesys chat button only ---------------------
    const loadingStateDone = ()=>{
        setLoading(false);
    };
    (0, $hgUW1$useEffect)(()=>{
        // handle direct opening of the Genesys chat window and check if a form is needed first
        document.body.addEventListener("supportDialog.genesys.loading.done", loadingStateDone, (0, $b4bcfd28199791f9$export$1c82bb05768c9ea1));
        return ()=>{
            document.body.removeEventListener("supportDialog.genesys.loading.done", loadingStateDone);
        };
    }, [
        loadingStateDone
    ]);
    // --------------------- END Genesys chat button only ---------------------
    return /*#__PURE__*/ (0, $hgUW1$jsx)((0, $hgUW1$ThemeProvider), {
        theme: currentTheme || theme,
        children: loading ? /*#__PURE__*/ (0, $hgUW1$jsx)($68f0a1e026992fef$var$StyledCaption, {
            children: loadingText
        }) : usesGenesys || useGenesys ? /*#__PURE__*/ (0, $hgUW1$jsx)((0, $727dd0bb7a28c844$export$2e2bcd8739ae039), {
            ref: ref,
            setLoading: setLoading,
            minizedText: chatConfiguration?.defaultMinimizedText || undefined,
            ...props,
            disabled: forceDisabled
        }) : /*#__PURE__*/ (0, $hgUW1$jsx)((0, $e322de2051adfe14$export$2e2bcd8739ae039), {
            ref: ref,
            setLoading: setLoading,
            chatConfiguration: chatConfiguration || undefined,
            ...props,
            disabled: forceDisabled
        })
    });
});
$68f0a1e026992fef$export$af9dc48491a7451d.displayName = "ChatButton";
const $68f0a1e026992fef$var$StyledCaption = (0, $hgUW1$emotionstyled)((0, $hgUW1$Caption))`
  align-items: center;
  min-height: ${(0, $hgUW1$Spacings).xxLarge};
  user-select: none;
`;




export {$b6e745f4ad9febb0$export$37be97b52ad59ecc as SupportDialog, $68f0a1e026992fef$export$af9dc48491a7451d as ChatButton};
//# sourceMappingURL=module.js.map
